import { preparePlaylistAddition } from "./playlist-selection.js";
import { bindClaimSessionForm, claimSessionFor } from "./claim-session-form.js";
import { startClaimSession } from "./api.js";
import {projectScreenRegion,projectScreenOverlays} from "./screen-layout-projection.js";
import {projectedScrollSpeed} from "./scroll-playback-projection.js";
import { mapTransfers } from "./transfer-batch.js";
import { openDeviceSettings } from "./device-settings-panel.js";
import { getDeviceSettings, saveDeviceSettings } from "./api.js";
import { supportsMuteProfile, readCloudMute, sendCloudMuteBatch, muteStatus } from "./device-mute.js";
const deviceMuteSnapshots = new Map();
let muteAccount, muteOrganization;
import { createEditorViewState } from "./editor-view-state.js";
const editorViewState = createEditorViewState();
import {audioFields,audioError,isAudioAsset,playlistAudioReferences,validatePlaylistAudio,preparedAudioMetadata,audioDuration} from "./playlist-audio.js";
import {renderItemAudio,renderHotspotAudio,bindPlaylistAudio,audioFileAccept} from "./playlist-audio-editor.js";
import {prepareCydAudio} from "./cyd-audio.js";
import {crc32} from "./usb-device.js";
import {staticOverlaysMarkup,bindStaticOverlay,resizeStaticOverlay,validateStaticOverlays,effectiveStaticOverlays,staticOverlayFields,appendStaticOverlays,removeStaticOverlay} from "./static-overlay.js";
import {overlayError} from "./static-overlay-collection.js";
const overlaySelections = new WeakMap();
const overlayEditorsExpanded = new WeakSet();
import { prepareOverlay, overlayPreview, validateOverlayPlaylist } from "./hotspot-overlay.js";
import { trustedArtifactUrl } from "./content-url.js";
import "./styles.css";
import { initializeAuthentication, currentAccount, signIn, createAccount, signOut } from "./auth.js";
import { configureApi, warmUpApi, renameDevice, createSubgroup, updateSubgroup, deleteSubgroup, createParentGroup, updateParentGroup, deleteParentGroup, loadWorkspace, loadPirdyAccount, registerPirdyAccount, bootstrapCustomerAccount, loadPlaylist, loadWorkspaceSettingsSnapshot, updateWorkspaceSettings, loadBillingProfile, updateBillingProfile, validatePublication, publishContent, setDeviceDisplay, setGroupDisplay, setParentGroupDisplay, loadPlanCatalog, loadBilling, loadCloudEntitlement, createPlanCheckout, changePlan, createSingleChangeCheckout, createPaymentSession, downloadInvoice, registerMedia, completeMedia, registerContentSource, completeContentSource, createContentSourceDownloads, deleteMedia, createMediaDownloads, createPlaylist, updatePlaylist, deletePlaylist, registerBranding, completeBranding, removeBranding, loadSupportTickets, createSupportTicket, loadOrganizationUsers, updateOrganizationUser, loadOrganizationInvitations, inviteOrganizationUser, revokeOrganizationInvitation } from "./api.js";
import { Orientation, PlaybackMode, Direction, DeviceProfile, requireDeviceProfileId, geometryProfileIdForAsset, viewportFor, prepareArtwork, preparationPlan, prepareBranding, inspectContentSource, uploadBlob, previewPimg, createPlaylistItem, interactionTargetContentIds, movePlaylistItemWithTargets, duplicatePlaylistItemWithTargets, removePlaylistItemWithTargets, clampHotspot, hotspotBounds, transformHotspot, validateHotspots } from "./authoring.js";
import { reviewWorkspace, reviewBilling } from "./review-data.js";
import { buildFleet } from "./workspace.js";
import { customerDeviceName, customerModelName } from "./device-presentation.js";
import { MediaPreviews } from "./media-previews.js";
import { playlistCreateRecovery, playlistRecoveryScope } from "./playlist-create-recovery.js";
import { applyDisplayCommandStatuses, displayAcknowledgement, supportCategories, supportTicketPayload, validateDisplayCommand } from "./customer-parity.js";
import { confirmOrganizationInvitation, confirmOrganizationMemberUpdate, normalizeOrganizationInvitation, normalizeOrganizationMember, organizationInvitationRequest, organizationMemberUpdate, organizationRoleLabel, organizationRoleOptions, organizationRoleValue } from "./organization-settings.js";
import { createWorkspaceSettingsUpload, normalizeWorkspaceSettings, readWorkspaceSettingsSnapshot } from "./workspace-settings.js";
import { billingProfileDraft, createBillingProfileUpdate, normalizeBillingProfile } from "./billing-profile.js";
import { createBrowserLocalWorkspaceStore, createEncryptedWorkspaceBackup, downloadEncryptedWorkspaceBackup, encodeBackupAttachmentBytes, encryptedWorkspaceBackupContract, restoreEncryptedWorkspaceBackup } from "./encrypted-workspace-backup.js";
import { customerOperationError, customerVisibleErrorMessage } from "./error-presentation.js";
import { withReadDeadline } from "./read-deadline.js";
import { waitForStartupCreation } from "./startup-creation.js";
import { applyHotspotGeometry } from "./hotspot-layout.js";
import { itemPreviewPlan, SelectedItemPreview, applyItemPreviewGeometry } from "./item-preview.js";
import { openInteractionPreview, previewPlayback } from "./interaction-preview.js";
import { openAssistantComposer } from "./assistant-panel.js";
import { buildAssistantPlaylist, assistantError, validateAssistantResult } from "./assistant-draft.js";
import { createAssistantApiSession } from "./api.js";
import { savedPlaylistFingerprint, publicationDeliveryText } from "./publication-state.js";
import { createBrowserAuthoringWorkspaceStore } from "./browser-local-workspace.js";
import { createPirdyTransfer, deliverPirdyTransfer } from "./pirdy-transfer.js";
import { cloudRecheckGuidance, cloudRecheckAfterPaymentGuidance } from "./cloud-recheck-guidance.js";
import { openUsbControls } from "./usb-panel.js";
import { prepareUsbPlaylist } from "./usb-playlist.js";

import { loadCloudAccess, loadClaimedDevices, loadAccountProfile } from './api.js';
import { claimPirdy, loadHardwareOffers, startCloudTrial, reportPirdyStolen, reEnableProtectedPirdy } from './api.js';
import { customerCloudAccessPolicy, customerCloudChangePolicy } from './cloud-access.js';
import { localControlHandoffCapabilities, requestLocalControlHandoff } from './local-control-handoff.js';

const mediaPreviews = new MediaPreviews();
const selectedItemPreview = new SelectedItemPreview();
let selectedPreviewSource = null;
const localWorkspaceStore = createBrowserLocalWorkspaceStore();
const browserAuthoringWorkspaceStore = createBrowserAuthoringWorkspaceStore();
let workspaceOwner = null;

const app = document.querySelector("#app");
const reviewRequested = new URLSearchParams(location.search).get("review") === "1";
let reviewMode = false;
const workspaceResourceKeys = ["devices", "statuses", "groups", "sites", "playlists", "content", "branding"];
const routes = [
  ["home", "Home", "home"], ["content", "Content", "image"], ["playlists", "Playlists", "list"],
  ["pirdys", "Pirdys", "display"], ["publish", "Publish", "send"], ["logo", "Startup Logo", "spark"],
  ["billing", "Billing & Usage", "bill"], ["help", "Help & Support", "help"], ["settings", "Settings", "settings"],
];

const state = {
  route: location.hash.replace("#", "") || "home",
  busy: false,
  accountRequestVersion: 0,
  notice: null,
  account: null,
  pirdyAccount: null,
  accountRegistrationRequired: false,
  startupCreation: null,
  workspace: null,
  workspaceLoading: false,
  workspaceError: null,
  workspaceRequestVersion: 0,
  cloudActivationOpen: false,
  billing: null,
  planCatalog: null,
  hardwareOfferCatalog: null,
  entitlement: null,
  entitlementError: null,
  cloudAccess: null,
  cloudAccessError: null,
  claimedDevices: null,
  cloudWorkspaceAuthorization: null,
  pendingProductCode: null,
  selectedContent: new Set(),
  selectedPlaylistId: null,
  selectedPlaylist: null,
  playlistSelectionOperation: null,
  publishStep: 1,
  publishTarget: null,
  publicationValidation: null,
  publicationRequest: null,
  publicationPlaylistFingerprint: null,
  publicationReviewBinding: null,
  publicationOperation: null,
  preparedArtwork: null,
  preparedBranding: null,
  thumbnailUrls: mediaPreviews.urls,
  playlistDraft: null,
  assistantDraftJobId: null,
  selectedPlaylistItem: 0,
  drawingHotspot: false,
  hierarchyEditor: null,
  supportTickets: null,
  supportLoading: false,
  supportError: null,
  supportSubmitting: false,
  organizationMembers: null,
  organizationInvitations: null,
  organizationMembersLoading: false,
  organizationInvitationsLoading: false,
  organizationMembersError: null,
  organizationInvitationsError: null,
  organizationActionError: null,
  organizationRequestVersion: 0,
  organizationMutationVersion: 0,
  organizationBusyKind: null,
  organizationSelectedMemberId: null,
  organizationMemberDraft: null,
  organizationInviteDraft: { email: "", role: 3 },
  organizationLastInvitation: null,
  organizationConfirmation: null,
  workspaceSettingsSnapshot: null,
  workspaceSettingsDraft: null,
  workspaceSettingsLoading: false,
  workspaceSettingsSaving: false,
  workspaceSettingsError: null,
  workspaceSettingsRequestVersion: 0,
  billingProfile: null,
  billingProfileDraft: null,
  billingProfileLoading: false,
  billingProfileSaving: false,
  billingProfileError: null,
  billingProfileRequestVersion: 0,
  backupOperationVersion: 0,
  backupBusyKind: null,
  backupError: null,
  backupRecoveryKey: null,
  backupExportFileName: null,
  localWorkspace: null,
  localWorkspaceRecord: null,
  localWorkspaceStorageError: null,
  browserLocalPlaylists: new Map(),
  browserLocalStorageError: null,
};

const icons = {
  home: '<path d="M3 11.5 12 4l9 7.5v8a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"/>',
  image: '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9" r="1.5"/><path d="m4 17 5-5 4 4 2-2 5 5"/>',
  list: '<path d="M8 6h13M8 12h13M8 18h13"/><circle cx="3.5" cy="6" r=".5"/><circle cx="3.5" cy="12" r=".5"/><circle cx="3.5" cy="18" r=".5"/>',
  display: '<rect x="3" y="4" width="18" height="13" rx="2"/><path d="M8 21h8M12 17v4"/>',
  send: '<path d="m21 3-7 18-4-7-7-4zM10 14 21 3"/>',
  spark: '<path d="m12 3 1.4 4.6L18 9l-4.6 1.4L12 15l-1.4-4.6L6 9l4.6-1.4zM5 15l.8 2.2L8 18l-2.2.8L5 21l-.8-2.2L2 18l2.2-.8z"/>',
  bill: '<path d="M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6M9 16h3"/>',
  help: '<circle cx="12" cy="12" r="9"/><path d="M9.8 9a2.4 2.4 0 1 1 3.2 2.3c-.8.4-1 1-1 1.7M12 17h.01"/>',
  settings: '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.6v-.2h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1z"/>',
};

function icon(name) {
  return `<svg class="icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${icons[name]}</svg>`;
}

function escapeHtml(value) {
  return String(value ?? "").replace(/[&<>'"]/g, character => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character]);
}

function array(value) {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.items)) return value.items;
  if (Array.isArray(value?.value)) return value.value;
  return [];
}

function playlistSavedAt(playlist) {
  const value = playlist?.createdAt ?? playlist?.createdAtUtc ?? playlist?.updatedAt ?? playlist?.updatedAtUtc;
  if (!value) return "saved time unavailable";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return `saved ${String(value)}`;
  return `saved ${parsed.toLocaleString("en-IN", {
    day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit",
  })}`;
}

function title() {
  return routes.find(([id]) => id === state.route)?.[1] ?? "Home";
}

async function loadRuntimeConfiguration() {
  let lastError;
  for (let attempt = 1; attempt <= 3; attempt++) {
    try {
      const response = await fetch("/pirdy-config.json", { cache: "no-store" });
      if (response.ok) return response.json();
      if (![408, 429, 500, 502, 503, 504].includes(response.status))
        throw new Error("Pirdy web configuration is missing.");
      lastError = new Error(`Pirdy web configuration is temporarily unavailable (${response.status}).`);
    } catch (error) {
      lastError = error;
    }
    if (attempt < 3) await new Promise(resolve => globalThis.setTimeout(resolve, attempt * 400));
  }
  throw customerOperationError("pirdy_configuration_failed", lastError);
}

function consumeCompletedSignIn(account) {
  try {
    const completed = JSON.parse(sessionStorage.getItem("pirdy.signin.completed.v1") || "null");
    sessionStorage.removeItem("pirdy.signin.completed.v1");
    return Boolean(account?.homeAccountId && completed?.accountId === account.homeAccountId &&
      Number.isFinite(completed.started) && Date.now() >= completed.started && Date.now() - completed.started < 60000);
  } catch { return false; }
}

async function initialize() {
  render();
  try {
    const configuration = await loadRuntimeConfiguration();
    configureApi(configuration);
    reviewMode = reviewRequested && configuration.visualReviewEnabled === true;
    const catalogLoading = reviewMode ? null : Promise.allSettled([loadPlanCatalog(), loadHardwareOffers()]);
    state.account = reviewMode ? { name: "Pirdy Reviewer", username: "review@localhost" } : await initializeAuthentication(configuration);
    void catalogLoading?.then(([plans, hardware]) => {
      state.planCatalog = plans.status === "fulfilled" ? plans.value : null;
      state.hardwareOfferCatalog = hardware.status === "fulfilled" ? hardware.value : null;
      if (!state.account || state.route === "billing") render();
    });
    if (reviewMode) {
      state.workspace = structuredClone(reviewWorkspace);
      state.billing = structuredClone(reviewBilling);
    } else if (state.account) {
      render();
      await openSignedInPirdyAccount({ showSetup: consumeCompletedSignIn(state.account) });
      if (!state.accountRegistrationRequired && !state.cloudActivationOpen && state.workspace && state.route === "help")
        await refreshSupportTickets({ announce: false });
    }
    render();
  } catch (error) {
    renderFatal(customerVisibleErrorMessage(error,
      "Pirdy could not start. Refresh the page and try again; no account change was made."));
  }
}

async function refreshWorkspace({ announce = true } = {}) {
  const requestedAccount = state.account;
  const requestedPirdyAccountId = localControlAccountId();
  // Keep the last view for this refresh: progressive pending snapshots must not
  // erase the good resource values needed if a later read fails.
  const cachedWorkspace = state.workspace;
  const cachedOwner = workspaceOwner;
  const requestVersion = ++state.workspaceRequestVersion;
  const isCurrent = () => state.account === requestedAccount && requestVersion === state.workspaceRequestVersion;
  state.workspaceLoading = true;
  state.workspaceError = null;
  state.busy = true;
  render();
  let notice = null;
  try {
    let verifiedAccess;
    try {
      verifiedAccess = await loadCloudAccess();
    } catch (error) {
      if (!isCurrent()) return;
      if (!requestedPirdyAccountId) throw error;
      state.cloudWorkspaceAuthorization = { accountId: requestedPirdyAccountId, allowed: false };
      state.cloudAccess = null;
      state.cloudAccessError = error;
      await enterBrowserLocalWorkspace({ announce: false });
      notice = ["Cloud access could not be verified. Local Control is available; refresh when you want to try Cloud Control again.", "error"];
      return;
    }
    if (!isCurrent()) return;
    const accessPolicy = customerCloudAccessPolicy(verifiedAccess);
    if (!accessPolicy.canReadCloudWorkspace) {
      if (!requestedPirdyAccountId)
        throw new Error("Cloud Control is not active for this Pirdy account.");
      state.cloudWorkspaceAuthorization = { accountId: requestedPirdyAccountId, allowed: false };
      state.cloudAccess = verifiedAccess;
      state.cloudAccessError = null;
      await enterBrowserLocalWorkspace({ announce: false });
      notice = ["Cloud Control is not active. Your account and Local Control remain available.", "error"];
      return;
    }
    if (requestedPirdyAccountId)
      state.cloudWorkspaceAuthorization = { accountId: requestedPirdyAccountId, allowed: true };

    const applyWorkspace = workspace => {
      if (!isCurrent()) return;
      const owner = `${state.account?.homeAccountId ?? state.account?.localAccountId ?? ""}:${workspace.me?.organizationId ?? ""}`;
      const previousWorkspace = owner === cachedOwner
        && cachedWorkspace?.me?.userId === workspace.me?.userId
        && cachedWorkspace?.me?.organizationId === workspace.me?.organizationId
        ? cachedWorkspace : null;
      if (owner !== workspaceOwner) {
        state.notice = null;
        mediaPreviews.clear();selectedItemPreview.clear();selectedPreviewSource = null;state.editorArtwork = null;state.hotspotViewportPosition = {};
        state.preparedArtwork = null;
        state.preparedBranding = null;
        state.selectedPlaylistId = null;
        state.selectedPlaylist = null;
        state.playlistDraft = null; state.assistantDraftJobId = null;
        state.hierarchyEditor = null;
        state.supportTickets = null;
        state.supportLoading = false;
        state.supportError = null;
        state.supportSubmitting = false;
        resetOrganizationManagement();
        resetCustomerSettings();
        state.cloudAccess = null;
        state.cloudAccessError = null;
        state.billing = null;
        state.claimedDevices = null;
        workspaceOwner = owner;
      }
      if (previousWorkspace) {
        for (const resource of workspaceResourceKeys) {
          if (workspace[resource] !== null || !workspace.resourceErrors?.[resource] || previousWorkspace[resource] == null) continue;
          workspace[resource] = previousWorkspace[resource];
          workspace.resourceErrors[resource].usingCachedData = true;
        }
      }
      state.workspace = workspace;
      state.cloudAccess = verifiedAccess;
      state.cloudAccessError = null;
      state.cloudActivationOpen = false;
      state.busy = false;
      render();
    };
    // Quota is needed for paid changes, but must not block viewing the account.
    state.entitlement = null;
    state.entitlementError = null;
    void loadCloudEntitlement().then(value => {
      if (!isCurrent()) return;
      state.entitlement = value;state.entitlementError = null;render();
    }, error => {
      if (!isCurrent()) return;
      state.entitlement = null;state.entitlementError = error;render();
    });
    const workspace = await loadWorkspace({ onProgress: applyWorkspace });
    if (!isCurrent()) return;
    applyWorkspace(workspace);
    const playlistIds = new Set(array(state.workspace.playlists).map(playlist => String(playlist.id ?? playlist.playlistId)));
    if (state.selectedPlaylistId && !playlistIds.has(String(state.selectedPlaylistId))) {
      state.selectedPlaylistId = null;
      state.selectedPlaylist = null;
      state.playlistDraft = null; state.assistantDraftJobId = null;
      state.publishStep = 1;
      state.publishTarget = null;
    }
    if (announce) notice = Object.keys(workspace.resourceErrors ?? {}).length
      ? ["Some account data could not be refreshed. Available data is shown read-only.", "error"]
      : ["Pirdy data is up to date.", "success"];
  } catch (error) {
    if (!isCurrent()) return;
    if (error.code === "pirdy_account_not_bootstrapped") {
      resetCustomerSettings();
      state.workspace = null;
      state.cloudActivationOpen = false;
      state.workspaceError = {
        message: "The Cloud workspace is not available for this account. Your Pirdy account remains signed in, and no Cloud activation was started.",
        resource: error.resource,
        status: error.status,
      };
    } else {
      state.workspaceError = { message: customerVisibleErrorMessage(error,
        "Pirdy account data could not be loaded. Check your connection and try again."), resource: error.resource, status: error.status };
    }
  } finally {
    if (isCurrent()) {
      state.workspaceLoading = false;
      state.busy = false;
      render();
      if (state.route === "settings") {
        if (state.workspaceSettingsSnapshot === null && !state.workspaceSettingsLoading)
          void refreshWorkspaceSettings({ announce: false });
        if (hasAdministratorRole()) {
          void refreshOrganizationManagement({ announce: false });
          if (state.billingProfile === null && !state.billingProfileLoading)
            void refreshBillingProfile({ announce: false });
        }
      }
      if (notice) notify(...notice);
    }
  }
}
let assistantComposer = null;
const playlistContentSelections=new WeakMap();
function playlistSourceSelection(){
  const draft=state.playlistDraft;if(!draft)return new Set();
  if(!playlistContentSelections.has(draft))playlistContentSelections.set(draft,new Set());
  return playlistContentSelections.get(draft);
}
function ensureGlobalAssistantShell() {
  if (!state.account || reviewMode || !document.createElement || !app.append) return;
  let host = app.querySelector("[data-assistant-host]");
  if (!host) {
    const surface = app.querySelector("#main-content") ?? app.firstElementChild;
    if (!surface) return;
    const layout = document.createElement("div"), content = document.createElement("div");
    layout.className = "playlist-ai-layout global-assistant-layout"; content.className = "playlist-ai-editor";
    while (surface.firstChild) content.append(surface.firstChild);
    host = document.createElement("div"); host.dataset.assistantHost = ""; host.hidden = true;
    layout.append(content, host); surface.append(layout); surface.classList.add("playlist-ai-shell");
  }
  if (app.querySelector("[data-assistant-toggle]")) return;
  const toggle = document.createElement("button"); toggle.type = "button"; toggle.className = "button assistant-toggle";
  toggle.dataset.assistantToggle = ""; toggle.textContent = "Assistant";
  toggle.setAttribute("aria-label", "Open or collapse Pirdy Assistant");
  toggle.addEventListener("click", () => {
    if (assistantComposer?.isCurrent() && !assistantComposer.isCollapsed()) assistantComposer.collapse();
    else void openCustomerAssistant();
  });
  (app.querySelector(".top-actions") ?? app).append(toggle);
  updateAssistantToggle();
}
function updateAssistantToggle() {
  app.querySelectorAll("[data-assistant-toggle]").forEach(button => button.setAttribute("aria-expanded", String(!!assistantComposer?.isCurrent() && !assistantComposer.isCollapsed())));
}
function restoreAssistantSidebar() {
  if (!assistantComposer) return;
  const host = app.querySelector("[data-assistant-host]");
  if (!host || !assistantComposer.isCurrent()) { void assistantComposer(true); return; }
  assistantComposer.mount(host);
}
function render() {
  const scrollScope = [state.account, state.route, state.playlistDraft];
  const scrollPosition = editorViewState.capture(app, scrollScope);
  const focused = assistantComposer?.element?.contains?.(document.activeElement) ? document.activeElement : null;
  try { renderWorkspaceShell(); }
  finally {
    ensureGlobalAssistantShell(); restoreAssistantSidebar(); updateAssistantToggle();
    const item = state.playlistDraft?.items?.[state.selectedPlaylistItem];
    editorViewState.bindSections(app, item, () => item === state.playlistDraft?.items?.[state.selectedPlaylistItem]);
    if (focused?.isConnected) focused.focus({ preventScroll: true });
    editorViewState.restore(app, scrollPosition, [state.account, state.route, state.playlistDraft]);
  }
}
function renderWorkspaceShell() {
  if (!state.account && !reviewMode) {
    renderWelcome();
    return;
  }
  if (currentStartupCreation()?.outcomeUnknown && !reviewMode) {
    renderStartupCreationRecovery();
    return;
  }
  if (state.accountRegistrationRequired && !reviewMode) {
    renderAccountRegistration();
    return;
  }
  if (state.cloudActivationOpen && !reviewMode) {
    renderCloudActivation();
    return;
  }
  if (browserLocalAccountId() && !reviewMode) {
    renderAccountOnly();
    return;
  }
  app.innerHTML = `<div class="app-shell">
    <aside class="sidebar" aria-label="Pirdy navigation">
      <div class="brand"><img src="/pirdy-symbol.png" alt="" /><strong>Pirdy</strong></div>
      <nav>${routes.map(([id, label, glyph]) => `<button class="nav-item ${state.route === id ? "active" : ""}" data-route="${id}" ${state.busy ? "disabled" : ""}>${icon(glyph)}<span>${label}</span></button>`).join("")}</nav>
      <div class="sidebar-footer"><span class="avatar">${initials()}</span><span><strong>${escapeHtml(displayName())}</strong><small>${cloudSessionLabel()}</small></span></div>
    </aside>
    <section class="workspace">
      <header class="topbar"><button class="mobile-menu" aria-label="Open navigation">${icon("list")}</button><strong>${escapeHtml(title())}</strong><div class="top-actions"><span class="sync-state ${state.workspaceError || Object.keys(state.workspace?.resourceErrors ?? {}).length ? "sync-failed" : state.workspaceLoading || !state.workspace ? "sync-pending" : ""}"><i></i>${workspaceSyncLabel()}</span><button class="button quiet" data-action="refresh" ${state.busy || reviewMode ? "disabled" : ""}>Refresh</button></div></header>
      <main id="main-content" tabindex="-1">${["content", "playlists"].includes(state.route) && mediaPreviews.errors.size ? '<div class="info">Some image previews are unavailable. Your content has not been deleted. <button class="button" data-action="retry-previews">Retry previews</button></div>' : ""}${renderWorkspaceContent()}</main>
    </section>
  </div><div id="toast-region" class="toast-region" aria-live="polite">${notificationMarkup()}</div>`;
  bindShell();
  bindRoute();
  paintNotification();
}

function workspaceSyncLabel() {
  if (state.workspaceLoading) return "Loading account data…";
  if (state.workspaceError) return "Account data unavailable";
  if (Object.keys(state.workspace?.resourceErrors ?? {}).length) return "Partially synced · showing available data";
  const access = customerCloudAccessPolicy(state.cloudAccess);
  if (state.workspace && !access.canMutateCloudWorkspace)
    return access.requiresLocalRehydration ? "Cloud unavailable · restore required" : "Cloud unavailable";
  return state.workspace ? "Synced on request" : "Account data not loaded";
}

function cloudSessionLabel() {
  if (reviewMode) return "Visual review";
  if (state.workspaceError) return "Signed in · data unavailable";
  if (!state.workspace) return "Signed in";
  const access = customerCloudAccessPolicy(state.cloudAccess);
  if (access.canMutateCloudWorkspace) return "Cloud connected";
  return access.verified ? "Cloud unavailable" : "Signed in · Cloud unavailable";
}

function localControlAccountId() {
  const accountId = state.pirdyAccount?.accountId;
  return typeof accountId === "string" && accountId.trim() ? accountId.trim() : null;
}

function renderLocalControlHandoff(compact = false) {
  if (reviewMode || !localControlAccountId()) return "";
  const capability = localControlHandoffCapabilities(globalThis.navigator);
  const button = capability.canRequestAppLaunch
    ? '<button class="button primary" type="button" data-action="open-local-control">Open Pirdy Customer App</button>'
    : '<button class="button" type="button" disabled>Requires Pirdy Customer App on Windows</button>';
  return `<section class="${compact ? "info" : "card"} local-control-handoff" aria-label="Open Local Control">
    <div class="local-control-handoff-copy"><span class="eyebrow">Local Control</span><strong>Open Local Control</strong>
      <p>Connect your Pirdy with a USB data cable. Use direct controls in desktop Chrome or Edge, or open the Windows Customer App.</p></div>
    <div class="local-control-capabilities" aria-label="Local connection availability"><span><b>Local connection</b><small>${capability.transports.usb ? "USB-C is available in the Windows app" : "Open the transfer file in a compatible Pirdy app"}</small></span></div>
    <div class="local-control-handoff-actions"><button class="button primary" type="button" data-action="usb-local-control">Connect via USB in browser</button>${button}<p class="field-help" data-local-handoff-status>Choose a Pirdy and confirm before anything changes.</p></div>
  </section>`;
}

function openLocalControl() {
  const accountId = localControlAccountId();
  if (!accountId) return notify("Sign in to your Pirdy account before opening Local Control.", "error");
  try {
    requestLocalControlHandoff({
      accountId,
      currentAccountId: localControlAccountId(),
      transport: "usb",
      action: "manage",
    }, { navigator: globalThis.navigator, location: globalThis.location });
    const message = "Opening Pirdy Customer App. Sign in, choose a Pirdy, and confirm before anything changes.";
    const status = app.querySelector("[data-local-handoff-status]");
    if (status) status.textContent = message;
    notify(message, "success");
  } catch (error) {
    const message = customerVisibleErrorMessage(error,
      "Pirdy Customer App could not be requested. Open it manually on Windows; no device or Cloud action was started.");
    const status = app.querySelector("[data-local-handoff-status]");
    if (status) status.textContent = message;
    notify(message, "error");
  }
}

async function openBrowserUsbControl() {
  const accountId = localControlAccountId();
  if (!accountId) return notify("Sign in to your Pirdy account first.", "error");
  const account = state.account;
  let devices = array(isBrowserLocalWorkspace() ? state.claimedDevices : state.workspace?.devices);
  if (!devices.length && (state.pirdyAccount?.organizationId || state.workspace?.me?.organizationId)) {
    try { devices = array(await loadClaimedDevices()); }
    catch { return notify("Could not verify your linked Pirdys. Refresh the Pirdys page before opening settings.", "error"); }
    if (state.account !== account || localControlAccountId() !== accountId) return;
    state.claimedDevices = devices;
  }
  if (devices.length === 1) return openDeviceSettings({ device: devices[0], name: customerDeviceName(devices[0], state.workspace),
    accountId, currentAccountId: localControlAccountId, cloudAvailable: canAdministerCloudWorkspace() });
  if (devices.length > 1) { navigate("pirdys");return; }
  openUsbControls({ accountId, currentAccountId: localControlAccountId, claimOnly: true, onClaimPin: credential => {
    const device = app.querySelector('#activation-form [name="deviceId"]');
    const pin = app.querySelector('#activation-form [name="claimPin"]');
    if (device && pin) { device.value = credential.deviceId;pin.value = credential.pin; }
  } });
}

function renderCloudAccessNotice() {
  if (reviewMode || !state.workspace) return "";
  const access = customerCloudAccessPolicy(state.cloudAccess);
  if (!access.verified)
    return '<section class="info cloud-access-notice" role="status"><strong>Cloud access could not be verified.</strong> Cloud content, live status, remote controls, and publishing are unavailable. Your Pirdy Account, billing, support, and Local Control remain available.</section>' + renderLocalControlHandoff(true);
  if (!access.canMutateCloudWorkspace) {
    if (access.requiresLocalRehydration)
      return '<section class="info cloud-access-notice" role="status"><strong>Cloud workspace restoration is required.</strong> Cloud content, live status, remote controls, and publishing remain unavailable until Cloud Control is active and the latest verified local workspace is restored. Your account, billing, support, Local Control, and current Pirdy playback remain available. <button class="button" data-route="billing">Review billing</button></section>' + renderLocalControlHandoff(true);
    return '<section class="info cloud-access-notice" role="status"><strong>Cloud Control is inactive.</strong> Cloud content, live status, remote controls, and publishing are unavailable until renewal. Your account, billing, support, Local Control, locally stored content, and current Pirdy playback remain available. <button class="button" data-route="billing">Review billing</button></section>' + renderLocalControlHandoff(true);
  }
  const change = customerCloudChangePolicy(state.entitlement);
  if (change.exhausted)
    return '<section class="info cloud-access-notice" role="status"><strong>Monthly Cloud changes are used.</strong> Only publishing and startup-logo changes need a Single Change or renewal. Account reads, Content and playlist management, Pirdy status, display control, and support remain available. <button class="button" data-route="billing">View options</button></section>';
  return "";
}

function renderWorkspaceContent() {
  const error = state.workspaceError;
  const notice = error ? `<section class="card account-data-error" role="alert"><h2>${state.workspace ? "Could not refresh account data" : "Could not load account data"}</h2><p>${state.workspace ? "Showing the last successfully loaded data. Changes are unavailable until a refresh succeeds." : "Your Pirdys and content have not been reported as missing. Their account data could not be loaded."}</p><p>${escapeHtml(error.message)}</p><button class="button" data-action="refresh" ${state.workspaceLoading ? "disabled" : ""}>Try again</button></section>` : "";
  if (!state.workspace) return notice || '<section class="empty" role="status"><h2>Loading your account</h2><p>Your Pirdys and content will appear after the account data is received.</p></section>';
  const resourceErrors = Object.values(state.workspace.resourceErrors ?? {});
  const nonMediaErrors = resourceErrors.filter(item => item.resource !== "/v1/media");
  const partialNotice = nonMediaErrors.length ? `<section class="card account-data-error" role="alert"><h2>Some account data is unavailable</h2><p>${escapeHtml(nonMediaErrors.map(item => item.message).join(" "))}</p><p>${nonMediaErrors.some(item => item.usingCachedData) ? "Previously loaded information is shown where available. " : ""}Changes are paused until every required resource has refreshed.</p><button class="button" data-action="refresh" ${state.workspaceLoading ? "disabled" : ""}>Try again</button></section>` : "";
  const mediaError = state.workspace.resourceErrors?.content;
  const mediaNotice = mediaError ? `<section class="card account-data-error" role="alert"><h2>Content library unavailable</h2><p>${escapeHtml(mediaError.message)}</p><p>Your Pirdys and groups are still available. Content editing and publishing are paused until the library can be loaded.</p><button class="button" data-action="refresh" ${state.workspaceLoading ? "disabled" : ""}>Try again</button></section>` : "";
  const required = {
    content: ["content"], playlists: ["playlists", "content"], pirdys: ["devices", "statuses", "groups", "sites"],
    publish: ["devices", "groups", "sites", "playlists", "content"], logo: ["devices", "branding"],
  }[state.route] ?? [];
  const routeBlocked = required.some(resource => state.workspace.resourceErrors?.[resource] && state.workspace[resource] == null);
  if (required.some(resource => state.workspace.pendingResources?.includes(resource) && state.workspace[resource] == null))
    return notice + partialNotice + mediaNotice + '<section class="empty" role="status"><h2>Loading this page</h2><p>Available account information is already shown. This page will update automatically.</p></section>';
  const blocked = routeBlocked ? '<section class="empty" role="status"><h2>This page could not be refreshed</h2><p>Try again to load the required account data. Nothing has been removed.</p></section>' : "";
  return notice + renderCloudAccessNotice() + partialNotice + mediaNotice + (routeBlocked ? blocked : renderRoute());
}

function renderAccountRegistration() {
  const email = state.account?.username ?? "this sign-in";
  app.innerHTML = `<main class="activation-shell"><section class="activation-card">
    <img src="/pirdy-header.png" alt="Pirdy" />
    <span class="eyebrow">Free Pirdy account</span>
    <h1>Create your Pirdy account</h1>
    <p>No Pirdy account is registered for <strong>${escapeHtml(email)}</strong>. Creating one does not create an organization, start a subscription, claim a device, or upload local content.</p>
    <p>Local Control remains free and offline-capable on previously trusted devices. Content you create locally remains device-local unless Cloud Control is active.</p>
    <section class="info"><strong>Need a Pirdy?</strong> ${hardwarePriceSummary()} You can continue account setup now and connect a purchased Pirdy later from any Pirdy app.</section>
    <div id="registration-error" class="form-error" role="alert"></div>
    <div class="actions"><button class="button" data-action="registration-signout">Use another sign-in</button><button class="button primary" data-action="register-account">Create free account</button></div>
  </section></main>`;
  app.querySelector('[data-action="register-account"]').addEventListener("click", registerCurrentPirdyAccount);
  app.querySelector('[data-action="registration-signout"]').addEventListener("click", async () => {
    await signOut();
    resetCustomerSettings();
    state.account = null;
    state.pirdyAccount = null;
    state.accountRegistrationRequired = false;
    state.cloudActivationOpen = false;
    render();
  });
}

function browserLocalAccountId() {
  const accountId = localControlAccountId();
  if (!accountId) return null;
  const projectedCloudCandidate = Boolean(state.pirdyAccount?.organizationId) &&
    ["Trial", "Active", "Grace"].includes(state.pirdyAccount?.cloudControlState) &&
    state.pirdyAccount?.cloudDataAvailability === "Active";
  const checkedAuthorization = state.cloudWorkspaceAuthorization?.accountId === accountId
    ? state.cloudWorkspaceAuthorization.allowed
    : null;
  return projectedCloudCandidate && checkedAuthorization !== false ? null : accountId;
}

function isBrowserLocalWorkspace() {
  const accountId = browserLocalAccountId();
  return Boolean(accountId && state.workspace?.browserLocal === true &&
    state.workspace.accountId === accountId);
}

function applyBrowserLocalWorkspace(snapshot) {
  const accountId = browserLocalAccountId();
  if (!accountId || snapshot?.accountId !== accountId)
    throw new Error("The browser-local workspace account changed before it loaded.");
  mediaPreviews.clear();selectedItemPreview.clear();selectedPreviewSource = null;state.editorArtwork = null;state.hotspotViewportPosition = {};
  for (const asset of snapshot.assets)
    state.thumbnailUrls.set(String(asset.assetId), asset.thumbnail);
  state.browserLocalPlaylists = new Map(snapshot.playlists.map(playlist =>
    [String(playlist.id), structuredClone(playlist)]));
  state.workspace = {
    browserLocal: true,
    accountId,
    revision: snapshot.revision,
    me: {
      ...(state.accountProfile??{}),
      userId: accountId,
      organizationId: null,
      role: state.accountProfile?.role??"ContentManager",
      displayName: state.accountProfile?.displayName ?? state.pirdyAccount?.displayName ??
        state.account?.name ?? state.account?.username ?? "Pirdy user",
    },
    devices: [], statuses: [], groups: [], sites: [], branding: null,
    resourceErrors: {},
    content: snapshot.assets.map(({ bytes, thumbnail, mediaType, byteLength, ...asset }) => ({
      ...asset,
      sourceContentType: mediaType,
      sourceSha256: asset.sha256,
      fileSize: byteLength,
    })),
    playlists: snapshot.playlists.map(playlist => ({
      id: playlist.id,
      name: playlist.name,
      version: playlist.version,
      itemCount: playlist.items.length,
      createdAtUtc: playlist.createdAtUtc,
      updatedAtUtc: playlist.updatedAtUtc,
    })),
  };
  state.workspaceError = null;
  state.workspaceLoading = false;
  state.browserLocalStorageError = null;
}

function clearBrowserLocalWorkspaceView() {
  state.claimedDevices = null;state.claimedDevicesAccountId = null;
  browserAuthoringWorkspaceStore.close?.();
  mediaPreviews.clear();selectedItemPreview.clear();selectedPreviewSource = null;state.editorArtwork = null;state.hotspotViewportPosition = {};
  state.browserLocalPlaylists = new Map();
  state.browserLocalStorageError = null;
}

function rememberBrowserLocalFailure(error) {
  if (["browser_local_corrupt", "browser_local_account_mismatch",
       "browser_local_unavailable"].includes(error?.code))
    state.browserLocalStorageError = customerVisibleErrorMessage(error,
      "Browser-local Pirdy storage is unavailable. Existing content was not changed.");
}

async function refreshBrowserLocalWorkspace({ announce = true } = {}) {
  const account = state.account;
  const accountId = browserLocalAccountId();
  if (!accountId) return;
  state.workspaceLoading = true;
  render();
  try {
    const snapshot = await withReadDeadline(() => browserAuthoringWorkspaceStore.open(accountId));
    if (state.account !== account || browserLocalAccountId() !== accountId) return;
    applyBrowserLocalWorkspace(snapshot);
    void refreshLocalLinkedPirdys(account, accountId);
    if (announce) notify("Browser-local content is up to date.", "success");
  } catch (error) {
    if (state.account !== account || browserLocalAccountId() !== accountId) return;
    rememberBrowserLocalFailure(error);
    state.workspaceLoading = false;
    if (!state.workspace)
      state.workspaceError = { message: customerVisibleErrorMessage(error,
        "Browser-local content could not be opened. Existing storage was not changed.") };
    if (announce) notify(customerVisibleErrorMessage(error,
      "Browser-local content could not be opened. Existing storage was not changed."), "error");
  } finally {
    if (state.account === account && browserLocalAccountId() === accountId) render();
  }
}

async function enterBrowserLocalWorkspace({ announce = false } = {}) {
  resetCustomerSettings();
  resetOrganizationManagement();
  clearBrowserLocalWorkspaceView();
  state.workspace = null;
  state.workspaceError = null;
  state.workspaceLoading = false;
  state.billing = null;
  state.entitlement = null;
  state.entitlementError = null;
  state.cloudAccess = null;
  state.cloudAccessError = null;
  state.claimedDevices = null;
  state.selectedPlaylistId = null;
  state.selectedPlaylist = null;
  state.playlistDraft = null; state.assistantDraftJobId = null;
  state.preparedArtwork = null;
  workspaceOwner = null;
  await refreshBrowserLocalWorkspace({ announce });
}

async function refreshSignedInAccount() {
  if (reviewMode || !state.account || state.busy) return;
  const account = state.account;
  try {
    const projection = await loadPirdyAccount();
    if (state.account !== account) return;
    const wasLocal = Boolean(browserLocalAccountId());
    state.pirdyAccount = projection;
    state.cloudWorkspaceAuthorization = null;
    if (browserLocalAccountId()) {
      if (!wasLocal || !isBrowserLocalWorkspace())
        await enterBrowserLocalWorkspace({ announce: true });
      else await refreshBrowserLocalWorkspace({ announce: true });
      if (state.account === account && state.route === "billing" &&
          state.pirdyAccount?.organizationId)
        await refreshBilling({ announce: false });
      return;
    }
    clearBrowserLocalWorkspaceView();
    await refreshWorkspace({ announce: true });
  } catch (error) {
    if (state.account === account)
      notify(customerVisibleErrorMessage(error,
        "Your Pirdy Account could not be refreshed. Existing local content was not changed."), "error");
  }
}

function renderAccountOnly() {
  const linkedCloudAccount = Boolean(state.pirdyAccount?.organizationId);
  const localRoutes = routes;
  if (!localRoutes.some(([id]) => id === state.route)) state.route = "home";
  const failure = state.browserLocalStorageError ?? state.workspaceError?.message;
  const body = state.route === "billing" ? renderBilling()
    : state.route === "help" ? renderHelp()
      : !isBrowserLocalWorkspace()
        ? state.workspaceLoading
          ? "<section class='empty' role='status'><h2>Opening your local content</h2><p>Your workspace will appear automatically.</p></section>"
          : "<section class='empty' role='status'><h2>Browser-local content is unavailable</h2><p>Existing local storage was not changed. Refresh after browser storage is available.</p></section>"
        : state.route === "content" ? renderContent()
          : state.route === "playlists" ? renderPlaylists()
            : state.route === "pirdys" ? renderPirdys()
              : state.route === "publish" ? renderBrowserLocalPublish()
                : state.route === "logo" ? renderLogo()
                  : state.route === "settings" ? renderSettings()
                    : renderBrowserLocalHome();
  app.innerHTML = `<div class="app-shell browser-local-shell">
    <aside class="sidebar" aria-label="Pirdy navigation">
      <div class="brand"><img src="/pirdy-symbol.png" alt= ""/><strong>Pirdy</strong></div>
      <nav>${localRoutes.map(([id,label,glyph]) => `<button class="nav-item ${state.route === id ? "active" : ""}" data-route="${id}" ${state.busy ? "disabled" : ""}>${icon(glyph)}<span>${label}</span></button>`).join("")}</nav>
      <div class="sidebar-footer"><span class="avatar">${initials()}</span><span><strong>${escapeHtml(displayName())}</strong><small>Local Control</small></span></div>
    </aside>
    <section class="workspace">
      <header class="topbar"><button class="mobile-menu" aria-label="Open navigation">${icon("list")}</button><strong>${escapeHtml(title())}</strong><div class="top-actions"><span class="sync-state ${failure ? "sync-failed" : state.workspaceLoading ? "sync-pending" : ""}"><i></i>${failure ? "Local storage unavailable" : state.workspaceLoading ? "Loading local content…" : "Saved in this browser"}</span><button class="button quiet" data-action="refresh" ${state.busy ? "disabled" : ""}>Refresh</button>${linkedCloudAccount ? '<button class="button primary" data-route="billing">Review Cloud Control</button>' : '<button class="button primary" data-action="start-cloud-activation">Claim Pirdy / Enable Cloud Control</button>'}</div></header>
      <main id="main-content" tabindex="-1">${failure ? `<section class="card account-data-error" role="alert"><h2>Browser-local storage needs attention</h2><p>${escapeHtml(failure)} Existing content was not replaced.</p></section>` : ""}${body}</main>
    </section>
  </div><div id="toast-region" class="toast-region" aria-live="polite">${notificationMarkup()}</div>`;
  app.querySelector('[data-action="start-cloud-activation"]')?.addEventListener("click", () => {
    state.cloudActivationOpen = true;
    render();
  });
  app.querySelector('[data-action="open-local-control"]')?.addEventListener("click", openLocalControl);
  app.querySelector('[data-action="account-only-signout"]')?.addEventListener("click", async () => {
    await signOut();
    resetCustomerSettings();
    state.account = null;
    state.pirdyAccount = null;
    state.accountRegistrationRequired = false;
    state.cloudActivationOpen = false;
    state.workspace = null;
    state.pendingProductCode = null;
    clearBrowserLocalWorkspaceView();
    render();
  });
  bindShell();
  bindRoute();
  paintNotification();
}

function renderBrowserLocalHome() {
  const contentCount = libraryContent().length;
  const playlistCount = array(state.workspace?.playlists).length;
  const linkedCloudAccount = Boolean(state.pirdyAccount?.organizationId);
  return `${pageHeading(`Welcome back, ${escapeHtml(firstName())}`, "Create something new or check what’s playing.", '<div class="actions"><button class="button" data-route="content">Import content</button><button class="button" data-route="pirdys">Add Pirdy</button><button class="button primary" data-route="publish">Publish</button></div>')}
    <section class="stat-grid"><article class="stat"><strong>${state.claimedDevicesAccountId===browserLocalAccountId()?currentLinkedPirdys().length:'—'}</strong><span>Pirdys</span></article><article class="stat"><strong>${contentCount}</strong><span>content items</span></article><article class="stat"><strong>${playlistCount}</strong><span>playlists</span></article></section>
    <section><h2>Your Pirdys</h2>${renderLocalLinkedPirdyCards()}</section>
    <p class="field-help">Content and playlists are saved in this browser under your Pirdy Account. Signing in does not upload them or activate Cloud Control. USB transfers do not need a subscription.</p>
    ${renderLocalControlHandoff(true)}
    <p class="field-help">${linkedCloudAccount ? "Cloud Control is paused. Review Billing & Usage for remote access." : "Cloud Control is optional and can be enabled separately."}</p>`;
}

function renderCloudActivation() {
  const email = state.account?.username ?? "";
  app.innerHTML = `<main class="activation-shell"><section class="activation-card">
    <img src="/pirdy-header.png" alt="Pirdy" />
    <span class="eyebrow">Optional Cloud Control</span>
    <h1>Connect your purchased Pirdy</h1>
    <p>Your free Pirdy account is ready. Local Control stays free for life. To add Cloud Control, enter the temporary PIN shown by a genuine unclaimed Pirdy. After claiming, the account is eligible to start its one-time 7-day Cloud trial, with no payment method and no automatic charge.</p>
    <section class="info"><strong>Need a device?</strong> ${hardwarePriceSummary()} Hardware ordering never starts a Cloud subscription.</section>
    <form id="activation-form">
      <fieldset><legend>Pirdy proof</legend><div class="form-grid">
        <label>Device ID<input name="deviceId" required maxlength="32" pattern="PIRDY-[0-9]{8}(-[0-9]{2,17})?" placeholder="PIRDY-20261023-01" autocomplete="off" /></label>
        <label>Temporary claim PIN<input name="claimPin" required maxlength="6" minlength="6" inputmode="numeric" pattern="[0-9]{6}" placeholder="6 digits" autocomplete="one-time-code" /></label>
      </div><p class="field-help">Start registration here, then tap Add an Account on the Wi-Fi-connected Pirdy. USB discovery reads the same active PIN.</p></fieldset>
      <fieldset><legend>Billing contact</legend><div class="form-grid">
        <label>Account type<select name="accountType"><option value="Individual">Individual</option><option value="Business">Business</option></select></label>
        <label>Billing name<input name="billingName" required maxlength="256" autocomplete="name" /></label>
        <label>Billing email<input name="billingEmail" required maxlength="320" type="email" value="${escapeHtml(email)}" autocomplete="email" /></label>
        <label>Phone (optional)<input name="billingPhone" maxlength="32" autocomplete="tel" /></label>
        <label class="span-two">Address line 1<input name="addressLine1" required maxlength="256" autocomplete="address-line1" /></label>
        <label class="span-two">Address line 2 (optional)<input name="addressLine2" maxlength="256" autocomplete="address-line2" /></label>
        <label>City<input name="city" required maxlength="128" autocomplete="address-level2" /></label>
        <label>State / province<input name="stateOrProvince" required maxlength="128" autocomplete="address-level1" /></label>
        <label>Postal code<input name="postalCode" required maxlength="32" autocomplete="postal-code" /></label>
        <label>Country code<input name="countryCode" required maxlength="2" value="IN" pattern="[A-Za-z]{2}" autocomplete="country" /></label>
        <label>GST state code<input name="taxRegionCode" required maxlength="2" inputmode="numeric" pattern="[0-9]{2}" placeholder="e.g. 07" /></label>
        <label>GSTIN (optional)<input name="gstin" maxlength="15" autocomplete="off" /></label>
      </div>
      <label class="confirmation"><input name="confirmed" type="checkbox" required /> <span>I confirm that these billing details are accurate. GSTIN is optional for buyers who do not have one.</span></label></fieldset>
      <div id="activation-error" class="form-error" role="alert"></div>
      <div class="actions"><button class="button" type="button" data-action="usb-local-control">Connect via USB in browser</button><button class="button" type="button" data-action="activation-signout">Use another sign-in</button><button class="button" type="button" data-action="cancel-cloud-activation">Not now — use Local Control</button><button class="button primary" type="submit">Connect Pirdy for Cloud Control</button></div>
    </form>
  </section></main>`;
  bindClaimSessionForm(app.querySelector("#activation-form"), {start: startClaimSession, account: () => state.account, pinName: "claimPin", enabled: !reviewMode});
  app.querySelector("#activation-form").addEventListener("submit", activateCloudAccount);
  app.querySelector('[data-action="usb-local-control"]').addEventListener("click", openBrowserUsbControl);
  const country = app.querySelector('[name="countryCode"]');
  const taxRegion = app.querySelector('[name="taxRegionCode"]');
  const gstin = app.querySelector('[name="gstin"]');
  const applyTaxRegionRules = () => {
    const india = country.value.trim().toUpperCase() === "IN";
    taxRegion.required = india;
    taxRegion.disabled = !india;
    gstin.disabled = !india;
    if (!india) {
      taxRegion.value = "";
      gstin.value = "";
    }
  };
  country.addEventListener("input", applyTaxRegionRules);
  applyTaxRegionRules();
  app.querySelector('[data-action="cancel-cloud-activation"]').addEventListener("click", continueLocalAfterSetup);
  app.querySelector('[data-action="activation-signout"]').addEventListener("click", async () => {
    await signOut();
    resetCustomerSettings();
    state.account = null;
    state.pirdyAccount = null;
    state.accountRegistrationRequired = false;
    state.cloudActivationOpen = false;
    state.pendingProductCode = null;
    render();
  });
}

async function continueLocalAfterSetup() {
  state.cloudActivationOpen = false;
  await enterBrowserLocalWorkspace({ announce: false });
}

function currentStartupCreation() {
  return state.startupCreation?.account === state.account ? state.startupCreation : null;
}

function beginStartupCreation(kind) {
  if (!state.account || currentStartupCreation()) return null;
  const attempt = { account: state.account, kind, outcomeUnknown: false, checking: false, lateSettled: false };
  state.startupCreation = attempt;
  return attempt;
}

function startupCreationIsCurrent(attempt) {
  return state.account === attempt.account && state.startupCreation === attempt;
}

function markStartupCreationUnknown(attempt) {
  if (!startupCreationIsCurrent(attempt)) return;
  attempt.outcomeUnknown = true;
  state.busy = false;
  state.workspaceLoading = false;
  render();
  if (attempt.lateSettled) reconcileLateStartupCreation(attempt);
}

function reconcileLateStartupCreation(attempt) {
  if (!startupCreationIsCurrent(attempt)) return;
  attempt.lateSettled = true;
  if (!attempt.outcomeUnknown || attempt.checking || attempt.lateReadStarted) return;
  attempt.lateReadStarted = true;
  void checkStartupCreation(attempt);
}

function renderStartupCreationRecovery() {
  const attempt = currentStartupCreation();
  if (!attempt) return;
  app.innerHTML = `<main class="activation-shell"><section class="activation-card">
    <img src="/pirdy-header.png" alt="Pirdy" /><span class="eyebrow">Account setup</span>
    <h1>Setup is not yet confirmed</h1>
    <p>${escapeHtml(customerOperationError("pirdy_startup_outcome_unknown").message)}</p>
    <p>Checking only reads this signed-in account. It does not repeat account creation, claim a device again, or start a payment.</p>
    ${attempt.message ? `<p class="form-error" role="status">${escapeHtml(attempt.message)}</p>` : ""}
    <div class="actions"><button class="button" data-action="setup-signout">Use another sign-in</button>
    <button class="button primary" data-action="check-account-setup" ${attempt.checking ? "disabled" : ""}>${attempt.checking ? "Checking account..." : "Check account"}</button></div>
  </section></main>`;
  app.querySelector('[data-action="check-account-setup"]')?.addEventListener("click", () => checkStartupCreation(attempt));
  app.querySelector('[data-action="setup-signout"]')?.addEventListener("click", async () => {
    if (!startupCreationIsCurrent(attempt)) return;
    try {
      await signOut();
      if (!startupCreationIsCurrent(attempt)) return;
      mediaPreviews.clear();selectedItemPreview.clear();selectedPreviewSource = null;state.editorArtwork = null;state.hotspotViewportPosition = {};
      workspaceOwner = null;
      resetCustomerSettings();
      resetOrganizationManagement();
      clearBrowserLocalWorkspaceView();
      state.startupCreation = null;
      state.account = null;
      state.pirdyAccount = null;
      state.workspace = null;
      state.billing = null;
      state.entitlement = null;
      state.cloudAccess = null;
      state.claimedDevices = null;
      state.pendingProductCode = null;
      state.accountRegistrationRequired = false;
      state.cloudActivationOpen = false;
      render();
    } catch {
      if (startupCreationIsCurrent(attempt)) {
        attempt.message = "Sign-out could not be confirmed. You can still check this account safely.";
        render();
      }
    }
  });
}

async function checkStartupCreation(attempt = currentStartupCreation()) {
  if (!attempt || !startupCreationIsCurrent(attempt) || attempt.checking) return;
  attempt.checking = true;
  attempt.message = null;
  render();
  try {
    const projection = await loadPirdyAccount();
    if (!startupCreationIsCurrent(attempt)) return;
    if (attempt.kind === "bootstrap" && !projection.organizationId) {
      attempt.message = "The Cloud workspace is not confirmed yet. The original request may still be processing. Check again later; do not resubmit it.";
      return;
    }
    state.startupCreation = null;
    state.pirdyAccount = projection;
    state.accountRegistrationRequired = false;
    state.cloudActivationOpen = false;
    state.cloudWorkspaceAuthorization = null;
    state.workspaceError = null;
    render();
    if (browserLocalAccountId()) await enterBrowserLocalWorkspace({ announce: false });
    else await refreshWorkspace({ announce: false });
  } catch {
    if (!startupCreationIsCurrent(attempt)) return;
    attempt.message = "Setup could not be confirmed yet. The original request may still have completed. Check your connection and check this account again; no new setup request was sent.";
  } finally {
    if (startupCreationIsCurrent(attempt)) {
      attempt.checking = false;
      render();
      if (attempt.lateSettled) reconcileLateStartupCreation(attempt);
    }
  }
}

async function activateCloudAccount(event) {
  event.preventDefault();
  const form = event.currentTarget;
  if (!form.reportValidity()) return;
  const attempt = beginStartupCreation("bootstrap");
  if (!attempt) return;
  const submit = form.querySelector('[type="submit"]');
  const error = form.querySelector("#activation-error");
  submit.disabled = true;
  error.textContent = "";
  const data = new FormData(form);
  const optional = name => String(data.get(name) ?? "").trim() || null;
  const account = state.account;
  let creationConfirmed = false;
  try {
    await waitForStartupCreation(() => bootstrapCustomerAccount({
      contractVersion: 2,
      deviceId: String(data.get("deviceId") ?? "").trim().toUpperCase(),
      claimPin: String(data.get("claimPin") ?? "").trim(),
      sessionId: claimSessionFor(form, account),
      billingProfile: {
        accountType: String(data.get("accountType")),
        billingName: String(data.get("billingName") ?? "").trim(),
        billingEmail: String(data.get("billingEmail") ?? "").trim(),
        billingPhone: optional("billingPhone"),
        addressLine1: String(data.get("addressLine1") ?? "").trim(),
        addressLine2: optional("addressLine2"),
        city: String(data.get("city") ?? "").trim(),
        stateOrProvince: String(data.get("stateOrProvince") ?? "").trim(),
        postalCode: String(data.get("postalCode") ?? "").trim(),
        countryCode: String(data.get("countryCode") ?? "").trim().toUpperCase(),
        taxRegionCode: optional("taxRegionCode"),
        gstin: optional("gstin"),
        detailsConfirmedByAccountCreator: data.get("confirmed") === "on",
      },
    }), { onLateSettlement: () => reconcileLateStartupCreation(attempt) });
    if (state.account !== account) return;
    creationConfirmed = true;
    const activatedAccount = await loadPirdyAccount();
    if (state.account !== account) return;
    if (!activatedAccount.organizationId)
      throw new Error("Cloud activation was not confirmed. Your free Pirdy account remains signed in, and no Cloud workspace was opened.");
    state.pirdyAccount = activatedAccount;
    state.startupCreation = null;
    state.cloudWorkspaceAuthorization = null;
    state.cloudActivationOpen = false;
    render();
    await refreshWorkspace({ announce: false });
    if (state.account !== account) return;
    await resumePendingCheckout();
    if (state.account !== account) return;
    notify("The Pirdy was added to your account. Cloud publishing starts only when Cloud Control access is active.", "success");
  } catch (failure) {
    if (state.account !== account) return;
    if (failure.code === "pirdy_startup_outcome_unknown" || creationConfirmed) {
      markStartupCreationUnknown(attempt);
      return;
    }
    if (state.startupCreation === attempt) state.startupCreation = null;
    error.textContent = customerVisibleErrorMessage(failure,
      "Cloud activation could not be completed. Check the Pirdy ID, claim PIN, and billing details, then try again; no Cloud workspace was opened.");
    submit.disabled = false;
  }
}
function renderWelcome() {
  const changePass = planCatalog()?.singleChangePass;
  const changePassMarkup = changePass
    ? `<span>INR ${escapeHtml(changePass.basePrice?.amount)} plus applicable tax. A purchased change remains available until used.</span><button class="button" data-public-product="${escapeHtml(changePass.code)}">Choose one change</button>`
    : '<span>Current published price is temporarily unavailable. Refresh before choosing a Single Change Pass.</span>';
  app.innerHTML = `<div class="landing-shell">
    <header class="landing-nav">
      <a class="landing-brand" href="#top" aria-label="Pirdy home"><img src="/pirdy-symbol.png" alt="" /><strong>Pirdy</strong></a>
      <nav aria-label="Public navigation"><a href="#product">Product</a><a href="#integrations">Integrations</a><a href="#workflow">How it works</a><a href="#cloud">Local & Cloud</a><a href="#pricing">Plans</a><a href="/marketplace.html">Marketplace</a></nav>
      <div class="actions"><button class="button" data-action="signin">Sign in</button><button class="button primary" data-action="create-account">Create account</button></div>
    </header>
    <main id="main-content" class="landing-main">
      <section class="landing-hero" id="top">
        <div class="hero-copy"><span class="eyebrow">Programmable Interactive Retail Display</span><h1>Small screen. A world of possibilities.</h1><p>Pirdy is a compact touchscreen you fill with your own content. Show products, share information or bring memories to life—on a shelf, in furniture or built into a wall.</p><div class="hero-actions"><button class="button primary hero-button" data-action="create-account">Create free account</button><button class="button" data-action="signin">Open Pirdy</button><a class="button" href="#product">Explore the product</a></div><p class="fine-print">Update by USB without a subscription. Add Cloud Control to manage your screens from anywhere.</p><div id="welcome-status" class="form-status" role="status" aria-live="polite"></div><div id="welcome-error" class="form-error" role="alert"></div></div>
        <figure class="integration-hero">
          <img src="/integrations/retail-1440.webp" srcset="/integrations/retail-720.webp 720w, /integrations/retail-1440.webp 1440w" sizes="(max-width: 700px) calc(100vw - 32px), (max-width: 1000px) calc(100vw - 48px), 620px" width="1440" height="810" alt="Integration concept: a compact Pirdy display built into a stone product plinth" loading="eager" decoding="async" fetchpriority="high" />
          <figcaption><span>Built into your world</span>Retail display integration concept</figcaption>
        </figure>
      </section>
      <section class="landing-proof" aria-label="Pirdy capabilities"><article><strong>Local first</strong><span>Your content. USB updates. No subscription.</span></article><article><strong>Cloud when ready</strong><span>Manage connected screens from anywhere.</span></article><article><strong>Designed for touch</strong><span>Let people tap to explore more.</span></article></section>
      <section class="landing-section" id="product"><div class="section-kicker">What you can do</div><h2>Show it. Scroll it. Make it interactive.</h2><div class="feature-grid"><article><span class="feature-number">01</span><h3>Show your content</h3><p>Turn images into playlists for products, menus, information or personal memories.</p></article><article><span class="feature-number">02</span><h3>Keep the story moving</h3><p>Show a full image or scroll through longer artwork—up, down, left or right.</p></article><article><span class="feature-number">03</span><h3>Add a touch</h3><p>Add tappable buttons to open another item or play audio.</p></article></div></section>
      <section class="landing-section integrations-section" id="integrations" aria-labelledby="integration-heading">
        <div class="section-kicker">Imagine the integration</div><h2 id="integration-heading">Design the setting. Make Pirdy part of it.</h2>
        <p class="integration-intro">On a counter, within a shelf or built into wall cladding. Give Pirdy a home that suits your space.</p>
        <div class="integration-grid">
          <figure><img src="/integrations/reception-1440.webp" srcset="/integrations/reception-720.webp 720w, /integrations/reception-1440.webp 1440w" sizes="(max-width: 700px) calc(100vw - 32px), (max-width: 1000px) calc(100vw - 48px), 620px" width="1440" height="810" alt="Concept of a small display integrated into a hotel reception counter" loading="lazy" decoding="async" /><figcaption><span class="section-kicker">Hospitality &amp; workspaces</span><h3>A welcome built into the counter.</h3><p>Guest information and interactive menus, right where people need them.</p></figcaption></figure>
          <figure><img src="/integrations/wall-collage-1440.webp" srcset="/integrations/wall-collage-720.webp 720w, /integrations/wall-collage-1440.webp 1440w" sizes="(max-width: 700px) calc(100vw - 32px), (max-width: 1000px) calc(100vw - 48px), 620px" width="1440" height="810" alt="Concept of multiple portrait and landscape screens recessed into residential wall cladding" loading="lazy" decoding="async" /><figcaption><span class="section-kicker">Personal spaces</span><h3>Your memories, part of the architecture.</h3><p>Mix portrait and landscape displays for a changing wall of personal memories.</p></figcaption></figure>
          <figure><img src="/integrations/retail-1440.webp" srcset="/integrations/retail-720.webp 720w, /integrations/retail-1440.webp 1440w" sizes="(max-width: 700px) calc(100vw - 32px), (max-width: 1000px) calc(100vw - 48px), 620px" width="1440" height="810" alt="Concept of a display fitted beneath a product on a retail plinth" loading="lazy" decoding="async" /><figcaption><span class="section-kicker">Retail &amp; product displays</span><h3>Put the story beside the product.</h3><p>Give each product its own screen, scrolling story and touch interaction.</p></figcaption></figure>
          <figure><img src="/integrations/enclosures-1440.webp" srcset="/integrations/enclosures-720.webp 720w, /integrations/enclosures-1440.webp 1440w" sizes="(max-width: 700px) calc(100vw - 32px), (max-width: 1000px) calc(100vw - 48px), 620px" width="1440" height="810" alt="Five illustrative Pirdy enclosure designs in wood and stone finishes" loading="lazy" decoding="async" /><figcaption><span class="section-kicker">Custom enclosures</span><h3>A form that belongs in your space.</h3><p>Tabletop or built-in. Wood, stone or a finish that feels at home.</p></figcaption></figure>
        </div>
        <p class="integration-note">Images show illustrative integration concepts. Final size, finish and installation depend on the chosen hardware.</p>
      </section>
      <section class="showcase integration-workflow" id="workflow"><div><span class="eyebrow">How it works</span><h2>Your ideas. On your Pirdy.</h2><p>Create a playlist in the Pirdy app, choose how it plays, then send it to your screen.</p><button class="button primary" data-action="signin">Create your playlist</button></div><div class="integration-steps"><article><h3>1. Add your content</h3><p>Import images and arrange them in a playlist.</p></article><article><h3>2. Make it yours</h3><p>Choose timing, scrolling, buttons and audio.</p></article><article><h3>3. Send it to Pirdy</h3><p>Transfer by USB, or publish remotely with Cloud Control.</p></article></div></section>
      <section class="landing-section cloud-section" id="cloud"><div><span class="eyebrow">Your choice of control</span><h2>Nearby or worldwide. You’re in control.</h2></div><div class="cloud-options"><article><strong>Local Pirdy</strong><p>Sign in with your Pirdy Account and update by USB without a subscription. Your content plays offline.</p></article><article><strong>Cloud-connected Pirdy</strong><p>With a Cloud Control subscription, update and manage internet-connected Pirdys from anywhere in the world.</p></article></div></section>
      <section class="landing-section pricing-section" id="pricing"><div class="section-kicker">Cloud Control plans</div><h2>Choose the Cloud Control plan that suits you.</h2><p>Plans cover successful cloud changes. Local editing and USB transfers stay free.</p>${planCards({ publicView: true })}<div class="change-pass"><div><strong>Need one more change?</strong>${changePassMarkup}</div></div></section>
      <section class="landing-cta"><img src="/pirdy-symbol.png" alt="" /><div><h2>Ready to manage your Pirdy?</h2><p>Sign in to open the customer dashboard.</p></div><button class="button primary" data-action="signin">Sign in</button></section>
    </main>
    <footer class="landing-footer"><img src="/pirdy-header.png" alt="Pirdy" /><span>Programmable Interactive Retail Display</span><span>pirdy.in</span></footer>
  </div>`;
  app.querySelectorAll('[data-action="signin"]').forEach(button => button.addEventListener("click", () => signInAndContinue()));
  app.querySelectorAll('[data-action="create-account"]').forEach(button => button.addEventListener("click", () => createAccountAndContinue()));
  app.querySelectorAll('[data-public-product]').forEach(button => button.addEventListener("click", () => signInAndContinue(button.dataset.publicProduct)));
}

function renderFatal(message) {
  app.innerHTML = `<main class="welcome"><section class="welcome-card"><img src="/pirdy-header.png" alt="Pirdy" /><h1>Pirdy is unavailable</h1><p>${escapeHtml(message)}</p><button class="button primary" data-action="retry">Try again</button></section></main>`;
  app.querySelector('[data-action="retry"]').addEventListener("click", () => location.reload());
}

function renderRoute() {
  return ({ home: renderHome, content: renderContent, playlists: renderPlaylists, pirdys: renderPirdys, publish: renderPublish, logo: renderLogo, billing: renderBilling, help: renderHelp, settings: renderSettings }[state.route] ?? renderHome)();
}

function pageHeading(name, description, action = "") {
  return `<div class="page-heading"><div><h1>${name}</h1><p>${description}</p></div>${action}</div>`;
}

function planCatalog() {
  return state.planCatalog;
}

function hardwarePriceSummary() {
  const offers = array(state.hardwareOfferCatalog?.offers);
  if (!offers.length) return "Current published Pirdy prices are temporarily unavailable. Try again before ordering.";
  return `${offers.map(offer => `${escapeHtml(offer.displayName)} INR ${escapeHtml(offer.price?.amount)}`).join(" - ")}. Local Control is included for life.`;
}

function hasCurrentCloudSubscription(entitlement) {
  return ["Pending", "Active", "Grace"].includes(entitlement?.subscriptionState);
}

function formatPlanBytes(value) {
  const bytes = Number(value);
  if (!Number.isFinite(bytes) || bytes <= 0) return "Not available";
  const gib = bytes / (1024 ** 3);
  return gib >= 1 ? `${Number.isInteger(gib) ? gib : gib.toFixed(1)} GiB` : `${Math.round(bytes / (1024 ** 2))} MiB`;
}

function planLimitSummary(plan) {
  const limits = plan?.limits;
  if (!limits) return "Plan limits are unavailable";
  return `${limits.maximumLibraryItems} content items · ${limits.maximumPlaylists} playlists · ${formatPlanBytes(limits.maximumActiveCloudBytes)} Cloud storage · ${formatPlanBytes(limits.maximumMonthlyDeviceDeliveryBytes)} monthly delivery`;
}

function planCards({ publicView = false } = {}) {
  const catalog = planCatalog();
  if (!catalog) return '<div class="info">Current published Cloud prices are temporarily unavailable. Refresh before choosing a plan.</div>';
  const current = hasCurrentCloudSubscription(state.entitlement) ? state.entitlement?.planCode ?? null : null;
  return `<div class="plan-grid">${array(catalog.monthlyPlans).map(plan => {
    const selected = String(current) === String(plan.code);
    const action = selected ? "Current plan" : current ? "Change plan" : "Choose plan";
    const attribute = publicView ? `data-public-product="${escapeHtml(plan.code)}"` : `data-plan="${escapeHtml(plan.code)}"`;
    return `<article class="plan-card ${selected ? "current" : ""}"><span class="plan-name">${escapeHtml(plan.name)}</span><strong class="plan-price">₹${escapeHtml(plan.basePrice?.amount)}<small>/month + tax</small></strong><p>${escapeHtml(plan.includedSuccessfulCloudChanges)} successful Cloud changes + ${escapeHtml(plan.includedAiPrompts ?? 0)} AI prompts each month</p><p class="muted">${escapeHtml(planLimitSummary(plan))}</p><button class="button ${selected ? "" : "primary"}" ${attribute} ${selected ? "disabled" : ""}>${action}</button></article>`;
  }).join("")}</div>`;
}

// Keep the document alive when it contains an editor draft, prepared media or
// a pending purchase. A sign-in redirect must never silently discard that work.
function hasUnpersistedSignInContext() {
  return Boolean(state.playlistDraft || state.preparedArtwork || state.preparedBranding || state.pendingProductCode);
}

async function signInAndContinue(productCode = null) {
  let requestedAccount = null;
  if (productCode) state.pendingProductCode = productCode;
  const buttons = app.querySelectorAll('[data-action="signin"], [data-action="create-account"], [data-public-product]');
  buttons.forEach(item => { item.disabled = true; });
  const status = app.querySelector("#welcome-status");
  if (status) status.textContent = "Opening secure Pirdy sign-in…";
  try {
    void warmUpApi({ includeDependencies: true }).catch(() => {});
    state.account = requestedAccount = await signIn({ preserveWindow: hasUnpersistedSignInContext() });
    render();
    const currentStatus = app.querySelector("#welcome-status");
    if (currentStatus) currentStatus.textContent = "Preparing your Pirdy workspace…";
    await openSignedInPirdyAccount({ showSetup: true });
    if (state.account !== requestedAccount) return;
    if (!state.accountRegistrationRequired && !state.cloudActivationOpen && state.workspace && state.route === "help")
      await refreshSupportTickets({ announce: false });
    if (!state.accountRegistrationRequired && !state.cloudActivationOpen) await resumePendingCheckout();
  } catch (error) {
    if (requestedAccount && state.account !== requestedAccount) return;
    if (state.account) {
      state.workspaceLoading = false;
      state.busy = false;
      state.workspaceError = { message: customerVisibleErrorMessage(error, "Your account could not be opened. Try again to reconnect.") };
      render();
      return;
    }
    const target = app.querySelector("#welcome-error");
    if (target) target.textContent = customerVisibleErrorMessage(error,
      "Sign-in could not be completed. Please try again.");
    const currentStatus = app.querySelector("#welcome-status");
    if (currentStatus) currentStatus.textContent = "";
    buttons.forEach(item => { item.disabled = false; });
  }
}

async function createAccountAndContinue() {
  let requestedAccount = null;
  const buttons = app.querySelectorAll('[data-action="signin"], [data-action="create-account"], [data-public-product]');
  buttons.forEach(item => { item.disabled = true; });
  const status = app.querySelector("#welcome-status");
  if (status) status.textContent = "Opening secure Pirdy account setup...";
  try {
    void warmUpApi({ includeDependencies: true }).catch(() => {});
    state.account = requestedAccount = await createAccount({ preserveWindow: hasUnpersistedSignInContext() });
    render();
    await openSignedInPirdyAccount({ register: true, showSetup: true });
  } catch (error) {
    if (requestedAccount && state.account !== requestedAccount) return;
    if (state.account) {
      state.workspaceLoading = false;
      state.busy = false;
      state.workspaceError = { message: customerVisibleErrorMessage(error, "Your account could not be opened. Try again to reconnect.") };
      render();
      return;
    }
    const target = app.querySelector("#welcome-error");
    if (target) target.textContent = customerVisibleErrorMessage(error,
      "Account creation could not be completed. Please try again.");
    const currentStatus = app.querySelector("#welcome-status");
    if (currentStatus) currentStatus.textContent = "";
    buttons.forEach(item => { item.disabled = false; });
  }
}

async function openSignedInPirdyAccount({ register = false, showSetup = false } = {}) {
  const account = state.account;
  if (register && currentStartupCreation()) { render();return; }
  const attempt = register ? beginStartupCreation("registration") : null;
  const requestVersion = ++state.accountRequestVersion;
  const isCurrent = () => state.account === account && requestVersion === state.accountRequestVersion;
  try {
    const projection = register
      ? await waitForStartupCreation(() => registerPirdyAccount(), { onLateSettlement: () => reconcileLateStartupCreation(attempt) })
      : await loadPirdyAccount();
    if (!isCurrent()) return;
    if (attempt && state.startupCreation === attempt) state.startupCreation = null;
    state.pirdyAccount = projection;
  } catch (error) {
    if (!isCurrent()) return;
    if (attempt && error.code === "pirdy_startup_outcome_unknown") {
      markStartupCreationUnknown(attempt);
      return;
    }
    if (attempt && state.startupCreation === attempt) state.startupCreation = null;
    if (!register && error.status === 404 && error.code === "pirdy_account_not_created") {
      // Resume an interrupted registration for this authenticated identity only.
      await openSignedInPirdyAccount({ register: true, showSetup: true });
      return;
    }
    throw error;
  }

  state.accountRegistrationRequired = false;
  state.cloudActivationOpen = false;
  state.cloudWorkspaceAuthorization = null;
  if (showSetup && !state.pirdyAccount.organizationId) {
    state.cloudActivationOpen = true;
    render();
    return;
  }
  if (browserLocalAccountId()) {
    await enterBrowserLocalWorkspace({ announce: false });
    return;
  }
  await refreshWorkspace({ announce: false });
  if (isCurrent()) void refreshLocalWorkspaceRecord();
}

async function registerCurrentPirdyAccount() {
  if (currentStartupCreation()) { render();return; }
  const account = state.account;
  const button = app.querySelector('[data-action="register-account"]');
  const error = app.querySelector("#registration-error");
  button.disabled = true;
  error.textContent = "";
  try {
    await openSignedInPirdyAccount({ register: true });
  } catch (failure) {
    if (state.account !== account) return;
    error.textContent = customerVisibleErrorMessage(failure,
      "Your Pirdy account could not be created. Refresh the page, sign in again, and retry.");
    button.disabled = false;
  }
}

function renderHome() {
  const devices = array(state.workspace?.devices);
  const online = state.workspace?.statuses == null ? "—" : devices.filter(device => statusFor(device).online).length;
  const deviceCount = state.workspace?.devices == null ? "—" : devices.length;
  const playlistCount = state.workspace?.playlists == null ? "—" : array(state.workspace?.playlists).length;
  const contentCount = state.workspace?.content == null ? "—" : libraryContent().length;
  const publishAction = canManageContent() && canCommitMeteredCloudChange()
    ? '<button class="button primary" data-route="publish">Publish content</button>'
    : '<button class="button" data-route="publish">View publishing status</button>';
  return `${pageHeading(`Welcome back, ${escapeHtml(firstName())}`, "Create something new or check what’s playing.", publishAction)}
    <section class="stat-grid"><article class="stat"><strong>${deviceCount}</strong><span>Pirdys</span></article><article class="stat"><strong>${online}</strong><span>online now</span></article><article class="stat"><strong>${playlistCount}</strong><span>playlists</span></article><article class="stat"><strong>${contentCount}</strong><span>content items</span></article></section>
    <section class="section-head"><div><h2>Your Pirdys</h2><p>Groups expand to show individual displays and controls.</p></div><button class="button" data-route="pirdys">Manage all</button></section>
    <div class="group-grid">${groupCards(true)}</div>`;
}

function renderContent() {
  const browserLocal = isBrowserLocalWorkspace();
  const content = reviewMode ? array(reviewWorkspace.content) : array(state.workspace?.content).filter(asset=>asset.libraryVisible!==false);
  const prepared = state.preparedArtwork;
  const body = content.length
    ? `<div class="media-grid">${content.map(item => `<article class="media-card">${contentThumbnail(item)}<strong>${escapeHtml(item.name)}</strong><small>${escapeHtml(mediaDetail(item))}</small><div class="card-actions">${canManageContent() ? `<button class="button quiet danger" data-delete-media="${escapeHtml(item.assetId ?? item.id)}">Delete</button>` : ""}</div></article>`).join("")}</div>`
    : browserLocal
      ? '<section class="empty"><h2>No browser-local content yet</h2><p>Import the first PNG or JPEG below. Its verified bytes and preview stay in this browser.</p></section>'
      : '<section class="empty"><h2>No cloud content yet</h2><p>Import the first PNG or JPEG below. Pirdy prepares and verifies the device file before upload.</p></section>';
  const importPanel = canManageContent() ? `<section class="card authoring-card"><div class="section-head compact"><div><h2>Import artwork</h2><p>Add one reusable source image. Its device output is prepared when you publish.</p></div></div>
    <div class="authoring-form"><label>PNG or JPEG source<input id="artwork-file" type="file" accept="image/png,image/jpeg" ${reviewMode ? "disabled" : ""}/></label><button class="button" data-action="prepare-artwork" ${reviewMode ? "disabled" : ""}>Inspect and verify</button></div>
    <div class="info"><strong>Fit</strong> and <strong>Scroll</strong> are selected for each image while editing a playlist. Pirdy then resizes that source automatically for the selected model and orientation.</div>
    ${prepared ? `<div class="prepared-review"><img src="${prepared.previewUrl}" alt="Prepared artwork preview"/><div><strong>${escapeHtml(prepared.metadata.name)}</strong><small>${escapeHtml(mediaDetail(prepared.metadata))} · ${Math.ceil(prepared.metadata.fileSize / 1024)} KB</small><button class="button primary" data-action="upload-artwork">Add to Content</button></div></div>` : ""}
    </section>` : "";
  return `${pageHeading("Content", browserLocal
      ? "Import and manage verified content stored only in this browser for the signed-in Pirdy account."
      : "Import and manage verified content for this signed-in Pirdy account.")}
    ${importPanel}${canManageContent()?'<section class="card"><h2>Import audio</h2><p>Add reusable sound clips, then attach them to an artwork or hotspot in Edit playlist.</p><label class="button">Import audio<input type="file" accept="'+audioFileAccept+'" data-import-library-audio/></label></section>':""}
    <section class="section-head"><div><h2>Library</h2><p>${content.length} account-owned item${content.length === 1 ? "" : "s"}. Content used by a saved playlist is protected until it is removed from every saved playlist.</p></div></section>${body}`;
}

function renderPlaylists() {
  const playlists = array(state.workspace?.playlists);
  const detail = state.playlistDraft;
  const mayEdit = canManageContent();
  if (!mayEdit) {
    const rows = playlists.length
      ? playlists.map(playlist => {
          const id = String(playlist.id ?? playlist.playlistId);
          return `<button class="playlist-summary ${String(state.selectedPlaylistId) === id ? "selected" : ""}" data-playlist="${escapeHtml(id)}"><span><strong>${escapeHtml(playlist.name)}</strong><small>${escapeHtml(playlist.itemCount ?? 0)} content item${Number(playlist.itemCount) === 1 ? "" : "s"} · ${escapeHtml(playlistSavedAt(playlist))}</small></span><span>View</span></button>`;
        }).join("")
      : '<section class="empty"><h2>No saved playlists</h2><p>No playlist containers are currently available in this workspace.</p></section>';
    const items = array(detail?.items);
    const detailPanel = detail
      ? `<section class="card playlist-editor read-only"><div class="section-head compact"><div><h2>${escapeHtml(detail.name ?? "Playlist details")}</h2><p>Saved playlist · read-only</p></div></div><div class="playlist-list">${items.map((item, index) => `<article class="playlist-row"><span class="order">${index + 1}</span>${contentThumbnail(assetById(item.assetId), "thumb")}<span><strong>${escapeHtml(assetName(item.assetId))}</strong><small>${escapeHtml(playlistItemDescription(item))}</small></span></article>`).join("") || '<p class="muted">This saved playlist is empty.</p>'}</div></section>`
      : '<section class="card empty"><h2>Select a playlist</h2><p>Its saved content and playback settings will appear here without enabling changes.</p></section>';
    return `${pageHeading("Playlists", "Review saved playlists and their current content.")}<div class="editor-layout wide-editor"><section class="card"><div class="section-head compact"><div><h2>Saved playlists</h2><p>Select one to review it.</p></div></div><div class="playlist-list">${rows}</div></section>${detailPanel}</div>`;
  }
  const rows = playlists.length
    ? playlists.map(playlist => {
        const id = String(playlist.id ?? playlist.playlistId);
        return `<button class="playlist-summary ${String(state.selectedPlaylistId) === id ? "selected" : ""}" data-playlist="${escapeHtml(id)}"><span><strong>${escapeHtml(playlist.name)}</strong><small>${escapeHtml(playlist.itemCount ?? 0)} content item${Number(playlist.itemCount) === 1 ? "" : "s"} · ${escapeHtml(playlistSavedAt(playlist))}</small></span><span>Edit</span></button>`;
      }).join("")
    : '<section class="empty"><h2>No saved playlists</h2><p>Create an empty playlist container, then add and configure content.</p></section>';
  const items = detail ? array(detail.items) : [];
  const selectedIndex = Math.min(state.selectedPlaylistItem, Math.max(0, items.length - 1));
  const selectedItem = items[selectedIndex];
  const selectedAsset = selectedItem ? assetById(selectedItem.assetId) : null;
  const detailPanel = detail
    ? `<section class="card playlist-editor"><div class="section-head compact"><div><h2>Edit playlist</h2><p>Apply each image's settings, then save the playlist. Saving does not install hotspots on a Pirdy; publish the saved playlist separately.</p></div><button class="button danger" data-action="delete-playlist" ${reviewMode ? "disabled" : ""}>Delete playlist</button></div>
      <section class="playlist-step"><h3>1. Name this playlist</h3><label>Playlist name<input id="playlist-name" value="${escapeHtml(detail.name)}" maxlength="120"/></label></section>
      <div class="playlist-workspace">
      <section class="playlist-step"><h3>2. Choose content</h3><p>Select one or more images. Selected cards are outlined, then use the Add button once.</p>
        <div class="add-media-grid playlist-source-grid" data-scroll-key="add-content">${libraryContent().map(asset=>{const id=String(asset.assetId??asset.id),selected=playlistSourceSelection().has(id);return `<button type="button" class="add-media playlist-source ${selected?'selected':''}" data-select-playlist-source="${escapeHtml(id)}" aria-pressed="${selected}">${contentThumbnail(asset,"thumb")}<span><strong>${escapeHtml(asset.name)}</strong><small>${escapeHtml(mediaDetail(asset))}</small></span></button>`;}).join("")||'<p class="muted">Import content first.</p>'}</div>
        <button type="button" class="button" data-add-playlist-selection ${playlistSourceSelection().size&&!state.busy?'':'disabled'}>Add selected content${playlistSourceSelection().size?' ('+playlistSourceSelection().size+')':''}</button>
      </section>
      <section class="playlist-arrangement playlist-step"><h3>3. Arrange and select an item</h3><p>Drag cards to set playback order. Select one card to edit its appearance and interactions below.</p>
        <div class="playlist-list playlist-card-strip" data-scroll-key="playback-order" aria-label="Playlist playback order">${items.map((item,index)=>`<article class="playlist-card ${index===selectedIndex?'selected':''}" draggable="true" data-playlist-drag-index="${index}"><button type="button" class="playlist-item-select" data-playlist-item="${index}" aria-pressed="${index===selectedIndex}"><span class="order">${index+1}</span>${contentThumbnail(assetById(item.assetId),"thumb")}<span><strong>${escapeHtml(assetName(item.assetId))}</strong><small>${escapeHtml(playlistItemDescription(item))}</small></span></button></article>`).join("")||'<p class="muted">This playlist is empty. It remains saved until you delete it.</p>'}</div>
        <p class="field-help">${selectedAsset?'Selected: '+escapeHtml(selectedAsset.name)+'. Edit its appearance and interactions in step 4 below.':'Select an item to edit its settings.'}</p>
        <div class="actions"><button class="button" data-move-item="${selectedIndex}" data-delta="-1" ${selectedIndex===0||!items.length?'disabled':''}>Move earlier</button><button class="button" data-move-item="${selectedIndex}" data-delta="1" ${selectedIndex===items.length-1||!items.length?'disabled':''}>Move later</button><button class="button" data-duplicate-item="${selectedIndex}" ${items.length>=16||!items.length?'disabled':''}>Duplicate</button><button class="button" data-remove-item="${selectedIndex}" ${!items.length?'disabled':''}>Remove</button></div>
      </section>
      <div>${selectedItem&&selectedAsset?renderItemSettings(selectedItem,selectedAsset,selectedIndex):'<section class="empty compact-empty"><h3>4. Edit the selected item</h3><p>Select an image to see its preview, playback and touch settings.</p></section>'}</div></div>
      <div class="actions"><button class="button primary" data-action="save-playlist" ${reviewMode ? "disabled" : ""}>Save playlist</button>${state.assistantDraftJobId ? `<button class="button" data-action="assistant-review-publish" ${items.length && !state.busy ? "" : "disabled"}>${isBrowserLocalWorkspace() ? "Save and prepare transfer" : "Save and review publishing"}</button>` : ""}${isBrowserLocalWorkspace() && detail.id ? `<button class="button" data-action="export-local-playlist" ${items.length && !state.busy ? "" : "disabled"}>Prepare Local Transfer</button>` : ""}</div>
      ${isBrowserLocalWorkspace() && detail.id ? '<p class="field-help local-transfer-help">Save this playlist first, then prepare a verified file to open or share with Pirdy Customer App. The app asks you to choose the Pirdy and available connection before transfer.</p>' : ""}
    </section>`
    : '<section class="card empty"><h2>Select or create a playlist</h2><p>A playlist is a reusable container and may remain empty.</p></section>';
  return `${pageHeading("Playlists", "Arrange what your Pirdys play, in order.", canManageContent() ? '<div class="actions"><button class="button primary" data-action="new-playlist">New playlist</button></div>' : "")}
    ${renderPendingPlaylistCreates()}<div class="editor-layout wide-editor playlist-authoring-layout"><details class="card item-editor-section" data-editor-section="saved-playlists" ${detail ? "" : "open"}><summary>Saved playlists</summary><div class="playlist-list" data-scroll-key="saved-playlists">${rows}</div></details>${detailPanel}</div>`;
}

function renderPendingPlaylistCreates() {
  if (isBrowserLocalWorkspace()) return "";
  try {
    const pending = playlistCreateRecovery.list(playlistRecoveryScope(state.workspace));
    return pending.length ? `<section class="info"><strong>Unfinished Cloud saves</strong><p>Resume to confirm the original save without creating duplicates. Your current draft stays in the editor.</p>${pending.map(item => `<button class="button" data-resume-playlist-create="${escapeHtml(item.request.requestId)}">Resume ${escapeHtml(item.desired?.name ?? item.request.name)}</button>`).join("")}</section>` : "";
  } catch (error) { return `<p class="notice error">${escapeHtml(customerVisibleErrorMessage(error,
    "Unfinished Cloud saves could not be read. Refresh your playlists before trying again."))}</p>`; }
}

async function resumePlaylistCreate(requestId) {
  if (!canManageContent() || state.busy) return;
  const workspace = state.workspace, account = state.account, scope = playlistRecoveryScope(workspace);
  const pending = playlistCreateRecovery.list(scope).find(item => item.request.requestId === requestId);
  if (!pending) return;
  state.busy = true;render();
  try {
    let saved = await createPlaylist(pending.request);
    if (workspace !== state.workspace || account !== state.account) return;
    if (!saved?.id || saved.version <= 0) throw new Error("The original save was not confirmed.");
    if (JSON.stringify({ name: pending.request.name, items: pending.request.items }) !== JSON.stringify(pending.desired))
      saved = await updatePlaylist(saved.id, saved.version, pending.desired);
    if (workspace !== state.workspace || account !== state.account) return;
    playlistCreateRecovery.complete(scope, requestId);
    await refreshWorkspace({ announce: false });
    if (account === state.account) notify("The unfinished save was confirmed. Your current editor draft was not replaced.", "success");
  } catch (error) { if (workspace === state.workspace && account === state.account) notify(customerVisibleErrorMessage(error,
    "The unfinished save could not be resumed. Refresh your playlists and try again."), "error"); }
  finally { if (account === state.account) { state.busy = false;render(); } }
}

function renderItemSettings(item, asset, index) {
  const playbackMode = Number(asset.playbackMode);
  const requestedPresentation = Number(item.requestedPresentation ?? (playbackMode === PlaybackMode.static ? 1 : 3));
  const scrolling = requestedPresentation === 3;
  const transition = `<div class="settings-grid"><label>Transition<select id="item-transition"><option value="0" ${Number(item.transitionEffect ?? 1) === 0 ? "selected" : ""}>Immediate</option><option value="1" ${Number(item.transitionEffect ?? 1) === 1 ? "selected" : ""}>Fade out · switch · fade in</option></select></label><label>Transition duration (ms)<input id="item-transition-duration" type="number" min="0" max="10000" step="100" value="${escapeHtml(item.transitionDurationMs ?? 500)}"/></label></div>`;
  const playbackRole = `<label class="choice"><input id="item-hotspot-only" type="checkbox" ${item.autoplay === false ? "checked" : ""}/> Touch hotspot only — skip during normal playback</label><p class="field-help">Keep this artwork on the device and open it from another artwork’s hotspot. Add a Show content or Go to playlist image hotspot pointing here. Keep at least one artwork in normal playback. Requires a Touch-capable Pirdy.</p>`;
  const areas = array(item.interactions?.touchAreas);
  const preview = state.thumbnailUrls.get(String(asset.assetId ?? asset.id));
  const presentation = `<fieldset><legend>Presentation</legend><label class="choice"><input type="radio" name="item-presentation" value="1" ${scrolling ? "" : "checked"}/> Fit</label><label class="choice"><input type="radio" name="item-presentation" value="3" ${scrolling ? "checked" : ""}/> Scroll</label></fieldset>`;
  const playback = scrolling
    ? `<div class="settings-grid"><label>Horizontal direction<select id="item-horizontal-direction">${[[Direction.left, "Left"], [Direction.right, "Right"]].map(([value, label]) => `<option value="${value}" ${Number(item.requestedHorizontalDirection ?? item.direction ?? Direction.left) === value ? "selected" : ""}>${label}</option>`).join("")}</select></label><label>Horizontal speed (pixels/second)<input id="item-horizontal-speed" type="number" min="1" max="60" step="0.5" value="${escapeHtml(item.requestedHorizontalSpeedPxPerSecond ?? (Number(item.direction) < 3 ? item.speedPxPerSecond : 10) ?? 10)}"/></label><label>Vertical direction<select id="item-vertical-direction">${[[Direction.up, "Up"], [Direction.down, "Down"]].map(([value, label]) => `<option value="${value}" ${Number(item.requestedVerticalDirection ?? (Number(item.direction) > 2 ? item.direction : Direction.up)) === value ? "selected" : ""}>${label}</option>`).join("")}</select></label><label>Vertical speed (pixels/second)<input id="item-vertical-speed" type="number" min="5" max="60" step="0.5" value="${escapeHtml(item.requestedVerticalSpeedPxPerSecond ?? (Number(item.direction) > 2 ? item.speedPxPerSecond : 5) ?? 5)}"/></label></div><p class="field-help">Wide artwork uses Left or Right and is scaled to the Pirdy's height. Tall artwork uses Up or Down and is scaled to its width. If the source already fits the target shape, Pirdy uses Fit.</p>`
    : `<div class="settings-grid"><label>Show for (seconds)<input id="item-hold" type="number" min="0.1" max="3600" step="0.1" value="${escapeHtml((Number(item.holdDurationMs ?? 5000) / 1000).toFixed(1))}"/></label><label>Fade duration (milliseconds)<input id="item-fade" type="number" min="0" max="10000" step="50" value="${escapeHtml(item.effectDurationMs ?? 500)}"/></label></div><p class="field-help">Fit keeps the complete image visible, preserves its proportions, and adds background space instead of cropping.</p>`;
  const visualBounds=hotspotBounds({coordinateMode:2},asset);
  let prospectivePlan, prospectivePreview;
  try {
    prospectivePlan = itemPreviewPlan(item, asset);
    prospectivePreview = selectedItemPreview.peek({ account: state.account, workspace: state.workspace, item, plan: prospectivePlan });
  } catch (error) { prospectivePreview = { error }; }
  const previewWidth = prospectivePlan?.outputWidth ?? visualBounds.width;
  const previewHeight = prospectivePlan?.outputHeight ?? visualBounds.height;
  const previewMessage = prospectivePreview?.error ? customerVisibleErrorMessage(prospectivePreview.error, "This artwork preview could not be prepared. Reopen the playlist to retry.") : "Preparing this artwork's selected layout...";
  const requestedPreview = `<div class="item-preview-frame"><div class="item-preview-viewport" data-item-preview-viewport tabindex="0" aria-label="Selected presentation preview"><img data-item-preview-artwork ${prospectivePreview?.url ? `src="${escapeHtml(prospectivePreview.url)}"` : "hidden"} alt="${escapeHtml(asset.name)} ${scrolling ? "Scroll" : "Fit"} preview"/><p data-item-preview-message class="item-preview-message" ${prospectivePreview?.url ? "hidden" : ""}>${escapeHtml(previewMessage)}</p></div></div><p class="field-help">${visualBounds.width} × ${visualBounds.height} display preview. ${scrolling ? "Scroll inside this window to see the full artwork at its prepared size." : "The complete artwork fits within the display."}</p><div class="actions"><button type="button" class="button" data-action="test-item-interactions">Test interactions preview</button><button type="button" class="button quiet" data-action="retry-item-preview">Reload preview</button></div>`;
  const images=effectiveStaticOverlays(item),selectedOverlay=Math.min(overlaySelections.get(item)??0,Math.max(0,images.length-1));
  const staticEditorContents='<section class="static-overlay-editor"><p>These images belong only to this artwork. Drag an image to move it and its corner to resize proportionally. Images stay fixed while artwork scrolls. Add hotspots separately for tap actions.</p><label class="button">Add overlay images<input type="file" accept="image/png,image/jpeg" multiple data-static-overlay-file '+(images.length>=8?'disabled':'')+'/></label><p class="field-help">'+images.length+' of 8 images on this artwork. Later images appear in front. Select a covered image below and use the arrow keys to move it.</p><div class="static-overlay-list" aria-label="Overlay images">'+images.map((overlay,overlayIndex)=>'<div class="static-overlay-row"><button type="button" class="button '+(overlayIndex===selectedOverlay?'primary':'')+'" data-select-static-overlay="'+overlayIndex+'" aria-pressed="'+(overlayIndex===selectedOverlay)+'">Overlay '+(overlayIndex+1)+'</button><button type="button" class="button quiet" data-remove-static-overlay="'+overlayIndex+'" aria-label="Remove overlay '+(overlayIndex+1)+'">Remove</button></div>').join('')+'</div><div class="static-overlay-preview-frame"><div class="static-overlay-preview"><div class="static-overlay-artwork" tabindex="0" aria-label="Scroll artwork underneath the fixed overlays"><img data-overlay-artwork '+(prospectivePreview?.url?'src="'+escapeHtml(prospectivePreview.url)+'"':'hidden')+' alt="Artwork preview" data-width="'+previewWidth+'" data-height="'+previewHeight+'"/><p data-item-preview-message class="item-preview-message" '+(prospectivePreview?.url?'hidden':'')+'>'+escapeHtml(previewMessage)+'</p></div>'+staticOverlaysMarkup(item,true,selectedOverlay)+'</div></div></section>';
  const staticEditor='<details class="static-overlay-options item-editor-section" data-editor-section="overlays" data-static-overlay-options '+(overlayEditorsExpanded.has(item)?'open':'')+'><summary>Static image overlays (optional)</summary>'+staticEditorContents+'</details>';
  const touch = hasTouchPirdy()
    ? `<section class="touch-editor"><div class="section-head compact"><div><h3>Touch interactions</h3><p>Content hotspots move with the artwork. Drag anywhere on the complete preview to add one. Drag an existing hotspot to move it, or drag its lower-right corner to resize it.</p></div><button class="button ${state.drawingHotspot ? "primary" : ""}" data-action="draw-hotspot">${state.drawingHotspot ? "Drag on preview…" : "Draw hotspot"}</button></div>
      ${prospectivePlan && (prospectivePlan.outputWidth !== Number(asset.width) || prospectivePlan.outputHeight !== Number(asset.height) || Number(asset.preparation ?? (playbackMode === 1 ? 1 : 3)) !== prospectivePlan.requested) ? '<p class="field-help">Edit hotspots on the saved artwork below. They follow the artwork in the selected Fit or Scroll layout when published.</p>' : ""}${renderHotspotStage(asset, areas, preview)}
      ${areas.some(area => Number(area.coordinateMode) === 2) ? `<p class="field-help">Screen-fixed hotspots stay in the same place as artwork scrolls. Edit them on this screen preview, which shows the start of the artwork.</p>${renderHotspotStage(asset, areas, preview, true)}` : ""}
      <div class="hotspot-list">${areas.map((area, areaIndex) => `<article class="hotspot-row"><span class="order">${areaIndex + 1}</span><label>Name<input data-hotspot-name="${areaIndex}" maxlength="80" value="${escapeHtml(area.name ?? `Hotspot ${areaIndex + 1}`)}"/></label><label>Action<select data-hotspot-action="${areaIndex}">${touchActionOptions(Number(area.action?.kind ?? 0))}</select></label>${touchTargetControl(area, areaIndex)}<label><input type="checkbox" data-hotspot-move="${areaIndex}" ${Number(area.coordinateMode)!==2?"checked":""}/>Move hotspot with content</label><button class="button quiet danger" data-delete-hotspot="${areaIndex}">Remove</button>${renderHotspotAudio(area,areaIndex,array(state.workspace?.content))}</article>`).join("") || '<p class="muted">No hotspots yet.</p>'}</div></section>`
    : '<div class="info">This account currently has no Touch-capable Pirdy, so touch-interaction controls are hidden.</div>';
  return `<section class="item-settings"><div class="section-head compact"><div><h3>4. Edit the selected item</h3><p>${escapeHtml(asset.name)}</p></div></div><div class="item-editor-workspace"><div class="item-preview-pane">${requestedPreview}</div><div class="item-settings-column"><div class="item-settings-scroll" data-scroll-key="item-settings">${itemEditorSection("appearance", "Appearance &amp; timing", presentation + playback, true)}${itemEditorSection("transitions", "Transitions", transition)}${renderItemAudio(item,array(state.workspace?.content))}${staticEditor}${itemEditorSection("hotspots", "Touch hotspots", touch)}${itemEditorSection("playback", "Playback behavior", playbackRole)}</div><div class="item-settings-footer"><button class="button primary" data-action="apply-item-settings">Apply settings</button><p class="field-help">Apply updates this item. Save and publish the playlist separately.</p></div></div></div></section>`;
}

function itemEditorSection(key, title, body, opened = false) {
  return `<details class="item-editor-section" data-editor-section="${key}" ${opened ? "open" : ""}><summary>${title}</summary><div class="editor-section-body">${body}</div></details>`;
}

function renderHotspotStage(asset, areas, preview, screenFixed = false) {
  const bounds = hotspotBounds({ coordinateMode: screenFixed ? 2 : 1 }, asset);
  const viewport = hotspotBounds({ coordinateMode: 2 }, asset);
  const overlays = areas.map((area, index) => {
    if ((Number(area.coordinateMode) === 2) !== screenFixed) return "";
    return `<button class="hotspot" data-hotspot="${index}" aria-label="Move or resize ${screenFixed ? "screen-fixed " : ""}hotspot ${index + 1}">${area.overlayImage?`<img src="${overlayPreview(area.overlayImage)}" alt="" class="hotspot-overlay-image"/>`:index + 1}</button>`;
  }).join("");
  const artwork = preview
    ? `<img src="${preview}" alt="${escapeHtml(asset.name)} touch preview"/>`
    : '<span class="preview-loading">Loading verified preview...</span>';
  return `<p class="field-help">${viewport.width} × ${viewport.height} viewport · Scroll inside to reach the full artwork. Hotspots scroll with it.</p><div class="hotspot-viewport" tabindex="0" aria-label="Scrollable artwork hotspot editor" data-width="${viewport.width}" data-height="${viewport.height}" data-artwork="${escapeHtml(asset.assetId ?? asset.id)}"><div class="hotspot-stage ${!screenFixed && state.drawingHotspot ? "drawing" : ""}" id="${screenFixed ? "screen-hotspot-stage" : "hotspot-stage"}" data-width="${bounds.width}" data-height="${bounds.height}">${artwork}${screenFixed?staticOverlaysMarkup(state.playlistDraft?.items?.[state.selectedPlaylistItem]):""}${overlays}</div></div>`;
}

function touchActionOptions(selected) {
  return [[0, "Choose action"], [7, "Keep current artwork"], [1, "Show content"], [2, "Next image"], [3, "Previous image"], [4, "Back"], [5, "Show QR content"], [6, "Go to playlist image"]]
    .map(([value, label]) => `<option value="${value}" ${selected === value ? "selected" : ""}>${label}</option>`).join("");
}

function touchTargetControl(area, index) {
  const kind = Number(area.action?.kind ?? 0);
  if (kind === 1 || kind === 5) {
    const current=String(area.action?.targetContentId??"");
    const options=[...libraryContent()];
    const retained=assetById(current);if(retained&&!options.some(asset=>String(asset.assetId??asset.id)===current))options.push(retained);
    return `<label>Target<select data-hotspot-target="${index}"><option value="">Choose content</option>${options.map(asset => `<option value="${escapeHtml(asset.assetId ?? asset.id)}" ${current === String(asset.assetId ?? asset.id) ? "selected" : ""}>${escapeHtml(asset.name)}</option>`).join("")}</select></label>`;
  }
  if (kind === 6) {
    return `<label>Target<select data-hotspot-target="${index}"><option value="">Choose image</option>${array(state.playlistDraft?.items).map((item, itemIndex) => `<option value="${itemIndex}" ${Number(area.action?.targetPlaylistIndex) === itemIndex ? "selected" : ""}>Image ${itemIndex + 1} · ${escapeHtml(assetName(item.assetId))}</option>`).join("")}</select></label>`;
  }
  return "";
}

function contentThumbnail(asset, className = "") {
  if (!asset) return `<span class="${className || "media-art"} placeholder"></span>`;
  if(isAudioAsset(asset))return `<span class="${className || "media-art"} audio-art" aria-label="Audio clip">Audio</span>`;
  const id = String(asset.assetId ?? asset.id);
  const thumbnail = state.thumbnailUrls.get(id);
  if (thumbnail) return `<img class="${className || "media-art"}" src="${thumbnail}" alt="${escapeHtml(asset.name)} preview"/>`;
  if (mediaPreviews.errors.has(id)) return `<span class="${className || "media-art"} preview-pending" title="Preview unavailable; content remains in your library"><b>Preview unavailable</b></span>`;
  return `<span class="${className || "media-art"} preview-pending" data-thumbnail="${escapeHtml(id)}"><b>${escapeHtml(String(asset.name ?? "P").slice(0, 1).toUpperCase())}</b></span>`;
}

function assetById(assetId) {
  return array(state.workspace?.content).find(item => String(item.assetId ?? item.id) === String(assetId));
}

function libraryContent() {
  return array(state.workspace?.content).filter(item => item.libraryVisible !== false && !isAudioAsset(item));
}

function hasTouchPirdy() {
  return isBrowserLocalWorkspace() ||
    array(state.workspace?.devices).some(device => !String(device.profileId ?? "").toUpperCase().includes("NOTOUCH"));
}

function renderPirdys() {
  if (isBrowserLocalWorkspace()) return renderLocalLinkedPirdys();
  return `${pageHeading("Pirdys", "Organize Groups, Subgroups, and individual displays.")}
    <div class="info"><strong>Hierarchy:</strong> a Group contains Subgroups. A Pirdy can belong to several Subgroups, including several within the same Group. Display Off stops the panel and playback only—Wi-Fi and remote control remain active.</div>
    ${hasAdministratorRole() ? '<section class="card"><h2>Add a purchased Pirdy</h2><p>Enter the current PIN shown by an unclaimed Pirdy. Updated Pirdys change it every 5 minutes. Claiming never transfers a prior owner subscription. An eligible account can then start its one-time 7-day Cloud trial.</p><form data-claim-pirdy-form class="form-grid"><label>Device ID<input name="deviceId" required maxlength="32" pattern="PIRDY-[0-9]{8}(-[0-9]{2,17})?" placeholder="PIRDY-20261023-01"/></label><label>Temporary PIN<input name="pin" required minlength="6" maxlength="6" inputmode="numeric" pattern="[0-9]{6}"/></label><button class="button primary" type="submit">Claim Pirdy</button></form></section>' : ''}
    ${renderHierarchyManager()}
    <div class="group-grid full">${groupCards(false)}</div>`;
}

async function refreshLocalLinkedPirdys(account = state.account, accountId = browserLocalAccountId()) {
  if (!accountId) return;
  try {
    const [devices,profile] = await Promise.allSettled([loadClaimedDevices(),loadAccountProfile()]);
    if (state.account !== account || browserLocalAccountId() !== accountId) return;
    if(profile.status==="fulfilled"){
      state.accountProfile=profile.value;
      if(isBrowserLocalWorkspace())state.workspace.me={...profile.value,userId:accountId,organizationId:null};
    }
    if(devices.status!=="fulfilled")throw devices.reason;
    state.claimedDevices = array(devices.value);
    state.claimedDevicesAccountId = accountId;
    state.linkedPirdysError = null;
    if (["home","pirdys","settings"].includes(state.route)) render();
  } catch {
    // The independent device directory is optional while offline. It does not
    // unlock paid workspace reads, status, content or remote mutations.
    if (state.account === account && browserLocalAccountId() === accountId && state.route === "pirdys") {
      state.linkedPirdysError = "Could not refresh linked Pirdys. Check your connection and try again.";render();
    }
  }
}

function renderLocalLinkedPirdys() {
  return `${pageHeading("Pirdys", "Open a Pirdy's own settings and connect it by USB.", '<button class="button" data-refresh-linked-pirdys>Refresh Pirdys</button>')}
    ${state.linkedPirdysError ? `<p role="status">${escapeHtml(state.linkedPirdysError)}</p>` : ""}
    ${hasAdministratorRole()?'<section class="card"><h2>Add a Pirdy to your account</h2><p>Start registration, then enter the current PIN shown by your Pirdy. This does not activate Cloud Control.</p><form data-claim-pirdy-form class="form-grid"><label>Device ID<input name="deviceId" required maxlength="32" pattern="PIRDY-[0-9]{8}(-[0-9]{2,17})?" placeholder="PIRDY-20261023-01"/></label><label>Temporary PIN<input name="pin" required minlength="6" maxlength="6" inputmode="numeric" pattern="[0-9]{6}"/></label><button class="button primary" type="submit">Add Pirdy</button></form></section>':''}
    ${renderLocalLinkedPirdyCards()}`;
}

function currentLinkedPirdys(){return state.claimedDevicesAccountId===browserLocalAccountId()?array(state.claimedDevices):[];}
function renderLocalLinkedPirdyCards(){
  return `<div class="group-grid full">${currentLinkedPirdys().map(device=>`<article class="card"><h2>${escapeHtml(customerDeviceName(device,state.workspace))}</h2><p>${escapeHtml(device.deviceId)} · ${escapeHtml(customerModelName(device))}</p><p>Connect by USB to read this Pirdy's current status and settings.</p><button class="button" data-device-settings="${escapeHtml(device.deviceId)}">Settings</button><button class="button" data-route="playlists">Edit content</button></article>`).join('')||'<section class="card"><h3>Your linked Pirdys</h3><p>Refresh to load this account’s linked devices. Local USB controls remain available.</p></section>'}</div>`;
}
function renderBrowserLocalPublish(){
  return `${pageHeading('Publish','Choose a saved playlist and send it to your Pirdy.')}<section class="card"><h2>1. Choose a playlist</h2><p>Original images are automatically resized for the selected screen. Saved audio, transitions, overlays and hotspots stay together.</p><div class="playlist-list">${array(state.workspace?.playlists).map(playlist=>`<article class="playlist-row"><strong>${escapeHtml(playlist.name)}</strong><div class="actions"><button class="button primary" data-send-local-playlist="${escapeHtml(playlist.id)}" ${playlist.itemCount&&!state.busy?'':'disabled'}>Send via USB</button><button class="button" data-prepare-local-publish="${escapeHtml(playlist.id)}" ${playlist.itemCount&&!state.busy?'':'disabled'}>Open in Customer App</button></div></article>`).join('')||'<p>Save a playlist first.</p>'}</div></section>${renderLocalControlHandoff()}`;
}

async function sendBrowserLocalPlaylist(playlistId) {
  if (!isBrowserLocalWorkspace() || state.busy) return;
  const account = state.account, accountId = browserLocalAccountId();
  try {
    const snapshot = await browserAuthoringWorkspaceStore.open(accountId);
    if (state.account !== account || browserLocalAccountId() !== accountId) return;
    const playlist = snapshot.playlists.find(value => value.id === playlistId);
    if (!playlist?.items?.length) throw new Error("Refresh and choose a saved playlist.");
    openUsbControls({ accountId, currentAccountId: () => state.account === account ? browserLocalAccountId() : null,
      playlist: { name: playlist.name, itemCount: playlist.items.length },
      preparePlaylist: (device, isCurrent) => prepareUsbPlaylist(snapshot, playlist.id, device,
        { isCurrent, prepareVariant: preparePublicationVariant }) });
  } catch (error) {
    if (state.account === account && browserLocalAccountId() === accountId)
      notify(customerVisibleErrorMessage(error, "The saved playlist could not be prepared. Nothing was sent."), "error");
  }
}

function renderPublish() {
  const playlists = array(state.workspace?.playlists);
  const devices = array(state.workspace?.devices);
  const groups = buildFleet(state.workspace).allGroups;
  const mayPublish = canManageContent();
  const access = customerCloudAccessPolicy(state.cloudAccess);
  const steps = `<ol class="steps"><li class="${state.publishStep === 1 ? "active" : ""}"><b>1</b> Playlist</li><li class="${state.publishStep === 2 ? "active" : ""}"><b>2</b> Pirdys</li><li class="${state.publishStep === 3 ? "active" : ""}"><b>3</b> Review</li></ol>`;
  if (!mayPublish) {
    const explanation = !access.canMutateCloudWorkspace
      ? "Cloud content, Pirdys, live status, remote controls, and publishing are unavailable until Cloud Control is active. Your account, billing, support, and Local Control remain available."
      : "Your organization role can review content and status but cannot publish. Ask an organization administrator or content manager.";
    return `${pageHeading("Publish", "Review Cloud publishing availability.")}${steps}<section class="card publish-card"><h2>Cloud publishing unavailable</h2><p>${explanation}</p></section>`;
  }
  if (!canCommitMeteredCloudChange())
    return `${pageHeading("Publish", "Review Cloud publishing availability.")}${steps}<section class="card publish-card"><h2>Monthly Cloud changes are used</h2><p>Publishing needs a Single Change or renewal. Content and playlist management, Pirdy status, display control, and support remain available.</p><button class="button" data-route="billing">View billing options</button></section>`;
  if (state.publishStep === 1) {
    const choices = playlists.map(playlist => {
      const id = String(playlist.id ?? playlist.playlistId);
      return `<label class="publish-choice"><input type="radio" name="publish-playlist" value="${escapeHtml(id)}" ${String(state.selectedPlaylistId) === id ? "checked" : ""}/><span><strong>${escapeHtml(playlist.name)}</strong><small>${escapeHtml(playlist.itemCount ?? 0)} content item${Number(playlist.itemCount) === 1 ? "" : "s"} · ${escapeHtml(playlistSavedAt(playlist))}</small></span><i>✓</i></label>`;
    }).join("");
    return `${pageHeading("Publish", "Send one saved playlist to one Pirdy or compatible group.")}${steps}<section class="card publish-card"><h2>Choose a playlist</h2><p>Only playlists saved for this signed-in account are shown.</p>${choices || '<section class="empty"><h2>No playlist is ready</h2><p>Create and save a playlist first.</p></section>'}<div class="info">Publishing saves a desired version and wakes connected Pirdys. Installation is confirmed separately by device status; offline Pirdys receive it after reconnecting.</div><div class="actions"><button class="button primary" data-action="publish-next" ${state.selectedPlaylistId && playlists.length ? "" : "disabled"}>Continue to Pirdys</button></div></section>`;
  }
  if (state.publishStep === 2) {
    const deviceChoices = devices.map(device => `<label class="target-choice"><input type="radio" name="publish-target" value="device:${escapeHtml(device.deviceId)}" ${targetChecked("device", device.deviceId)}/><span><strong>${escapeHtml(customerDeviceName(device, state.workspace))}</strong><small>${escapeHtml(customerModelName(device))} · ${statusFor(device).online ? "Online" : "Offline"}</small></span></label>`).join("");
    const groupChoices = groups.map(group => { const id=String(group.id ?? group.groupId); return `<label class="target-choice"><input type="radio" name="publish-target" value="group:${escapeHtml(id)}" ${targetChecked("group", id)}/><span><strong>${escapeHtml(group.name)}</strong><small>${array(group.members).length} compatible Pirdys</small></span></label>`; }).join("");
    return `${pageHeading("Publish", "Use one playlist on any Pirdy. Artwork is resized automatically for the selected screen.")}${steps}<section class="card publish-card"><h2>Individual Pirdys</h2><div class="target-grid">${deviceChoices || '<p class="muted">No Pirdys are assigned to this account.</p>'}</div><h2 class="target-heading">Compatible groups</h2><div class="target-grid">${groupChoices || '<p class="muted">No groups are available.</p>'}</div><div class="actions"><button class="button" data-action="publish-back">Back</button><button class="button primary" data-action="publish-review" ${state.publishTarget ? "" : "disabled"}>Check compatibility</button></div></section>`;
  }
  const playlist = state.selectedPlaylist;
  const target = publishTargetLabel();
  const validation = state.publicationValidation;
  return `${pageHeading("Publish", "Review the change before sending it.")}${steps}<section class="card publish-card"><h2>${escapeHtml(playlist?.name ?? "Selected playlist")}</h2><dl class="review-list"><div><dt>Target</dt><dd>${escapeHtml(target)}</dd></div><div><dt>Items</dt><dd>${array(playlist?.items).length}</dd></div><div><dt>Saved revision</dt><dd>${escapeHtml(playlist?.version ?? "Unverified")}</dd></div><div><dt>Hotspots</dt><dd>${array(playlist?.items).reduce((total, item) => total + array(item.interactions?.touchAreas).length, 0)}</dd></div><div><dt>Compatibility</dt><dd>${validation?.canPublish ? "Ready to publish" : "Not validated"}</dd></div></dl><div class="info">This sends the reviewed saved playlist, not unsaved draft edits. Publishing and device installation are separate; check the device-reported publication afterward.</div><div class="actions"><button class="button" data-action="publish-back-target">Back</button><button class="button primary" data-action="publish-confirm" ${validation?.canPublish ? "" : "disabled"}>Publish now</button></div></section>`;
}

function renderLogo() {
  const branding = state.workspace?.branding ?? {};
  const custom = branding.hasCustomLogo === true;
  const prepared = state.preparedBranding;
  let preview = prepared
    ? `<div class="branding-previews"><figure><img src="${prepared.landscape.previewUrl}" alt="Pirdy Spark landscape startup logo preview"/><figcaption>Pirdy Spark · Landscape</figcaption></figure><figure class="portrait"><img src="${prepared.portrait.previewUrl}" alt="Pirdy Spark portrait startup logo preview"/><figcaption>Pirdy Spark · Portrait</figcaption></figure><figure><img src="${prepared.duosLandscape.previewUrl}" alt="Pirdy Engage landscape startup logo preview"/><figcaption>Pirdy Engage · Landscape</figcaption></figure><figure class="portrait"><img src="${prepared.duosPortrait.previewUrl}" alt="Pirdy Engage portrait startup logo preview"/><figcaption>Pirdy Engage · Portrait</figcaption></figure></div>`
    : `<div class="logo-preview"><img src="/pirdy-header.png" alt="${custom ? "Custom logo is active; select a source image to preview a replacement" : "Default Pirdy startup logo"}" /></div>`;
  if (prepared?.crowLandscape && prepared?.crowPortrait) preview += `<div class="branding-previews"><figure><img src="${prepared.crowLandscape.previewUrl}" alt="5 and 7 inch landscape startup logo"/><figcaption>5-inch / 7-inch · Landscape</figcaption></figure><figure class="portrait"><img src="${prepared.crowPortrait.previewUrl}" alt="5 and 7 inch portrait startup logo"/><figcaption>5-inch / 7-inch · Portrait</figcaption></figure></div>`;
  if (isBrowserLocalWorkspace()) return `${pageHeading("Startup Logo", "Choose one PNG or JPEG. Pirdy preserves the complete image and prepares it for the screen you connect.")}
    <section class="card logo-card">${preview}<div><h2>Startup logo</h2><label>PNG or JPEG source<input id="branding-file" type="file" accept="image/png,image/jpeg" /></label>
    <div class="actions"><button class="button" data-action="prepare-branding">Prepare previews</button><button class="button primary" data-action="usb-branding" ${prepared?.sourceFile ? "" : "disabled"}>Set on connected Pirdy</button><button class="button" data-action="usb-default-branding">Remove from connected Pirdy</button></div>
    <p>Direct USB changes only the Pirdy you select. No Cloud command is sent.</p></div></section>`;
  const mayChange = canAdminister();
  const meteredAllowed = canCommitMeteredCloudChange();
  const controls = mayChange
    ? `<label>PNG or JPEG source<input id="branding-file" type="file" accept="image/png,image/jpeg" ${reviewMode ? "disabled" : ""}/></label><div class="actions"><button class="button" data-action="prepare-branding" ${reviewMode ? "disabled" : ""}>Prepare previews</button><button class="button primary" data-action="upload-branding" ${prepared && !reviewMode && meteredAllowed ? "" : "disabled"}>Apply startup logo</button>${custom ? `<button class="button danger" data-action="remove-branding" ${meteredAllowed ? "" : "disabled"}>Use default logo</button>` : ""}</div>`
    : hasAdministratorRole()
      ? '<p class="muted">Cloud Control is unavailable. The current Pirdy playback is unchanged; renew before opening or changing the Cloud startup logo.</p>'
      : '<p class="muted">Only an Organization Administrator can change the startup logo.</p>';
  const changeNotice = mayChange && !meteredAllowed
    ? '<div class="info">The included monthly Cloud changes are used. Prepare a preview now, then buy a Single Change or renew before applying it.</div>'
    : '';
  return `${pageHeading("Startup Logo", "Prepare one source image for both Pirdy orientations.")}
    <section class="card logo-card">${preview}<div><h2>${custom ? "Custom startup logo active" : "Default Pirdy startup logo"}</h2><p>${custom ? `${escapeHtml(branding.sourceFileName ?? "Custom logo")} · version ${escapeHtml(branding.version)}` : "No custom account logo is active."}</p>
    ${controls}${changeNotice}<div class="info">Pirdy prepares a verified Fit logo for every model and orientation automatically. Applying the logo counts as one successful Cloud change, regardless of fleet size.</div></div></section>`;
}

function renderBilling() {
  const billing = reviewMode ? reviewBilling : (state.billing ?? { invoices: [] });
  const catalog = planCatalog();
  const changePass = catalog?.singleChangePass;
  const summary = billing.summary ?? {};
  const invoices = array(billing.invoices);
  const money = value => value && Number.isFinite(Number(value.amount))
    ? `${escapeHtml(value.currency ?? "INR")} ${Number(value.amount).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : "Not loaded";
  const date = value => value ? new Date(value).toLocaleDateString("en-IN") : "Not scheduled";
  const rows = invoices.length
    ? invoices.map(invoice => {
        const outstanding=Number(invoice.outstanding?.amount ?? 0);
        const canOpen=invoice.documentAvailable===true;
        const canPay=billing.hostedPaymentsAvailable===true && outstanding>0 && ["issued","pastdue"].includes(String(invoice.status).toLowerCase());
        return `<tr><td><strong>${escapeHtml(invoice.invoiceNumber ?? invoice.invoiceId)}</strong></td><td>${date(invoice.issuedAtUtc)}</td><td>${date(invoice.dueAtUtc)}</td><td><strong>${money(invoice.total)}</strong><br/><span class="muted">${money(invoice.outstanding)} outstanding</span></td><td><span class="pill ${String(invoice.status).toLowerCase()}">${escapeHtml(invoice.status)}</span></td><td class="table-actions"><button class="button" data-invoice="${escapeHtml(invoice.invoiceId)}" data-action="invoice" ${canOpen?"":"disabled"}>Invoice</button><button class="button primary" data-invoice="${escapeHtml(invoice.invoiceId)}" data-action="pay" ${canPay?"":"disabled"}>Pay Now</button></td></tr>`;
      }).join("")
    : '<tr><td colspan="6"><p class="muted billing-empty">Billing has not been loaded, or this account has no invoices.</p></td></tr>';
  const entitlement = state.entitlement;
  const entitlementText = entitlement
    ? `${escapeHtml(entitlement.includedChangesRemaining)} included and ${escapeHtml(entitlement.purchasedSingleChangesRemaining)} purchased change(s) remaining${entitlement.periodEndExclusiveUtc ? ` · period ends ${new Date(entitlement.periodEndExclusiveUtc).toLocaleDateString("en-IN")}` : ""}.`
    : "Plan status has not been verified. No checkout will start until it is available.";
  const access = customerCloudAccessPolicy(state.cloudAccess);
  const passAllowed = changePass && entitlement && access.canReadCloudWorkspace
    && ["Active", "Grace"].includes(entitlement.subscriptionState)
    && Number(entitlement.includedChangesRemaining) === 0;
  const devices = reviewMode ? array(reviewWorkspace.devices) : array(state.claimedDevices);
  const trialAllowed = hasAdministratorRole() && devices.length > 0 &&
    canStartCloudTrial(entitlement, state.cloudAccess);
  const trialOptions = devices.map(device => `<option value="${escapeHtml(device.deviceId)}">${escapeHtml(customerDeviceName(device, state.workspace))} · ${escapeHtml(device.deviceId)}</option>`).join("");
  return `${pageHeading("Billing & Usage", "See fixed plans, Cloud changes, invoices and payment status.", `<button class="button" data-action="load-billing" ${reviewMode ? "disabled" : ""}>Refresh</button>`)}
    <section class="card"><h2>Reconnect a Pirdy after activation</h2><p>${escapeHtml(cloudRecheckAfterPaymentGuidance)}</p><p>For signed firmware without a Cloud plan, use Check Firmware on the Pirdy or in the Windows Customer App.</p></section>
    <section class="card"><div class="section-head"><div><h2>7 days free Cloud Control</h2><p>One trial per account, organization, and physical Pirdy. No payment method, no automatic charge, and Local Control remains free for life.</p></div></div><label>Claimed Pirdy<select data-trial-device ${trialAllowed ? "" : "disabled"}>${trialOptions || '<option>No claimed Pirdy available</option>'}</select></label><button class="button primary" data-action="start-trial" ${trialAllowed ? "" : "disabled"}>Start free trial</button></section>
    <section class="card"><div class="section-head"><div><h2>Buy a Pirdy</h2><p>${hardwarePriceSummary()} Hardware ordering is separate from Cloud subscription.</p></div></div><div class="actions"><button class="button" data-hardware-offer="pirdy-uno">Buy Pirdy Spark</button><button class="button" data-hardware-offer="pirdy-duos">Buy Pirdy Engage</button></div></section>
    <section class="section-head"><div><h2>Cloud Control plans</h2><p>Every plan change starts on the next billing date. There is no automatic mid-cycle charge, credit, or refund.</p></div></section>
    <label class="confirmation"><input type="checkbox" data-purchased-pirdy-confirm/> <span>I confirm that I purchased and claimed a Pirdy on this account.</span></label>
    ${planCards()}<div class="change-pass"><div><strong>${changePass ? `Single Change Pass - INR ${escapeHtml(changePass.basePrice?.amount)} + tax` : "Single Change Pass - current price unavailable"}</strong><span>1 Cloud change + ${escapeHtml(changePass?.includedAiPrompts ?? 0)} AI prompts. Available with active Cloud Control after the monthly included changes are used. A purchased change waits safely while Cloud Control is inactive.</span></div><button class="button" data-action="buy-change" ${passAllowed ? "" : "disabled"}>Buy one change</button></div>
    <div class="info"><strong>Cloud changes:</strong> ${entitlementText} Only a successfully committed content publication or startup-logo activation counts. Batch and group publishing count once.</div>
    <section class="billing-grid"><article class="stat wide-stat"><span>Plan</span><strong>${escapeHtml(summary.planName ?? "Not loaded")}</strong></article><article class="stat wide-stat"><span>Current period</span><strong>${summary.currentPeriod ? `${date(summary.currentPeriod.startUtc)} – ${date(summary.currentPeriod.endExclusiveUtc)}` : "Not loaded"}</strong></article><article class="stat wide-stat"><span>Included Cloud changes</span><strong>${escapeHtml(entitlement?.includedChanges ?? "Not loaded")}</strong></article><article class="stat wide-stat"><span>Used this period</span><strong>${escapeHtml(entitlement?.usedIncludedChanges ?? "Not loaded")}</strong></article><article class="stat wide-stat"><span>Remaining</span><strong>${escapeHtml(entitlement?.includedChangesRemaining ?? "Not loaded")}</strong></article><article class="stat wide-stat"><span>Purchased Single Changes</span><strong>${escapeHtml(entitlement?.purchasedSingleChangesRemaining ?? "Not loaded")}</strong></article><article class="stat wide-stat"><span>Invoice subtotal</span><strong>${money(summary.commercialSubtotal)}</strong></article><article class="stat wide-stat"><span>Tax</span><strong>${money(summary.tax)}</strong></article><article class="stat wide-stat"><span>Balance</span><strong>${money(summary.balance)}</strong></article><article class="stat wide-stat"><span>Payment state</span><strong>${escapeHtml(summary.paymentStatus ?? "Not loaded")}</strong></article></section>
    <section class="section-head"><div><h2>Invoices</h2><p>The amount is visible here; opening a PDF is optional.</p></div></section><div class="table-card"><table><thead><tr><th>Invoice</th><th>Issued</th><th>Due</th><th>Amount</th><th>Status</th><th></th></tr></thead><tbody>${rows}</tbody></table></div>`;
}

function renderHelp() {
  const items = [
    ["Fit or Scroll?", "Fit shows the complete static image. Scroll is for artwork longer than the connected Pirdy's screen; direction is automatically limited by device orientation."],
    ["How do Touch hotspots move?", "Every hotspot stays attached to its artwork and becomes tappable whenever that part is visible. Pirdy automatically handles manual scrolling and return to playback."],
    ["Does Display Off disconnect Wi-Fi?", "No. It switches off the display and playback only. The Pirdy remains reachable for approved commands and updates."],
    ["What is the difference between Display Off and Power Off?", "Display Off is reachable standby: the screen and playback stop, but approved USB-C, Wi-Fi and remote controls remain available. Power Off is a separately confirmed Ship Mode action. A Pirdy in Ship Mode is unreachable and cannot be turned on remotely; wake it with its multifunction button or USB-C power. A deliberately powered-off Pirdy stays black while charging until you wake it."],
    ["Why does Pirdy not appear as a USB drive?", "This is intentional. Use a USB-C data cable and Pirdy Customer App to send a verified local transfer. Pirdy remains the only owner of its microSD card, so the computer does not receive a drive letter."],
    ["How do I force-restart an unresponsive Pirdy?", "Disconnect USB-C if necessary and hold the multifunction button for 15 seconds. This uses the hardware recovery path; it is not a remote or software restart."],
    ["Does Pirdy need Cloud Control?", "No. Normal playback and USB-C transfer work locally. Cloud Control adds remote publishing, status and display controls."],
    ["How do I transfer locally?", "Save a playlist here, choose Prepare Local Transfer, then open or share the verified file with Pirdy Customer App. The app asks you to choose the Pirdy and an available local connection."],
    ["What happens when my Cloud Control plan expires?", "You can still sign in, use Local Control, and access billing and support. Cloud content, live status, remote control and publishing pause until renewal. Content kept locally and current Pirdy playback are not deleted."],
    ["What happens when my included Cloud changes are used?", "Further Cloud publishing and startup-logo changes pause. Sign-in, account reads, Pirdy status, display control, support, Content and playlist management continue. Renew or buy a Single Change when available."],
    ["What happens if publishing is interrupted?", "The current Pirdy publication keeps playing. A new publication becomes active only after it is ready."],
    ["Why can I not delete some content?", "Content used by a saved playlist is protected. Remove it from every named playlist, save those playlists, then delete it from Content. Deleting unused content never changes current Pirdy playback."],
    ["How do I recover a Pirdy that cannot finish starting?", "Connect it to Pirdy Customer App with a USB-C data cable and open Settings, Pirdy firmware, then Boot-loop recovery. Choose the exact Pirdy model and port. Recovery preserves device identity, Wi-Fi settings and SD content."],
  ];
  const me = state.workspace?.me ?? {};
  const contactName = me.displayName ?? displayName();
  const contactEmail = me.email ?? state.account?.username ?? me.signInIdentifier ?? "Not provided";
  const contactPhone = me.phone ?? me.phoneNumber ?? "Not provided";
  const tickets = array(state.supportTickets);
  const history = state.supportLoading
    ? '<section class="card support-history"><p class="muted">Loading your support requests...</p></section>'
    : state.supportError
      ? `<section class="card support-history" role="status"><p>${escapeHtml(state.supportError)}</p><button class="button" data-action="refresh-support">Try again</button></section>`
      : tickets.length
        ? `<div class="support-ticket-list">${tickets.map(ticket => {
            const issueType = ticket.category === "Other" && ticket.otherCategory ? ticket.otherCategory : supportCategoryLabel(ticket.category);
            return `<article class="support-ticket"><span><strong>${escapeHtml(ticket.subject ?? "Support request")}</strong><small>${escapeHtml(issueType ?? "General")} · ${escapeHtml(supportTicketDate(ticket))}</small></span><span class="pill">${escapeHtml(supportStatusLabel(ticket.status))}</span></article>`;
          }).join("")}</div>`
        : '<section class="card support-history"><p class="muted">You have no support requests yet.</p></section>';
  return `${pageHeading("Help & Support", "Find an answer or send a support request from your signed-in account.")}
    <section class="support-layout">
      <div><div class="faq">${items.map(([question, answer]) => `<details><summary>${escapeHtml(question)}</summary><p>${escapeHtml(answer)}</p></details>`).join("")}</div>
        <section class="card support-contact"><h2>Contact details</h2><p>These signed-in details are attached to your request automatically.</p><dl>
          <div><dt>Name</dt><dd>${escapeHtml(contactName)}</dd></div>
          <div><dt>Email</dt><dd>${escapeHtml(contactEmail)}</dd></div>
          <div><dt>Phone</dt><dd>${escapeHtml(contactPhone)}</dd></div>
        </dl><p class="muted">Never include a password, claim PIN, payment security code, or access token.</p></section>
      </div>
      <form class="card support-form" id="support-ticket-form">
        <div><span class="eyebrow">Customer support</span><h2>Tell us what happened</h2><p>Include what you expected, what happened instead, and which Pirdy was affected.</p></div>
        <label>Issue type<select name="category" required>${supportCategories.filter(category => category !== "WirelessRetrieval").map(category => `<option value="${escapeHtml(category)}">${escapeHtml(supportCategoryLabel(category))}</option>`).join("")}</select></label>
        <label class="hidden" data-support-other>Other issue type<input name="otherCategory" maxlength="80" autocomplete="off"/></label>
        <label>Subject<input name="subject" maxlength="160" required autocomplete="off"/></label>
        <label>Description<textarea name="description" minlength="20" maxlength="4000" rows="7" required placeholder="What were you doing, and what happened?"></textarea></label>
        <div class="support-form-footer"><small>Your request will be linked to this signed-in account.</small><button class="button primary" type="submit" ${state.supportSubmitting || reviewMode ? "disabled" : ""}>${state.supportSubmitting ? "Sending..." : "Send request"}</button></div>
        <div class="form-status" data-support-status role="status" aria-live="polite"></div>
      </form>
    </section>
    <section class="section-head support-history-head"><div><h2>Your support requests</h2><p>Updates for this customer account appear here.</p></div><button class="button" data-action="refresh-support" ${state.supportLoading || reviewMode ? "disabled" : ""}>Refresh</button></section>
    ${history}`;
}

function renderSettings() {
  const me = state.workspace?.me ?? {};
  const devices = array(state.workspace?.devices);
  const signInAddress = me.email ?? me.signInIdentifier ?? state.account?.username ?? "Not provided";
  const signInMethod = me.signInProvider ?? "Secure Pirdy sign-in";
  const deviceSettings = devices.length
    ? `<div class="settings-device-list">${devices.map(device => {
        const status = statusFor(device);
        return `<article><span><strong>${escapeHtml(customerDeviceName(device, state.workspace))}</strong><small>${escapeHtml(customerModelName(device))} · ${escapeHtml(device.firmwareVersion ?? "Firmware version not reported")}</small><small>${escapeHtml(status.state)} · ${escapeHtml(status.lastSeen)}</small></span><span class="settings-device-actions"><span class="presence ${status.online ? "online" : "offline"}"><i></i>${status.online ? "Online" : "Offline"}</span><button class="button" type="button" data-route="pirdys">Manage</button></span></article>`;
      }).join("")}</div>`
    : '<p class="muted">No Cloud Pirdys are assigned to this account.</p>';
  return `${pageHeading("Settings", "Manage browser-safe Cloud, account, billing, organization, and Pirdy preferences.")}
    <div class="settings-stack">
      <section class="card settings-section"><div class="section-head compact"><div><h2>Your Pirdy profile</h2><p>Identity details verified for this web session.</p></div><button class="button danger" data-action="signout" ${reviewMode ? "disabled" : ""}>Sign out</button></div>
        <dl class="settings-details">
          <div><dt>Name</dt><dd>${escapeHtml(me.displayName ?? displayName())}</dd></div>
          <div><dt>Sign-in email</dt><dd>${escapeHtml(signInAddress)}</dd></div>
          <div><dt>Phone</dt><dd>${escapeHtml(me.phone ?? me.phoneNumber ?? "Not provided")}</dd></div>
          <div><dt>Role</dt><dd>${escapeHtml(roleLabel(me.role))}</dd></div>
          <div><dt>Sign-in method</dt><dd>${escapeHtml(signInMethod)}</dd></div>
        </dl>
        <p class="field-help">Your sign-in email and method are verified account identity, not editable organization profile text. Signing in never uploads local content, claims a Pirdy, or activates Cloud Control.</p>
      </section>
      ${renderCloudControlSettings()}
      ${renderEncryptedWorkspaceBackup()}
      ${renderWorkspaceProfileSettings()}
      <section class="card settings-section"><div class="section-head compact"><div><h2>Organization administration</h2><p>Open the cloud-backed settings available for your role.</p></div></div>
        <div class="settings-actions"><button class="button" data-route="pirdys">Pirdys and groups</button><button class="button" data-route="logo">Startup logo</button><button class="button" data-route="billing">Billing and usage</button></div>
        ${renderOrganizationManagement()}
      </section>
      ${renderBillingProfileSettings()}
      <section class="card settings-section"><div class="section-head compact"><div><h2>Cloud Pirdys</h2><p>Model, firmware, playback, and connection state from the latest account refresh.</p></div><button class="button" data-action="refresh" ${state.workspaceLoading || reviewMode ? "disabled" : ""}>Refresh status</button></div>${deviceSettings}<p class="field-help settings-boundary">Names, Groups, Subgroups, and Display On or Off are managed through the Pirdys page. USB-C transfer, connected-device firmware install, and boot-loop recovery are available only in Pirdy Customer App for Windows.</p></section>
      <section class="card settings-section app-about"><img src="/pirdy-header.png" alt="Pirdy"/><div><h2>Application</h2><p>Pirdy · Programmable Interactive Retail Display</p><p class="muted">Pirdy Web 1.0.0</p><button class="button" data-route="help">Help & Support</button></div></section>
    </div>`;
}

function renderCloudControlSettings() {
  const access = customerCloudAccessPolicy(state.cloudAccess);
  const lifecycle = access.cloudState ?? state.pirdyAccount?.cloudControlState ?? null;
  const status = state.cloudAccessError || !access.verified
    ? "Status unavailable"
    : access.canMutateCloudWorkspace ? "Active" : "Unavailable";
  const detail = state.cloudAccessError || !access.verified
    ? "Cloud content, live status, remote controls, and publishing are unavailable until access can be verified."
    : access.canMutateCloudWorkspace
      ? "Intentional saves, publishing, display control, and startup-logo changes use this activated Cloud workspace."
      : "Cloud content, live status, remote controls, and publishing are unavailable. Sign-in, billing, support, Local Control, and current Pirdy playback remain available.";
  return `<section class="card settings-section"><div class="section-head compact"><div><h2>Cloud Control</h2><p>Activation and current workspace availability.</p></div><span class="pill ${access.canMutateCloudWorkspace ? "paid" : ""}">${escapeHtml(status)}</span></div>
    <dl class="settings-details"><div><dt>Cloud Control</dt><dd>${escapeHtml(lifecycle ? cloudLifecycleLabel(lifecycle) : status)}</dd></div><div><dt>Cloud changes</dt><dd>${access.canMutateCloudWorkspace ? "Available" : "Paused"}</dd></div></dl>
    <p>${detail}</p><p class="field-help">Cloud Control was activated separately with purchased-Pirdy proof. Opening Settings or refreshing data performs reads only; changes require a deliberate Save or action.</p>
    <div class="settings-actions"><button class="button" type="button" data-action="refresh-cloud-settings" ${state.workspaceLoading || reviewMode ? "disabled" : ""}>Refresh Cloud status</button><button class="button" type="button" data-route="billing">Manage Cloud plan</button></div></section>`;
}

function localBackupDate(value) {
  const parsed = value ? new Date(value) : null;
  return parsed && !Number.isNaN(parsed.valueOf())
    ? parsed.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })
    : "time unavailable";
}

function renderEncryptedWorkspaceBackup() {
  const accountReady = Boolean(state.pirdyAccount?.accountId);
  const busy = state.backupBusyKind !== null;
  const unavailable = busy || !accountReady || reviewMode;
  const local = state.localWorkspace?.workspace;
  const localDetail = local
    ? `Restored locally for this Pirdy account · ${array(local.content).length} content item(s) · ${array(local.playlists).length} playlist(s).`
    : state.localWorkspaceRecord
      ? `An encrypted local restore from ${localBackupDate(state.localWorkspaceRecord.exportedAtUtc)} is stored for this Pirdy account. Re-enter its recovery key and file to open it in a new browser session.`
      : "No encrypted backup has been restored into this browser for this Pirdy account.";
  const recovery = state.backupRecoveryKey
    ? `<div class="backup-recovery-key" role="status"><strong>Save this recovery key separately now</strong><p>The downloaded file cannot be opened without it. Pirdy does not store or recover this key, and does not place it on the clipboard.</p><code data-backup-recovery-key>${escapeHtml(state.backupRecoveryKey)}</code></div>`
    : "";
  const storageWarning = state.localWorkspaceStorageError
    ? `<div class="organization-inline-error" role="alert"><p>${escapeHtml(state.localWorkspaceStorageError)} A backup file can still be downloaded, but restore cannot replace the browser-local workspace until storage is available.</p></div>`
    : "";
  const error = state.backupError
    ? `<div class="organization-inline-error" role="alert"><strong>Backup action not completed</strong><p>${escapeHtml(state.backupError)}</p></div>`
    : "";
  return `<section class="card settings-section backup-settings"><div class="section-head compact"><div><h2>Encrypted workspace backup</h2><p>Keep a portable copy before Cloud retention removes large workspace data.</p></div><span class="pill">Account-bound</span></div>
    <div class="info backup-boundary"><strong>Local and explicit.</strong> The file is encrypted in this browser with AES-GCM. Its one-time recovery key is shown separately. Export reads the current workspace; restore writes only this account's encrypted browser-local partition and never activates Cloud Control or uploads anything.</div>
    <div class="backup-grid">
      <section class="backup-pane" aria-labelledby="backup-export-title"><h3 id="backup-export-title">Download encrypted backup</h3><p>Save the file and recovery key in separate secure places. Refresh incomplete account data before exporting.</p>
        <label class="confirmation"><input type="checkbox" data-backup-export-confirm ${unavailable ? "disabled" : ""}/> <span>I understand that losing the separate recovery key makes this backup unusable.</span></label>
        <div class="actions"><button class="button primary" type="button" data-action="download-encrypted-backup" disabled>${state.backupBusyKind === "export" ? "Preparing encrypted file..." : "Download encrypted backup"}</button></div>
        ${recovery}
      </section>
      <form class="backup-pane" data-backup-restore-form aria-labelledby="backup-restore-title" aria-busy="${state.backupBusyKind === "restore"}">
        <h3 id="backup-restore-title">Restore to this browser</h3><p>This replaces only the encrypted browser-local workspace for the signed-in Pirdy account. Current Cloud data and device playback stay unchanged.</p>
        <label>Encrypted Pirdy backup<input name="backupFile" type="file" accept=".pirdybackup,application/vnd.pirdy.workspace-backup+json" required ${unavailable ? "disabled" : ""}/></label>
        <label>Recovery key<input name="recoveryKey" type="password" minlength="43" maxlength="64" required autocomplete="off" autocapitalize="none" spellcheck="false" ${unavailable ? "disabled" : ""}/></label>
        <label class="confirmation"><input name="confirmed" type="checkbox" required ${unavailable ? "disabled" : ""}/> <span>I confirm that this restore may replace the current browser-local workspace for this account. It must not change or upload Cloud data.</span></label>
        <div class="actions"><button class="button" type="submit" ${unavailable ? "disabled" : ""}>${state.backupBusyKind === "restore" ? "Verifying and restoring..." : "Verify and restore locally"}</button></div>
      </form>
    </div>
    <p class="field-help backup-local-status" role="status">${escapeHtml(localDetail)}</p>${storageWarning}${error}
  </section>`;
}

function cloudLifecycleLabel(value) {
  return ({ NotActivated: "Not activated", Trial: "Trial", Active: "Active", Grace: "Grace period", Suspended: "Suspended", Cancelled: "Cancelled", Expired: "Expired" })[value] ?? "Status unavailable";
}

function workspaceSettingsFallback() {
  const me = state.workspace?.me ?? {};
  return {
    displayName: me.displayName ?? displayName(),
    businessName: "",
    customerKind: "Individual",
    countryCode: "IN",
    preferredLanguage: "English",
  };
}

function renderWorkspaceProfileSettings() {
  const draft = state.workspaceSettingsDraft ?? workspaceSettingsFallback();
  const loaded = state.workspaceSettingsSnapshot !== null;
  const writable = canAdministerCloudWorkspace() && loaded && !state.workspaceSettingsLoading &&
    !state.workspaceSettingsSaving && !state.workspaceSettingsError && !reviewMode;
  const disabled = writable ? "" : "disabled";
  const status = state.workspaceSettingsLoading
    ? '<span class="settings-progress" role="status">Loading Cloud profile preferences...</span>'
    : state.workspaceSettingsError
      ? `<div class="organization-inline-error" role="alert"><p>${escapeHtml(state.workspaceSettingsError)}</p><button class="button quiet" type="button" data-action="refresh-workspace-settings">Try again</button></div>`
      : !loaded && !reviewMode
        ? '<p class="muted" role="status">Cloud profile preferences have not been loaded yet.</p>'
        : !hasAdministratorRole() ? '<p class="muted">Cloud profile preferences are read-only for your role.</p>'
          : !canMutateCloudWorkspace() && !reviewMode ? '<p class="muted">Cloud profile changes are paused until Cloud Control is active.</p>' : "";
  return `<section class="card settings-section"><div class="section-head compact"><div><h2>Cloud profile preferences</h2><p>Shared profile details synchronized across Cloud-linked Pirdy apps.</p></div><button class="button" type="button" data-action="refresh-workspace-settings" ${state.workspaceSettingsLoading || state.workspaceSettingsSaving || reviewMode ? "disabled" : ""}>Refresh profile</button></div>
    <form class="settings-form" data-workspace-settings-form aria-busy="${state.workspaceSettingsLoading || state.workspaceSettingsSaving}">
      <div class="settings-form-grid"><label>Display name<input name="displayName" minlength="2" maxlength="80" required autocomplete="name" value="${escapeHtml(draft.displayName)}" ${disabled}></label><label>Customer type<select name="customerKind" ${disabled}><option value="Individual" ${draft.customerKind === "Individual" ? "selected" : ""}>Individual</option><option value="Business" ${draft.customerKind === "Business" ? "selected" : ""}>Business</option></select></label><label>Business name (optional)<input name="businessName" maxlength="80" autocomplete="organization" value="${escapeHtml(draft.businessName)}" ${disabled}></label><label>Country code<input name="countryCode" minlength="2" maxlength="2" pattern="[A-Za-z]{2}" required autocomplete="country" value="${escapeHtml(draft.countryCode)}" ${disabled}></label><label>Preferred language<input name="preferredLanguage" minlength="2" maxlength="40" required autocomplete="language" value="${escapeHtml(draft.preferredLanguage)}" ${disabled}></label></div>
      <p class="field-help">These preferences stay attached to the current Cloud organization. They do not change your Pirdy account, sign-in email, Pirdy ownership, subscription, or local content.</p>${status}
      <div class="actions"><button class="button primary" type="submit" ${writable ? "" : "disabled"}>${state.workspaceSettingsSaving ? "Saving..." : "Save Cloud profile"}</button></div>
    </form></section>`;
}

function renderBillingProfileSettings() {
  if (!hasAdministratorRole())
    return '<section class="card settings-section"><div class="section-head compact"><div><h2>Billing profile</h2><p>Billing contact and legal address.</p></div></div><p class="muted">Only an Organization Administrator can view or change billing-profile details.</p><button class="button" type="button" data-route="billing">View billing and usage</button></section>';
  const fallback = {
    accountType: "Individual",
    billingName: state.workspaceSettingsDraft?.businessName || state.workspaceSettingsDraft?.displayName || displayName(),
    billingEmail: state.workspace?.me?.email ?? state.account?.username ?? "",
    countryCode: state.workspaceSettingsDraft?.countryCode || "IN",
  };
  const draft = state.billingProfileDraft ?? billingProfileDraft(fallback);
  const loaded = state.billingProfile !== null;
  const writable = loaded && !state.billingProfileLoading && !state.billingProfileSaving &&
    !state.billingProfileError && !reviewMode;
  const disabled = writable ? "" : "disabled";
  const india = String(draft.countryCode ?? "").trim().toUpperCase() === "IN";
  const status = state.billingProfileLoading
    ? '<span class="settings-progress" role="status">Loading billing profile...</span>'
    : state.billingProfileError
      ? `<div class="organization-inline-error" role="alert"><p>${escapeHtml(state.billingProfileError)}</p><button class="button quiet" type="button" data-action="refresh-billing-profile">Try again</button></div>`
      : !loaded && !reviewMode ? '<p class="muted" role="status">Billing-profile details have not been loaded yet.</p>' : "";
  return `<section class="card settings-section"><div class="section-head compact"><div><h2>Billing profile</h2><p>Contact, address, and tax details used for future invoices.</p></div><button class="button" type="button" data-action="refresh-billing-profile" ${state.billingProfileLoading || state.billingProfileSaving || reviewMode ? "disabled" : ""}>Refresh billing profile</button></div>
    <form class="settings-form" data-billing-profile-form aria-busy="${state.billingProfileLoading || state.billingProfileSaving}">
      <div class="settings-form-grid"><label>Account type<select name="accountType" ${disabled}><option value="Individual" ${draft.accountType === "Individual" ? "selected" : ""}>Individual</option><option value="Business" ${draft.accountType === "Business" ? "selected" : ""}>Business</option></select></label><label>Billing name<input name="billingName" maxlength="256" required autocomplete="name" value="${escapeHtml(draft.billingName)}" ${disabled}></label><label>Billing email<input name="billingEmail" type="email" maxlength="320" required autocomplete="email" value="${escapeHtml(draft.billingEmail)}" ${disabled}></label><label>Phone (optional)<input name="billingPhone" type="tel" maxlength="32" autocomplete="tel" value="${escapeHtml(draft.billingPhone)}" ${disabled}></label><label class="span-two">Address line 1<input name="addressLine1" maxlength="256" required autocomplete="address-line1" value="${escapeHtml(draft.addressLine1)}" ${disabled}></label><label class="span-two">Address line 2 (optional)<input name="addressLine2" maxlength="256" autocomplete="address-line2" value="${escapeHtml(draft.addressLine2)}" ${disabled}></label><label>City<input name="city" maxlength="128" required autocomplete="address-level2" value="${escapeHtml(draft.city)}" ${disabled}></label><label>State / province<input name="stateOrProvince" maxlength="128" required autocomplete="address-level1" value="${escapeHtml(draft.stateOrProvince)}" ${disabled}></label><label>Postal code<input name="postalCode" maxlength="32" required autocomplete="postal-code" value="${escapeHtml(draft.postalCode)}" ${disabled}></label><label>Country code<input name="countryCode" maxlength="2" minlength="2" pattern="[A-Za-z]{2}" required autocomplete="country" value="${escapeHtml(draft.countryCode)}" ${disabled}></label><label>GST state / UT code<input name="taxRegionCode" maxlength="2" pattern="[0-9]{2}" inputmode="numeric" value="${escapeHtml(draft.taxRegionCode)}" ${india ? "required" : ""} ${disabled || !india ? "disabled" : ""}></label><label>GSTIN (optional)<input name="gstin" maxlength="15" autocomplete="off" value="${escapeHtml(draft.gstin)}" ${disabled || !india ? "disabled" : ""}></label></div>
      <label class="confirmation"><input name="detailsConfirmedByAccountCreator" type="checkbox" ${draft.detailsConfirmedByAccountCreator ? "checked" : ""} ${disabled}> <span>I confirm these billing details are complete and accurate.</span></label>
      <p class="field-help">Billing-profile changes apply only to future invoices. Existing invoices keep their original legal snapshot, and saving this form does not start a payment or change a plan.</p>${status}
      <div class="actions"><button class="button primary" type="submit" ${writable ? "" : "disabled"}>${state.billingProfileSaving ? "Saving..." : "Save billing profile"}</button><button class="button" type="button" data-route="billing">Billing and usage</button></div>
    </form></section>`;
}

function roleLabel(role) {
  if (role == null) return "Customer";
  try { return organizationRoleLabel(role); }
  catch { return String(role); }
}

function renderOrganizationManagement() {
  if (!hasAdministratorRole())
    return '<p class="muted organization-role-note">People and invitation management requires an Organization Administrator.</p>';
  if (reviewMode)
    return '<p class="muted organization-role-note">Organization people are not loaded in visual review. No invitation or member change can be sent.</p>';
  if (!customerCloudAccessPolicy(state.cloudAccess).canReadCloudWorkspace)
    return '<div class="info organization-read-only" role="status"><strong>Organization management is unavailable.</strong> Renew Cloud Control before opening or changing people and invitations.</div>';

  const refreshing = state.organizationMembersLoading || state.organizationInvitationsLoading;
  const writePaused = !canAdminister();
  return `<div class="organization-management" aria-labelledby="organization-people-title">
    <div class="organization-management-head"><div><h3 id="organization-people-title">People and invitations</h3><p>Manage accepted members and invitation history for this organization.</p></div><button class="button" type="button" data-action="refresh-organization" ${refreshing || state.organizationBusyKind ? "disabled" : ""}>${refreshing ? "Refreshing..." : "Refresh people"}</button></div>
    ${writePaused ? `<div class="info organization-read-only" role="status"><strong>Organization management is unavailable.</strong> ${customerCloudAccessPolicy(state.cloudAccess).canReadCloudWorkspace ? "Refresh complete account data before inviting or changing people." : "Renew Cloud Control before opening or changing people and invitations."}</div>` : ""}
    ${state.organizationActionError ? `<div class="organization-action-error" role="alert"><strong>Change not completed</strong><p>${escapeHtml(state.organizationActionError)}</p></div>` : ""}
    ${renderOrganizationConfirmation()}
    <div class="organization-management-grid">
      <section class="organization-pane" aria-labelledby="organization-members-title">
        <div class="organization-pane-head"><div><h4 id="organization-members-title">Members</h4><p>People who accepted an invitation.</p></div>${state.organizationMembersLoading ? '<span class="settings-progress" role="status">Loading members...</span>' : ""}</div>
        ${renderOrganizationMembers()}
      </section>
      <section class="organization-pane" aria-labelledby="organization-invitations-title">
        <div class="organization-pane-head"><div><h4 id="organization-invitations-title">Invitations</h4><p>Invite someone or review invitation history.</p></div>${state.organizationInvitationsLoading ? '<span class="settings-progress" role="status">Loading invitations...</span>' : ""}</div>
        ${renderOrganizationInvitations()}
      </section>
    </div>
  </div>`;
}

function renderOrganizationMembers() {
  const members = state.organizationMembers;
  const error = state.organizationMembersError;
  const errorMarkup = error ? `<div class="organization-inline-error" role="alert"><p>${escapeHtml(error)}</p><button class="button quiet" type="button" data-action="refresh-organization" ${state.organizationMembersLoading ? "disabled" : ""}>Try again</button></div>` : "";
  if (members === null)
    return errorMarkup || '<div class="organization-loading" role="status"><span aria-hidden="true"></span><p>Loading organization members...</p></div>';
  if (!members.length)
    return `${errorMarkup}<div class="organization-empty" role="status"><strong>No accepted members found</strong><p>Accepted invitations will appear here.</p></div>`;

  const selectedIndex = members.findIndex(member => member.userId === state.organizationSelectedMemberId);
  const list = `<div class="organization-member-list" role="list" aria-label="Organization members">${members.map((member, index) => {
    const name = member.displayName ?? member.email ?? member.phone ?? "Organization member";
    const self = member.userId === state.workspace?.me?.userId;
    return `<button type="button" class="organization-member ${index === selectedIndex ? "selected" : ""}" data-organization-member-index="${index}" aria-pressed="${index === selectedIndex}"><span><strong>${escapeHtml(name)}${self ? " (you)" : ""}</strong><small>${escapeHtml(member.email ?? member.phone ?? roleLabel(member.role))}</small></span><span><span class="pill ${member.enabled ? "paid" : ""}">${member.enabled ? "Active" : "Deactivated"}</span><small>${escapeHtml(roleLabel(member.role))}</small></span></button>`;
  }).join("")}</div>`;
  const selected = selectedIndex >= 0 ? members[selectedIndex] : null;
  return `${errorMarkup}${list}${selected ? renderOrganizationMemberEditor(selected) : '<p class="muted organization-selection-help">Select a member to edit their profile details, role, or access.</p>'}`;
}

function renderOrganizationMemberEditor(member) {
  const draft = state.organizationMemberDraft?.userId === member.userId ? state.organizationMemberDraft : member;
  const self = member.userId === state.workspace?.me?.userId;
  const writable = canChangeOrganizationMembers() && !state.organizationBusyKind;
  const busy = state.organizationBusyKind === "member";
  return `<form class="organization-member-editor" data-organization-member-form>
    <div class="organization-editor-title"><div><h5 tabindex="-1">Edit member</h5><p>These are organization profile details, not sign-in methods.</p></div><span class="pill ${member.enabled ? "paid" : ""}">${member.enabled ? "Active" : "Deactivated"}</span></div>
    <div class="organization-form-grid">
      <label>Display name<input name="displayName" maxlength="256" autocomplete="off" value="${escapeHtml(draft.displayName ?? "")}" ${writable ? "" : "disabled"}></label>
      <label>Email<input name="email" type="email" maxlength="320" autocomplete="off" value="${escapeHtml(draft.email ?? "")}" ${writable ? "" : "disabled"}></label>
      <label>Phone<input name="phone" type="tel" maxlength="32" autocomplete="off" value="${escapeHtml(draft.phone ?? "")}" ${writable ? "" : "disabled"}></label>
      <label>Organization role<select name="role" ${writable && !self ? "" : "disabled"}>${organizationRoleOptions.map(role => `<option value="${role.value}" ${role.value === Number(draft.role) ? "selected" : ""}>${escapeHtml(role.label)}</option>`).join("")}</select></label>
    </div>
    ${self ? '<p class="field-help">To prevent lockout, you cannot deactivate yourself or remove your own Organization Administrator role.</p>' : ""}
    <div class="organization-editor-actions"><button class="button primary" type="submit" ${writable ? "" : "disabled"}>${busy ? "Saving..." : "Save member"}</button>${self ? "" : `<button class="button ${member.enabled ? "danger" : ""}" type="button" data-action="change-member-state" ${writable ? "" : "disabled"}>${member.enabled ? "Deactivate" : "Reactivate"}</button>`}</div>
    <div class="form-status" role="status" aria-live="polite">${state.organizationBusyKind === "member" ? "Saving organization member changes..." : ""}</div>
  </form>`;
}

function renderOrganizationInvitations() {
  const invitations = state.organizationInvitations;
  const error = state.organizationInvitationsError;
  const writable = canChangeOrganizationInvitations() && !state.organizationBusyKind;
  const draft = state.organizationInviteDraft;
  const errorMarkup = error ? `<div class="organization-inline-error" role="alert"><p>${escapeHtml(error)}</p><button class="button quiet" type="button" data-action="refresh-organization" ${state.organizationInvitationsLoading ? "disabled" : ""}>Try again</button></div>` : "";
  const success = state.organizationLastInvitation ? `<div class="invitation-ready" role="status" aria-live="polite"><strong>Invitation ready for ${escapeHtml(state.organizationLastInvitation.email)}</strong><p>Share this code only with that person. It expires ${escapeHtml(formatOrganizationDate(state.organizationLastInvitation.expiresAtUtc))}.</p><code>${escapeHtml(state.organizationLastInvitation.invitationId)}</code></div>` : "";
  const form = `<form class="organization-invite-form" data-organization-invite-form>
    <div class="organization-form-grid"><label class="span-two">Email<input name="email" type="email" maxlength="320" required autocomplete="off" value="${escapeHtml(draft.email)}" ${writable ? "" : "disabled"}></label><label class="span-two">Organization role<select name="role" ${writable ? "" : "disabled"}>${organizationRoleOptions.map(role => `<option value="${role.value}" ${role.value === Number(draft.role) ? "selected" : ""}>${escapeHtml(role.label)}</option>`).join("")}</select></label></div>
    <button class="button primary" type="submit" ${writable ? "" : "disabled"}>${state.organizationBusyKind === "invite" ? "Creating invitation..." : "Create invitation"}</button>
  </form>`;
  if (invitations === null)
    return `${form}${success}${errorMarkup || '<div class="organization-loading" role="status"><span aria-hidden="true"></span><p>Loading invitation history...</p></div>'}`;
  const history = invitations.length ? `<div class="organization-invitation-list" role="list" aria-label="Organization invitation history">${invitations.map((invitation, index) => `<article class="organization-invitation" role="listitem"><span><strong>${escapeHtml(invitation.email)}</strong><small>${escapeHtml(roleLabel(invitation.role))} &middot; ${escapeHtml(invitation.status)}</small><small>${invitation.status === "Pending" ? `Expires ${escapeHtml(formatOrganizationDate(invitation.expiresAtUtc))}` : organizationInvitationStatusDate(invitation)}</small></span>${invitation.status === "Pending" ? `<button class="button quiet danger" type="button" data-revoke-invitation-index="${index}" ${writable ? "" : "disabled"}>Revoke</button>` : `<span class="pill ${invitation.status === "Accepted" ? "paid" : ""}">${escapeHtml(invitation.status)}</span>`}</article>`).join("")}</div>` : '<div class="organization-empty" role="status"><strong>No invitation history</strong><p>Create an invitation when someone needs access.</p></div>';
  return `${form}${success}${errorMarkup}${history}`;
}

function renderOrganizationConfirmation() {
  const confirmation = state.organizationConfirmation;
  if (!confirmation) return "";
  return `<section class="organization-confirmation" role="alertdialog" aria-labelledby="organization-confirm-title" aria-describedby="organization-confirm-message"><h4 id="organization-confirm-title">${escapeHtml(confirmation.title)}</h4><p id="organization-confirm-message">${escapeHtml(confirmation.message)}</p><div class="actions"><button class="button danger" type="button" data-action="confirm-organization-change" ${state.organizationBusyKind ? "disabled" : ""}>${escapeHtml(confirmation.actionLabel)}</button><button class="button" type="button" data-action="cancel-organization-change" ${state.organizationBusyKind ? "disabled" : ""}>Cancel</button></div></section>`;
}

function formatOrganizationDate(value) {
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? "at the stated time" : parsed.toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" });
}

function organizationInvitationStatusDate(invitation) {
  const value = invitation.status === "Accepted" ? invitation.acceptedAtUtc : invitation.status === "Revoked" ? invitation.revokedAtUtc : invitation.expiresAtUtc;
  const verb = invitation.status === "Accepted" ? "Accepted" : invitation.status === "Revoked" ? "Revoked" : "Expired";
  return `${verb} ${escapeHtml(formatOrganizationDate(value))}`;
}

function resetOrganizationManagement() {
  state.organizationRequestVersion++;
  state.organizationMutationVersion++;
  state.organizationMembers = null;
  state.organizationInvitations = null;
  state.organizationMembersLoading = false;
  state.organizationInvitationsLoading = false;
  state.organizationMembersError = null;
  state.organizationInvitationsError = null;
  state.organizationActionError = null;
  state.organizationBusyKind = null;
  state.organizationSelectedMemberId = null;
  state.organizationMemberDraft = null;
  state.organizationInviteDraft = { email: "", role: 3 };
  state.organizationLastInvitation = null;
  state.organizationConfirmation = null;
}

function resetCustomerSettings() {
  state.accountProfile = null;
  state.workspaceSettingsRequestVersion++;
  state.billingProfileRequestVersion++;
  state.backupOperationVersion++;
  state.workspaceSettingsSnapshot = null;
  state.workspaceSettingsDraft = null;
  state.workspaceSettingsLoading = false;
  state.workspaceSettingsSaving = false;
  state.workspaceSettingsError = null;
  state.billingProfile = null;
  state.billingProfileDraft = null;
  state.billingProfileLoading = false;
  state.billingProfileSaving = false;
  state.billingProfileError = null;
  state.backupBusyKind = null;
  state.backupError = null;
  state.backupRecoveryKey = null;
  state.backupExportFileName = null;
  state.localWorkspace = null;
  state.localWorkspaceRecord = null;
  state.localWorkspaceStorageError = null;
}

function workspaceBackupScope() {
  return {
    account: state.account,
    pirdyAccount: state.pirdyAccount,
    accountId: String(state.pirdyAccount?.accountId ?? "").trim(),
  };
}

function customerSafeBackupError(message) {
  const error = new Error(message);
  error.customerSafe = true;
  return error;
}

function isCurrentWorkspaceBackupScope(scope) {
  return scope.account === state.account && scope.pirdyAccount === state.pirdyAccount &&
    scope.accountId !== "" && scope.accountId === String(state.pirdyAccount?.accountId ?? "").trim();
}

async function refreshLocalWorkspaceRecord() {
  if (reviewMode || !state.pirdyAccount?.accountId) return;
  const scope = workspaceBackupScope();
  const version = ++state.backupOperationVersion;
  state.localWorkspaceStorageError = null;
  try {
    const record = await localWorkspaceStore.load(scope.accountId);
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    state.localWorkspaceRecord = record;
  } catch (error) {
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    state.localWorkspaceRecord = null;
    state.localWorkspaceStorageError = customerVisibleErrorMessage(error,
      "Encrypted browser-local workspace storage is unavailable. Check browser storage permissions and try again.");
  } finally {
    if (isCurrentWorkspaceBackupScope(scope) && version === state.backupOperationVersion) render();
  }
}

function cloudWorkspaceIsCompleteForBackup() {
  if (!state.workspace || state.workspaceError) return false;
  const required = ["devices", "groups", "sites", "playlists", "content", "branding"];
  return required.every(resource => state.workspace[resource] != null &&
    !state.workspace.resourceErrors?.[resource]);
}

function backupDescriptorMap(values, identityName) {
  const descriptors = array(values);
  if (descriptors.length > encryptedWorkspaceBackupContract.limits.maximumAttachmentCount)
    throw new Error("The workspace attachment count exceeds the browser backup safety limit.");
  const map = new Map();
  for (const value of descriptors) {
    const id = String(value?.[identityName] ?? "").trim();
    if (!id || !value?.downloadUrl || map.has(id))
      throw new Error("Pirdy returned an invalid or duplicate workspace attachment link.");
    map.set(id, value.downloadUrl);
  }
  return map;
}

function validatedBackupAttachmentSize(metadata) {
  const expectedSize = Number(metadata?.fileSize);
  if (!Number.isSafeInteger(expectedSize) || expectedSize <= 0)
    throw new Error("A workspace attachment is missing a valid size.");
  if (expectedSize > encryptedWorkspaceBackupContract.limits.maximumAttachmentBytes)
    throw customerSafeBackupError("A workspace attachment exceeds the browser backup safety limit.");
  return expectedSize;
}

async function readBoundedBackupResponse(response, expectedSize) {
  const maximum = encryptedWorkspaceBackupContract.limits.maximumAttachmentBytes;
  const contentLength = response.headers?.get?.("content-length");
  if (contentLength != null && contentLength !== "") {
    const declared = Number(contentLength);
    if (!Number.isSafeInteger(declared) || declared !== expectedSize || declared > maximum)
      throw new Error("A workspace attachment has an unexpected size.");
  }
  const reader = response.body?.getReader?.();
  if (!reader) {
    const bytes = new Uint8Array(await response.arrayBuffer());
    if (bytes.byteLength !== expectedSize || bytes.byteLength > maximum) {
      bytes.fill(0);
      throw new Error("A workspace attachment has an unexpected size.");
    }
    return bytes;
  }
  const chunks = [];
  let total = 0;
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      const chunk = value instanceof Uint8Array ? value : new Uint8Array(value);
      if (chunk.byteLength === 0) continue;
      if (chunk.byteLength > expectedSize - total || chunk.byteLength > maximum - total) {
        try { await reader.cancel(); } catch { /* size failure remains authoritative */ }
        throw new Error("A workspace attachment has an unexpected size.");
      }
      const copy = chunk.slice();
      chunks.push(copy);
      total += copy.byteLength;
    }
    if (total !== expectedSize)
      throw new Error("A workspace attachment has an unexpected size.");
    const bytes = new Uint8Array(total);
    let offset = 0;
    for (const chunk of chunks) {
      bytes.set(chunk, offset);
      offset += chunk.byteLength;
      chunk.fill(0);
    }
    chunks.length = 0;
    return bytes;
  } catch (error) {
    for (const chunk of chunks) chunk.fill(0);
    throw error;
  } finally { reader.releaseLock?.(); }
}

function trustedContentDownloadUrl(value, message) {
  return trustedArtifactUrl(value, message);
}

async function downloadBackupAttachment(kind, id, downloadUrl, metadata) {
  const expectedSize = validatedBackupAttachmentSize(metadata);
  const url = trustedContentDownloadUrl(downloadUrl, "Pirdy refused an untrusted workspace attachment.");
  let response;
  try { response = await fetch(url, { cache: "no-store" }); }
  catch { throw customerSafeBackupError("A workspace attachment could not be downloaded. Check your connection and try the backup again."); }
  if (!response.ok)
    throw customerSafeBackupError("A workspace attachment could not be downloaded. Refresh your account data and try the backup again.");
  const bytes = await readBoundedBackupResponse(response, expectedSize);
  try {
    const digest = new Uint8Array(await crypto.subtle.digest("SHA-256", bytes));
    const sha256 = [...digest].map(value => value.toString(16).padStart(2, "0")).join("").toUpperCase();
    const expectedHash = String(metadata.sha256 ?? "").trim().toUpperCase();
    if (expectedHash && (!/^[A-F0-9]{64}$/u.test(expectedHash) || sha256 !== expectedHash))
      throw new Error("A workspace attachment failed SHA-256 verification.");
    return {
      kind,
      id,
      fileName: String(metadata.fileName ?? id),
      contentType: String(metadata.contentType ?? "application/octet-stream"),
      sha256,
      byteLength: bytes.length,
      bytes: encodeBackupAttachmentBytes(bytes),
    };
  } finally { bytes.fill(0); }
}

async function completeCloudWorkspaceForBackup(scope) {
  if (!cloudWorkspaceIsCompleteForBackup())
    throw new Error("Refresh the complete Cloud workspace before downloading a backup.");
  const sourceWorkspace = state.workspace;
  const workspace = structuredClone(sourceWorkspace);
  const summaries = array(sourceWorkspace.playlists);
  const playlistDetails = await Promise.all(summaries.map(async summary => {
    const id = String(summary?.id ?? summary?.playlistId ?? "").trim();
    if (!id) throw new Error("A saved playlist is missing its workspace identity.");
    const detail = await loadPlaylist(id);
    const returnedId = String(detail?.id ?? detail?.playlistId ?? "").trim();
    const itemsAreList = Array.isArray(detail?.items) || Array.isArray(detail?.items?.items) ||
      Array.isArray(detail?.items?.value);
    if (returnedId !== id || !itemsAreList)
      throw new Error("A saved playlist could not be verified for backup.");
    return detail;
  }));
  if (!isCurrentWorkspaceBackupScope(scope) || sourceWorkspace !== state.workspace)
    throw new Error("The signed-in workspace changed while the backup was being prepared.");
  workspace.playlists = playlistDetails;

  const content = array(sourceWorkspace.content);
  if (!content.length) return { accountId: scope.accountId, workspace, attachments: [] };
  if (content.length > encryptedWorkspaceBackupContract.limits.maximumAttachmentCount)
    throw new Error("The workspace attachment count exceeds the browser backup safety limit.");
  const [sourceLinks, mediaLinks] = await Promise.all([
    createContentSourceDownloads(), createMediaDownloads(),
  ]);
  if (!isCurrentWorkspaceBackupScope(scope) || sourceWorkspace !== state.workspace)
    throw new Error("The signed-in workspace changed while the backup was being prepared.");
  const sourcesById = backupDescriptorMap(sourceLinks, "sourceId");
  const mediaById = backupDescriptorMap(mediaLinks, "assetId");
  const sourceMetadata = new Map();
  for (const asset of content) {
    const sourceId = String(asset?.logicalSourceAssetId ?? "").trim();
    if (sourceId && !sourceMetadata.has(sourceId)) sourceMetadata.set(sourceId, {
      fileName: asset.sourceFileName ?? `${asset.name ?? sourceId}.source`,
      contentType: asset.sourceContentType ?? "application/octet-stream",
      fileSize: asset.sourceFileSize,
      sha256: asset.sourceSha256,
    });
  }
  const attachmentRequests = [...sourceMetadata].map(([id, metadata]) => {
    const link = sourcesById.get(id);
    if (!link) throw new Error("Original artwork required by this workspace is unavailable for backup.");
    return { kind: "ContentSource", id, link, metadata };
  });
  attachmentRequests.push(...content.map(asset => {
    const id = String(asset?.assetId ?? asset?.id ?? "").trim();
    const link = mediaById.get(id);
    if (!id || !link) throw new Error("Prepared content required by this workspace is unavailable for backup.");
    return { kind: "PreparedContent", id, link, metadata: {
      fileName: `${asset.name ?? id}.${asset.extension ?? "pimg"}`,
      contentType: "application/octet-stream",
      fileSize: asset.fileSize,
      sha256: asset.sha256,
    } };
  }));
  const limits = encryptedWorkspaceBackupContract.limits;
  if (attachmentRequests.length > limits.maximumAttachmentCount)
    throw new Error("The workspace attachment count exceeds the browser backup safety limit.");
  let decodedBytes = 0;
  for (const request of attachmentRequests) {
    const size = validatedBackupAttachmentSize(request.metadata);
    if (size > limits.maximumDecodedAttachmentBytes - decodedBytes)
      throw new Error("The workspace attachment total exceeds the browser backup safety limit.");
    decodedBytes += size;
  }
  const attachments = await Promise.all(attachmentRequests.map(request =>
    downloadBackupAttachment(request.kind, request.id, request.link, request.metadata)));
  if (!isCurrentWorkspaceBackupScope(scope) || sourceWorkspace !== state.workspace)
    throw new Error("The signed-in workspace changed while the backup was being prepared.");
  return { accountId: scope.accountId, workspace, attachments };
}

async function workspaceBundleForBackup(scope) {
  const access = customerCloudAccessPolicy(state.cloudAccess);
  const local = state.localWorkspace?.accountId === scope.accountId ? state.localWorkspace : null;
  if (local && (access.requiresLocalRehydration || !cloudWorkspaceIsCompleteForBackup()))
    return structuredClone(local);
  return completeCloudWorkspaceForBackup(scope);
}

async function exportEncryptedWorkspaceBackup({ confirmed = false } = {}) {
  if (state.backupBusyKind) return;
  const confirmation = confirmed || app.querySelector("[data-backup-export-confirm]")?.checked === true;
  if (!confirmation) {
    state.backupError = "Confirm that you will save the separate recovery key before downloading.";
    render();
    return;
  }
  const scope = workspaceBackupScope();
  if (!scope.accountId) {
    state.backupError = "Sign in to a verified Pirdy account before downloading a backup.";
    render();
    return;
  }
  const version = ++state.backupOperationVersion;
  state.backupBusyKind = "export";
  state.backupError = null;
  render();
  let result;
  try {
    const bundle = await workspaceBundleForBackup(scope);
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    result = await createEncryptedWorkspaceBackup(bundle);
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    downloadEncryptedWorkspaceBackup(result);
    state.backupRecoveryKey = result.recoveryKey;
    state.backupExportFileName = result.fileName;
  } catch (error) {
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    state.backupError = `${customerVisibleErrorMessage(error,
      "The encrypted backup could not be created. Check the selected file and browser storage, then try again.")} No local or Cloud workspace data was changed.`;
  } finally {
    result?.bytes?.fill?.(0);
    if (isCurrentWorkspaceBackupScope(scope) && version === state.backupOperationVersion) {
      state.backupBusyKind = null;
      render();
      if (!state.backupError)
        notify("Encrypted backup downloaded. Save the recovery key separately before leaving this page.", "success");
    }
  }
}

async function restoreEncryptedWorkspaceLocally(event) {
  event?.preventDefault?.();
  if (state.backupBusyKind) return;
  const form = event?.currentTarget ?? app.querySelector("[data-backup-restore-form]");
  const file = form?.elements?.backupFile?.files?.[0];
  const recoveryKey = String(form?.elements?.recoveryKey?.value ?? "").trim();
  if (form?.elements?.confirmed?.checked !== true) {
    state.backupError = "Confirm the browser-local replacement before restoring.";
    render();
    return;
  }
  if (!file || !recoveryKey) {
    state.backupError = "Choose an encrypted Pirdy backup file and enter its separate recovery key.";
    render();
    return;
  }
  if (!Number.isSafeInteger(file.size) || file.size <= 0 ||
      file.size > encryptedWorkspaceBackupContract.limits.maximumEncryptedFileBytes) {
    state.backupError = "The encrypted Pirdy backup file has an invalid or unsafe size. Nothing was restored.";
    render();
    return;
  }
  const scope = workspaceBackupScope();
  if (!scope.accountId) {
    state.backupError = "Sign in to the Pirdy account that owns this backup before restoring it.";
    render();
    return;
  }
  const version = ++state.backupOperationVersion;
  state.backupBusyKind = "restore";
  state.backupError = null;
  render();
  let bytes;
  try {
    bytes = new Uint8Array(await file.arrayBuffer());
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    const restored = await restoreEncryptedWorkspaceBackup(bytes, recoveryKey, scope.accountId);
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    const record = await localWorkspaceStore.replace(scope.accountId, bytes, restored);
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    state.localWorkspace = restored.bundle;
    state.localWorkspaceRecord = record;
    state.localWorkspaceStorageError = null;
    state.backupRecoveryKey = null;
    state.backupExportFileName = null;
  } catch (error) {
    if (!isCurrentWorkspaceBackupScope(scope) || version !== state.backupOperationVersion) return;
    state.backupError = `${customerVisibleErrorMessage(error,
      "The encrypted backup could not be restored. Verify the backup file and recovery key, then try again.")} The existing browser-local and Cloud workspaces are unchanged.`;
  } finally {
    bytes?.fill?.(0);
    if (isCurrentWorkspaceBackupScope(scope) && version === state.backupOperationVersion) {
      state.backupBusyKind = null;
      render();
      if (!state.backupError)
        notify("Encrypted backup verified and restored locally. Nothing was uploaded or activated in Cloud.", "success");
    }
  }
}

function customerSettingsScope() {
  return {
    account: state.account,
    organizationId: String(state.workspace?.me?.organizationId ?? ""),
    accountId: String(state.pirdyAccount?.accountId ?? ""),
  };
}

function isCurrentCustomerSettingsScope(scope) {
  return scope.account === state.account && scope.organizationId !== "" &&
    scope.organizationId === String(state.workspace?.me?.organizationId ?? "") &&
    scope.accountId === String(state.pirdyAccount?.accountId ?? "");
}

async function refreshWorkspaceSettings({ announce = true } = {}) {
  if (reviewMode || !state.workspace) return;
  const scope = customerSettingsScope();
  if (!scope.organizationId) return;
  const requestVersion = ++state.workspaceSettingsRequestVersion;
  state.workspaceSettingsLoading = true;
  state.workspaceSettingsError = null;
  render();
  try {
    const response = await loadWorkspaceSettingsSnapshot();
    if (!isCurrentCustomerSettingsScope(scope) || requestVersion !== state.workspaceSettingsRequestVersion) return;
    const snapshot = readWorkspaceSettingsSnapshot(response, scope.organizationId, workspaceSettingsFallback());
    state.workspaceSettingsSnapshot = snapshot;
    state.workspaceSettingsDraft = { ...snapshot.preferences };
    if (announce) notify("Cloud profile preferences are up to date.", "success");
  } catch (error) {
    if (!isCurrentCustomerSettingsScope(scope) || requestVersion !== state.workspaceSettingsRequestVersion) return;
    state.workspaceSettingsError = organizationFailureMessage(error, "Cloud profile preferences could not be loaded.");
    if (announce) notify(`${state.workspaceSettingsError} Existing profile values were not changed.`, "error");
  } finally {
    if (isCurrentCustomerSettingsScope(scope) && requestVersion === state.workspaceSettingsRequestVersion) {
      state.workspaceSettingsLoading = false;
      render();
    }
  }
}

function syncWorkspaceSettingsDraft(form) {
  const elements = form?.elements;
  if (!elements) return;
  state.workspaceSettingsDraft = {
    displayName: String(elements.displayName?.value ?? ""),
    businessName: String(elements.businessName?.value ?? ""),
    customerKind: String(elements.customerKind?.value ?? ""),
    countryCode: String(elements.countryCode?.value ?? ""),
    preferredLanguage: String(elements.preferredLanguage?.value ?? ""),
  };
}

async function saveWorkspaceSettings(event) {
  event?.preventDefault?.();
  const form = event?.currentTarget;
  syncWorkspaceSettingsDraft(form);
  if (form?.reportValidity && !form.reportValidity()) return;
  if (!hasAdministratorRole()) return notify("Only an Organization Administrator can change Cloud profile preferences.", "error");
  if (!canMutateCloudWorkspace()) return notify("Cloud profile changes are paused until Cloud Control is active and account data is refreshed.", "error");
  if (!state.workspaceSettingsSnapshot) return notify("Refresh Cloud profile preferences before saving.", "error");
  if (state.workspaceSettingsError) return notify("Refresh Cloud profile preferences before retrying this save.", "error");

  const scope = customerSettingsScope();
  let preferences;
  let upload;
  try {
    preferences = normalizeWorkspaceSettings(state.workspaceSettingsDraft);
    upload = createWorkspaceSettingsUpload(state.workspaceSettingsSnapshot, scope.accountId, preferences);
  } catch (error) {
    return notify(customerVisibleErrorMessage(error,
      "Review the Cloud preferences and try again. No settings were changed."), "error");
  }

  const requestVersion = ++state.workspaceSettingsRequestVersion;
  state.workspaceSettingsDraft = { ...preferences };
  state.workspaceSettingsSaving = true;
  state.workspaceSettingsError = null;
  render();
  try {
    const response = await updateWorkspaceSettings(upload);
    if (!isCurrentCustomerSettingsScope(scope) || requestVersion !== state.workspaceSettingsRequestVersion) return;
    const snapshot = readWorkspaceSettingsSnapshot(response, scope.organizationId, preferences);
    state.workspaceSettingsSnapshot = snapshot;
    state.workspaceSettingsDraft = { ...snapshot.preferences };
    notify("Cloud profile preferences saved. Other Pirdy apps will see them after refresh.", "success");
  } catch (error) {
    if (!isCurrentCustomerSettingsScope(scope) || requestVersion !== state.workspaceSettingsRequestVersion) return;
    state.workspaceSettingsError = organizationFailureMessage(error, "Cloud profile preferences could not be saved.");
    notify(`${state.workspaceSettingsError} Your typed values are retained; refresh before retrying.`, "error");
  } finally {
    if (isCurrentCustomerSettingsScope(scope) && requestVersion === state.workspaceSettingsRequestVersion) {
      state.workspaceSettingsSaving = false;
      render();
    }
  }
}

function verifiedBillingProfile(value, expectedOrganizationId) {
  if (!value || String(value.organizationId ?? "") !== expectedOrganizationId ||
      typeof value.rowVersion !== "string" || !/^[A-Za-z0-9+/]{11}=$/u.test(value.rowVersion))
    throw new Error("Pirdy returned invalid billing-profile metadata.");
  const profile = normalizeBillingProfile({ ...value, detailsConfirmedByAccountCreator: true });
  return { organizationId: expectedOrganizationId, ...profile, rowVersion: value.rowVersion };
}

async function refreshBillingProfile({ announce = true } = {}) {
  if (reviewMode || !hasAdministratorRole()) return;
  const scope = customerSettingsScope();
  if (!scope.organizationId) return;
  const requestVersion = ++state.billingProfileRequestVersion;
  state.billingProfileLoading = true;
  state.billingProfileError = null;
  render();
  try {
    const response = await loadBillingProfile();
    if (!isCurrentCustomerSettingsScope(scope) || requestVersion !== state.billingProfileRequestVersion) return;
    const profile = verifiedBillingProfile(response, scope.organizationId);
    state.billingProfile = profile;
    state.billingProfileDraft = billingProfileDraft(profile);
    if (announce) notify("Billing profile is up to date.", "success");
  } catch (error) {
    if (!isCurrentCustomerSettingsScope(scope) || requestVersion !== state.billingProfileRequestVersion) return;
    state.billingProfileError = organizationFailureMessage(error, "Billing profile could not be loaded.");
    if (announce) notify(`${state.billingProfileError} Existing billing values were not changed.`, "error");
  } finally {
    if (isCurrentCustomerSettingsScope(scope) && requestVersion === state.billingProfileRequestVersion) {
      state.billingProfileLoading = false;
      render();
    }
  }
}

function syncBillingProfileDraft(form) {
  const elements = form?.elements;
  if (!elements) return;
  state.billingProfileDraft = {
    accountType: String(elements.accountType?.value ?? ""),
    billingName: String(elements.billingName?.value ?? ""),
    billingEmail: String(elements.billingEmail?.value ?? ""),
    billingPhone: String(elements.billingPhone?.value ?? ""),
    addressLine1: String(elements.addressLine1?.value ?? ""),
    addressLine2: String(elements.addressLine2?.value ?? ""),
    city: String(elements.city?.value ?? ""),
    stateOrProvince: String(elements.stateOrProvince?.value ?? ""),
    postalCode: String(elements.postalCode?.value ?? ""),
    countryCode: String(elements.countryCode?.value ?? ""),
    taxRegionCode: String(elements.taxRegionCode?.value ?? ""),
    gstin: String(elements.gstin?.value ?? ""),
    detailsConfirmedByAccountCreator: elements.detailsConfirmedByAccountCreator?.checked === true,
  };
}

function applyBillingCountryRules(form) {
  const elements = form?.elements;
  if (!elements) return;
  const india = String(elements.countryCode?.value ?? "").trim().toUpperCase() === "IN";
  const writable = state.billingProfile !== null && !state.billingProfileLoading &&
    !state.billingProfileSaving && !state.billingProfileError && !reviewMode;
  if (elements.taxRegionCode) elements.taxRegionCode.required = india;
  if (elements.taxRegionCode) elements.taxRegionCode.disabled = !india || !writable;
  if (elements.gstin) elements.gstin.disabled = !india || !writable;
  if (!india) {
    if (elements.taxRegionCode) elements.taxRegionCode.value = "";
    if (elements.gstin) elements.gstin.value = "";
  }
  syncBillingProfileDraft(form);
}

async function saveBillingProfile(event) {
  event?.preventDefault?.();
  const form = event?.currentTarget;
  syncBillingProfileDraft(form);
  if (form?.reportValidity && !form.reportValidity()) return;
  if (!hasAdministratorRole()) return notify("Only an Organization Administrator can change billing-profile details.", "error");
  if (!state.billingProfile) return notify("Refresh the billing profile before saving.", "error");
  if (state.billingProfileError) return notify("Refresh the billing profile before retrying this save.", "error");

  const scope = customerSettingsScope();
  let payload;
  try {
    payload = createBillingProfileUpdate(state.billingProfileDraft, state.billingProfile.rowVersion);
  } catch (error) {
    return notify(customerVisibleErrorMessage(error,
      "Review the billing details and try again. No billing information was changed."), "error");
  }

  const requestVersion = ++state.billingProfileRequestVersion;
  state.billingProfileDraft = { ...payload.profile };
  state.billingProfileSaving = true;
  state.billingProfileError = null;
  render();
  try {
    const response = await updateBillingProfile(payload);
    if (!isCurrentCustomerSettingsScope(scope) || requestVersion !== state.billingProfileRequestVersion) return;
    const profile = verifiedBillingProfile(response, scope.organizationId);
    state.billingProfile = profile;
    state.billingProfileDraft = billingProfileDraft(profile);
    notify("Billing profile saved for future invoices. No plan or payment was changed.", "success");
  } catch (error) {
    if (!isCurrentCustomerSettingsScope(scope) || requestVersion !== state.billingProfileRequestVersion) return;
    state.billingProfileError = organizationFailureMessage(error, "Billing profile could not be saved.");
    notify(`${state.billingProfileError} Your typed values are retained; refresh before retrying.`, "error");
  } finally {
    if (isCurrentCustomerSettingsScope(scope) && requestVersion === state.billingProfileRequestVersion) {
      state.billingProfileSaving = false;
      render();
    }
  }
}

function organizationRequestScope() {
  return {
    account: state.account,
    workspace: state.workspace,
    organizationId: String(state.workspace?.me?.organizationId ?? ""),
  };
}

function isCurrentOrganizationScope(scope) {
  return scope.account === state.account && scope.workspace === state.workspace &&
    scope.organizationId !== "" && scope.organizationId === String(state.workspace?.me?.organizationId ?? "");
}

async function refreshOrganizationManagement({ announce = true } = {}) {
  if (reviewMode || !hasAdministratorRole() ||
      !customerCloudAccessPolicy(state.cloudAccess).canReadCloudWorkspace) return;
  const scope = organizationRequestScope();
  if (!scope.organizationId) return;
  const requestVersion = ++state.organizationRequestVersion;
  state.organizationMembersLoading = true;
  state.organizationInvitationsLoading = true;
  state.organizationMembersError = null;
  state.organizationInvitationsError = null;
  state.organizationActionError = null;
  state.organizationConfirmation = null;
  render();
  const [membersResult, invitationsResult] = await Promise.allSettled([
    loadOrganizationUsers(), loadOrganizationInvitations(),
  ]);
  if (!isCurrentOrganizationScope(scope) || requestVersion !== state.organizationRequestVersion) return;

  if (membersResult.status === "fulfilled") {
    try {
      state.organizationMembers = organizationRecords(membersResult.value, "organization members").map(normalizeOrganizationMember);
      state.organizationMembersError = null;
      if (state.organizationSelectedMemberId && !state.organizationMembers.some(member => member.userId === state.organizationSelectedMemberId)) {
        state.organizationSelectedMemberId = null;
        state.organizationMemberDraft = null;
      }
    } catch (error) {
      state.organizationMembersError = organizationFailureMessage(error, "Organization members could not be verified.");
    }
  } else state.organizationMembersError = organizationFailureMessage(membersResult.reason, "Organization members could not be loaded.");

  if (invitationsResult.status === "fulfilled") {
    try {
      state.organizationInvitations = organizationRecords(invitationsResult.value, "organization invitations").map(normalizeOrganizationInvitation);
      state.organizationInvitationsError = null;
    } catch (error) {
      state.organizationInvitationsError = organizationFailureMessage(error, "Invitation history could not be verified.");
    }
  } else state.organizationInvitationsError = organizationFailureMessage(invitationsResult.reason, "Invitation history could not be loaded.");

  state.organizationMembersLoading = false;
  state.organizationInvitationsLoading = false;
  render();
  if (!announce) return;
  if (!state.organizationMembersError && !state.organizationInvitationsError)
    notify("Organization members and invitations are up to date.", "success");
  else notify("Some organization settings could not be refreshed. Existing account access was not changed.", "error");
}

function organizationRecords(value, label) {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.items)) return value.items;
  if (Array.isArray(value?.value)) return value.value;
  throw new Error(`Pirdy returned invalid ${label}.`);
}

function organizationFailureMessage(error, fallback) {
  if (error?.status === 401 || error?.status === 403)
    return "Your current organization role does not allow this action. Refresh your account or ask an Organization Administrator.";
  return customerVisibleErrorMessage(error, fallback);
}

function canChangeOrganizationMembers() {
  return canAdminister() && Array.isArray(state.organizationMembers) &&
    !state.organizationMembersLoading && !state.organizationMembersError;
}

function canChangeOrganizationInvitations() {
  return canAdminister() && Array.isArray(state.organizationInvitations) &&
    !state.organizationInvitationsLoading && !state.organizationInvitationsError;
}

function selectOrganizationMember(index) {
  const member = state.organizationMembers?.[Number(index)];
  if (!member) return;
  state.organizationSelectedMemberId = member.userId;
  state.organizationMemberDraft = { ...member };
  state.organizationActionError = null;
  state.organizationConfirmation = null;
  render();
  app.querySelector(".organization-member-editor h5")?.focus?.();
}

function organizationMemberFromForm(form, enabled) {
  const member = state.organizationMembers?.find(value => value.userId === state.organizationSelectedMemberId);
  if (!member) throw new Error("Select an organization member first.");
  const self = member.userId === state.workspace?.me?.userId;
  const draft = state.organizationMemberDraft?.userId === member.userId ? state.organizationMemberDraft : member;
  return organizationMemberUpdate(member, {
    displayName: form?.elements?.displayName?.value ?? draft.displayName,
    email: form?.elements?.email?.value ?? draft.email,
    phone: form?.elements?.phone?.value ?? draft.phone,
    role: self ? member.role : form?.elements?.role?.value ?? draft.role,
  }, self ? member.enabled : enabled);
}

async function saveOrganizationMember(event) {
  event.preventDefault();
  if (!canChangeOrganizationMembers() || state.organizationBusyKind) return rejectOrganizationWrite();
  try {
    const member = state.organizationMembers.find(value => value.userId === state.organizationSelectedMemberId);
    await performOrganizationMemberUpdate(organizationMemberFromForm(event.currentTarget, member.enabled));
  } catch (error) {
    state.organizationActionError = organizationFailureMessage(error, "The organization member could not be updated.");
    render();
  }
}

function requestOrganizationMemberStateChange() {
  if (!canChangeOrganizationMembers() || state.organizationBusyKind) return rejectOrganizationWrite();
  try {
    const member = state.organizationMembers.find(value => value.userId === state.organizationSelectedMemberId);
    if (!member || member.userId === state.workspace?.me?.userId) return;
    const payload = organizationMemberFromForm(app.querySelector("[data-organization-member-form]"), !member.enabled);
    const name = payload.displayName ?? payload.email ?? "This member";
    state.organizationMemberDraft = payload;
    state.organizationConfirmation = {
      kind: "member",
      payload,
      title: member.enabled ? "Deactivate organization member" : "Reactivate organization member",
      message: member.enabled
        ? `${name} will no longer be able to access this organization. You can reactivate them later.`
        : `${name} will regain the access allowed by ${roleLabel(payload.role)}.`,
      actionLabel: member.enabled ? "Deactivate" : "Reactivate",
    };
    state.organizationActionError = null;
    render();
    app.querySelector('[data-action="confirm-organization-change"]')?.focus?.();
  } catch (error) {
    state.organizationActionError = organizationFailureMessage(error, "The member change could not be prepared.");
    render();
  }
}

async function performOrganizationMemberUpdate(payload) {
  if (!canChangeOrganizationMembers() || state.organizationBusyKind) return rejectOrganizationWrite();
  const scope = organizationRequestScope();
  const mutationVersion = ++state.organizationMutationVersion;
  state.organizationMemberDraft = payload;
  state.organizationBusyKind = "member";
  state.organizationActionError = null;
  render();
  try {
    const response = await updateOrganizationUser(payload.userId, payload);
    if (!isCurrentOrganizationScope(scope) || mutationVersion !== state.organizationMutationVersion) return;
    const confirmed = confirmOrganizationMemberUpdate(response, payload);
    state.organizationMembers = state.organizationMembers.map(member => member.userId === confirmed.userId ? confirmed : member);
    state.organizationMemberDraft = { ...confirmed };
    state.organizationConfirmation = null;
    notify(`${confirmed.displayName ?? confirmed.email ?? "Organization member"} is ${confirmed.enabled ? "active" : "deactivated"} as ${roleLabel(confirmed.role)}.`, "success");
  } catch (error) {
    if (!isCurrentOrganizationScope(scope) || mutationVersion !== state.organizationMutationVersion) return;
    state.organizationActionError = organizationFailureMessage(error, "The organization member could not be updated. No change was confirmed.");
  } finally {
    if (isCurrentOrganizationScope(scope) && mutationVersion === state.organizationMutationVersion) {
      state.organizationBusyKind = null;
      render();
    }
  }
}

async function submitOrganizationInvitation(event) {
  event.preventDefault();
  if (!canChangeOrganizationInvitations() || state.organizationBusyKind) return rejectOrganizationWrite();
  let request;
  try {
    request = organizationInvitationRequest({ email: event.currentTarget.elements.email.value, role: event.currentTarget.elements.role.value });
  } catch (error) {
    state.organizationActionError = organizationFailureMessage(error, "Enter valid invitation details.");
    render();
    return;
  }
  const scope = organizationRequestScope();
  const mutationVersion = ++state.organizationMutationVersion;
  state.organizationInviteDraft = request;
  state.organizationBusyKind = "invite";
  state.organizationActionError = null;
  state.organizationLastInvitation = null;
  render();
  try {
    const response = await inviteOrganizationUser(request);
    if (!isCurrentOrganizationScope(scope) || mutationVersion !== state.organizationMutationVersion) return;
    const confirmed = confirmOrganizationInvitation(response, { request });
    state.organizationInvitations = [confirmed, ...state.organizationInvitations.filter(value => value.invitationId !== confirmed.invitationId)];
    state.organizationInviteDraft = { email: "", role: 3 };
    state.organizationLastInvitation = confirmed;
    notify(`Invitation ready for ${confirmed.email}.`, "success");
  } catch (error) {
    if (!isCurrentOrganizationScope(scope) || mutationVersion !== state.organizationMutationVersion) return;
    state.organizationActionError = organizationFailureMessage(error, "The invitation could not be created. No membership was changed.");
  } finally {
    if (isCurrentOrganizationScope(scope) && mutationVersion === state.organizationMutationVersion) {
      state.organizationBusyKind = null;
      render();
    }
  }
}

function requestOrganizationInvitationRevoke(index) {
  if (!canChangeOrganizationInvitations() || state.organizationBusyKind) return rejectOrganizationWrite();
  const invitation = state.organizationInvitations?.[Number(index)];
  if (!invitation || invitation.status !== "Pending") return;
  state.organizationConfirmation = {
    kind: "invitation",
    invitationId: invitation.invitationId,
    title: "Revoke invitation",
    message: `${invitation.email} will no longer be able to use this invitation code.`,
    actionLabel: "Revoke invitation",
  };
  state.organizationActionError = null;
  render();
  app.querySelector('[data-action="confirm-organization-change"]')?.focus?.();
}

async function performOrganizationInvitationRevoke(invitationId) {
  if (!canChangeOrganizationInvitations() || state.organizationBusyKind) return rejectOrganizationWrite();
  const scope = organizationRequestScope();
  const mutationVersion = ++state.organizationMutationVersion;
  state.organizationBusyKind = "revoke";
  state.organizationActionError = null;
  render();
  try {
    const response = await revokeOrganizationInvitation(invitationId);
    if (!isCurrentOrganizationScope(scope) || mutationVersion !== state.organizationMutationVersion) return;
    const confirmed = confirmOrganizationInvitation(response, { invitationId, status: "Revoked" });
    state.organizationInvitations = state.organizationInvitations.map(value => value.invitationId === confirmed.invitationId ? confirmed : value);
    state.organizationConfirmation = null;
    if (state.organizationLastInvitation?.invitationId === confirmed.invitationId) state.organizationLastInvitation = null;
    notify(`Invitation for ${confirmed.email} was revoked.`, "success");
  } catch (error) {
    if (!isCurrentOrganizationScope(scope) || mutationVersion !== state.organizationMutationVersion) return;
    state.organizationActionError = organizationFailureMessage(error, "The invitation could not be revoked. No change was confirmed.");
  } finally {
    if (isCurrentOrganizationScope(scope) && mutationVersion === state.organizationMutationVersion) {
      state.organizationBusyKind = null;
      render();
    }
  }
}

function confirmOrganizationChange() {
  const confirmation = state.organizationConfirmation;
  if (!confirmation || state.organizationBusyKind) return;
  if (confirmation.kind === "member") return performOrganizationMemberUpdate(confirmation.payload);
  if (confirmation.kind === "invitation") return performOrganizationInvitationRevoke(confirmation.invitationId);
}

function rejectOrganizationWrite() {
  const message = canMutateCloudWorkspace()
    ? "Organization settings are not ready to change. Refresh people and try again."
    : "Cloud Control is unavailable. Renew and refresh Cloud Control before opening or changing people and invitations.";
  state.organizationActionError = message;
  render();
}

function supportCategoryLabel(category) {
  return ({
    DisplayControl: "Pirdy display control",
    ContentAndPlaylists: "Content or playlists",
    UsbAndLocal: "USB-C or Local Control",
    WirelessRetrieval: "Wireless Retrieval",
    CloudAndSync: "Cloud publishing or sync",
    BillingAndSubscription: "Billing or subscription",
    AccountAndSignIn: "Account or sign-in",
    FirmwareAndUpdates: "Firmware or updates",
    Other: "Other",
  })[category] ?? String(category ?? "General");
}

function supportStatusLabel(status) {
  return ({ InProgress: "In progress", WaitingForCustomer: "Waiting for you" })[status]
    ?? String(status ?? "Submitted");
}

function supportTicketDate(ticket) {
  const value = ticket?.createdAtUtc ?? ticket?.createdAt ?? ticket?.submittedAtUtc;
  if (!value) return "Submitted";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? "Submitted" : parsed.toLocaleString("en-IN", {
    day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit",
  });
}

function supportFailureMessage(error, sending = false) {
  if (error?.status === 404 || error?.status === 501)
    return sending
      ? "Support requests are temporarily unavailable here. Your message was not sent."
      : "Support request history is temporarily unavailable here.";
  return customerVisibleErrorMessage(error,
    sending ? "The support request could not be sent. Review it and try again." : "Support requests could not be loaded. Try again.");
}

async function refreshSupportTickets({ announce = false } = {}) {
  if (state.supportLoading || !state.workspace) return;
  if (reviewMode) {
    state.supportTickets = [];
    state.supportError = null;
    render();
    return;
  }
  const account = state.account;
  const organization = state.workspace?.me?.organizationId;
  const isCurrent = () => state.account === account && state.workspace?.me?.organizationId === organization;
  state.supportLoading = true;
  state.supportError = null;
  render();
  try {
    const result = await loadSupportTickets();
    if (!isCurrent()) return;
    const tickets = Array.isArray(result) ? result
      : Array.isArray(result?.items) ? result.items
      : Array.isArray(result?.value) ? result.value
      : null;
    if (!tickets) throw new Error("Pirdy returned an unreadable support-request list.");
    state.supportTickets = tickets;
    if (announce) notify("Support requests are up to date.", "success");
  } catch (error) {
    if (!isCurrent()) return;
    state.supportError = supportFailureMessage(error);
    if (announce) notify(state.supportError, "error");
  } finally {
    if (isCurrent()) {
      state.supportLoading = false;
      render();
    }
  }
}

function toggleSupportOther(select) {
  const container = app.querySelector("[data-support-other]");
  const input = container?.querySelector("input");
  const other = select?.value === "Other";
  container?.classList.toggle("hidden", !other);
  if (input) input.required = other;
}

async function submitSupportTicket(event) {
  event?.preventDefault();
  const form = event?.currentTarget ?? app.querySelector("#support-ticket-form");
  if (!form || state.supportSubmitting || !state.workspace) return;
  let payload;
  try {
    payload = supportTicketPayload({
      category: form.elements.category.value,
      otherCategory: form.elements.otherCategory.value,
      subject: form.elements.subject.value,
      description: form.elements.description.value,
    });
  } catch (error) {
    notify(customerVisibleErrorMessage(error,
      "Review the issue type, subject, and description, then try again."), "error");
    return;
  }
  if (reviewMode) return notify("Visual review only: no support request was sent.", "success");
  const account = state.account;
  const organization = state.workspace?.me?.organizationId;
  const isCurrent = () => state.account === account && state.workspace?.me?.organizationId === organization;
  const button = form.querySelector('button[type="submit"]');
  const formStatus = form.querySelector("[data-support-status]");
  state.supportSubmitting = true;
  if (button) { button.disabled = true; button.textContent = "Sending..."; }
  if (formStatus) formStatus.textContent = "Sending your support request...";
  try {
    const result = await createSupportTicket(payload);
    if (!isCurrent()) return;
    const ticket = result?.ticket ?? result;
    if (!ticket?.id && !ticket?.ticketId) throw new Error("Pirdy did not confirm this support request.");
    form.reset();
    state.supportTickets = null;
    await refreshSupportTickets({ announce: false });
    if (isCurrent()) notify("Support request sent. It now appears in your request history.", "success");
  } catch (error) {
    if (!isCurrent()) return;
    const message = supportFailureMessage(error, true);
    if (formStatus) formStatus.textContent = message;
    notify(message, "error");
  } finally {
    if (isCurrent()) {
      state.supportSubmitting = false;
      const currentButton = app.querySelector('#support-ticket-form button[type="submit"]');
      if (currentButton) { currentButton.disabled = false; currentButton.textContent = "Send request"; }
    }
  }
}

function groupCards(compact) {
  const fleet = buildFleet(state.workspace);
  const sites = fleet.sites.map(site => parentGroupCard(site, compact)).join("");
  const groups = fleet.groups.map(group => groupCard(group, compact)).join("");
  const standalone = fleet.standalone.length ? `<section class="group-card fleet-standalone"><div class="section-head"><div><h2>Standalone</h2><p>Pirdys not assigned to any Subgroup.</p></div></div><div class="device-list">${fleet.standalone.map(device => deviceRow(device, compact)).join("")}</div></section>` : "";
  const shared = fleet.shared.length ? `<section class="group-card"><div class="section-head"><div><h2>Shared Pirdys</h2><p>These Pirdys belong to more than one Subgroup. Each display is shown once.</p></div></div><div class="device-list">${fleet.shared.map(entry => `<div><p class="muted">Subgroups: ${entry.groups.map(group => escapeHtml(group.name)).join(" · ")}</p>${deviceRow(entry.device, compact)}</div>`).join("")}</div></section>` : "";
  return sites + groups + shared + standalone || '<section class="empty"><h2>No Cloud Pirdys yet</h2><p>Enable Cloud Control for your purchased Pirdy in the Customer App, then refresh. Local-only devices are not automatically cloud accounts.</p></section>';
}

function parentGroupCard(site, compact) {
  const id = String(site.id ?? site.siteId);
  const members = [...new Map(site.groups.flatMap(group => group.members).map(device => [String(device.deviceId).toLowerCase(), device])).values()];
  const allOn = members.length === 0 || members.every(device => statusFor(device).desiredDisplayOn);
  const anyOn = members.some(device => statusFor(device).desiredDisplayOn);
  const mixed = anyOn && !allOn;
  const complete = members.length > 0 && site.groups.every(group => !group.unresolved.length)
    && members.every(device => statusFor(device).powerAvailable);
  return `<details class="group-card fleet-site" open><summary><span><strong>${escapeHtml(site.name)}</strong><small>${site.groups.length} Subgroup${site.groups.length === 1 ? "" : "s"}</small></span><span class="hierarchy-summary-actions">${canAdminister() && !compact ? `<button class="button hierarchy-edit" data-edit-parent-group="${escapeHtml(id)}">Rename</button><button class="button quiet danger" data-delete-parent-group="${escapeHtml(id)}" data-hierarchy-name="${escapeHtml(site.name)}">Delete</button>` : ""}<label class="switch group-power-switch"><input type="checkbox" data-parent-power="${escapeHtml(id)}" ${mixed ? 'data-mixed="true"' : ""} ${allOn ? "checked" : ""} ${canAdminister() && complete && !state.busy ? "" : "disabled"}/><span></span><em>${!complete ? "Unavailable" : mixed ? "Mixed" : allOn ? "On" : "Off"}</em></label>${muteControls("parent", id, members, site.groups.every(group => !group.unresolved.length))}</span></summary><div class="device-list">${site.groups.map(group => groupCard(group, compact)).join("") || '<p class="muted">No Subgroups in this Group yet.</p>'}</div></details>`;
}

function groupCard(group, compact) {
    const id = String(group.id ?? group.groupId);
    const members = group.members;
    const allOn = members.length === 0 || members.every(device => statusFor(device).desiredDisplayOn);
    const anyOn = members.some(device => statusFor(device).desiredDisplayOn);
    const mixed = anyOn && !allOn;
    const complete = members.length > 0 && !group.unresolved.length
      && members.every(device => statusFor(device).powerAvailable);
    const sharedIds = new Set((group.sharedMembers ?? []).map(device => String(device.deviceId).toLowerCase()));
    const visibleMembers = members.filter(device => !sharedIds.has(String(device.deviceId).toLowerCase()));
    return `<details class="group-card" open><summary><span><strong>${escapeHtml(group.name)}</strong><small>${members.length} Pirdy${members.length === 1 ? "" : "s"}</small></span><span class="hierarchy-summary-actions">${canAdminister() && !compact ? `<button class="button hierarchy-edit" data-edit-subgroup="${escapeHtml(id)}">Rename</button><button class="button quiet danger" data-delete-subgroup="${escapeHtml(id)}" data-hierarchy-name="${escapeHtml(group.name)}">Delete</button>` : ""}<label class="switch group-power-switch"><input type="checkbox" data-group-power="${escapeHtml(id)}" ${mixed ? 'data-mixed="true"' : ""} ${allOn ? "checked" : ""} ${canAdminister() && complete && !state.busy ? "" : "disabled"}/><span></span><em>${!complete ? "Unavailable" : mixed ? "Mixed" : allOn ? "On" : "Off"}</em></label>${muteControls("group", id, members, !group.unresolved.length)}</span></summary><div class="device-list">${visibleMembers.map(device => deviceRow(device, compact)).join("") || (members.length ? "" : '<p class="muted">No Pirdys in this Subgroup.</p>')}${sharedIds.size ? '<p class="muted">Shared Pirdy controls are shown once under Shared Pirdys below. Every Subgroup can still control its member Pirdys.</p>' : ""}${group.unresolved.length ? '<p class="muted">Some Subgroup members are missing from the account device list. Refresh before using Subgroup controls.</p>' : ""}</div></details>`;
}

function hierarchyRecordId(record) {
  return String(record?.id ?? record?.siteId ?? record?.groupId ?? "");
}

function renderHierarchyManager() {
  if (!canAdminister()) return "";
  const editor = state.hierarchyEditor;
  const actions = `<section class="hierarchy-manager"><div><h2>Account structure</h2><p>Create Groups first or create reusable Subgroups. The same Pirdy may be selected in any number of Subgroups.</p></div><div class="actions"><button class="button" data-new-parent-group>Add Group</button><button class="button primary" data-new-subgroup>Add Subgroup</button></div></section>`;
  if (!editor || editor.workspace !== state.workspace || editor.account !== state.account) return actions;
  const isParent = editor.kind === "parent";
  const candidates = array(isParent ? state.workspace?.groups : state.workspace?.devices);
  const current = isParent
    ? array(state.workspace?.sites).find(item => hierarchyRecordId(item) === editor.id)
    : array(state.workspace?.groups).find(item => hierarchyRecordId(item) === editor.id);
  const selected = new Set(isParent
    ? array(current?.groupIds).map(String)
    : array(current?.members).map(item => String(typeof item === "string" ? item : item.deviceId)));
  const choices = candidates.map(item => {
    const id = isParent ? hierarchyRecordId(item) : String(item.deviceId);
    const label = isParent ? item.name : customerDeviceName(item, state.workspace);
    const detail = isParent ? `${array(item.members).length} Pirdy${array(item.members).length === 1 ? "" : "s"}` : customerModelName(item);
    return `<label class="hierarchy-member"><input type="checkbox" data-hierarchy-member value="${escapeHtml(id)}" ${selected.has(id) ? "checked" : ""} ${editor.saving ? "disabled" : ""}/><span><strong>${escapeHtml(label)}</strong><small>${escapeHtml(detail)}</small></span></label>`;
  }).join("");
  const title = `${editor.id ? "Edit" : "Add"} ${isParent ? "Group" : "Subgroup"}`;
  const explanation = isParent
    ? "Select the Subgroups this Group contains. Selecting a Subgroup moves it from its previous Group; Pirdy memberships do not change."
    : "Select every Pirdy that belongs here. A Pirdy remains available for selection in other Subgroups.";
  return `${actions}<form class="card hierarchy-editor" data-hierarchy-form><div class="section-head"><div><h2>${title}</h2><p>${explanation}</p></div></div><label>${isParent ? "Group" : "Subgroup"} name<input name="hierarchyName" maxlength="128" value="${escapeHtml(editor.name)}" required ${editor.saving ? "disabled" : ""}/></label><fieldset><legend>${isParent ? "Subgroups in this Group" : "Pirdys in this Subgroup"}</legend><div class="hierarchy-members">${choices || `<p class="muted">${isParent ? "Create a Subgroup first." : "No Cloud Pirdys are available."}</p>`}</div></fieldset><div class="actions"><button class="button primary" type="submit" ${editor.saving ? "disabled" : ""}>${editor.saving ? "Saving…" : "Save"}</button><button class="button" type="button" data-cancel-hierarchy ${editor.saving ? "disabled" : ""}>Cancel</button>${editor.id ? `<button class="button danger" type="button" data-delete-hierarchy ${editor.saving ? "disabled" : ""}>Delete ${isParent ? "Group" : "Subgroup"}</button>` : ""}</div></form>`;
}

function startHierarchyEditor(kind, id = "") {
  if (!canAdminister()) return;
  const records = array(kind === "parent" ? state.workspace?.sites : state.workspace?.groups);
  const current = records.find(item => hierarchyRecordId(item) === String(id));
  state.hierarchyEditor = { workspace: state.workspace, account: state.account, kind, id: String(id), name: current?.name ?? "", version: current?.rowVersion ?? "", saving: false };
  render();app.querySelector('[name="hierarchyName"]')?.focus();
}

async function saveHierarchy(event) {
  event?.preventDefault();
  const editor = state.hierarchyEditor;
  if (!canAdminister() || !editor || editor.saving || editor.workspace !== state.workspace || editor.account !== state.account) return;
  const name = String(app.querySelector('[name="hierarchyName"]')?.value ?? editor.name).trim();
  const memberIds = [...app.querySelectorAll("[data-hierarchy-member]")].filter(input => input.checked).map(input => input.value);
  if (!name) return notify("Enter a name before saving.", "error");
  if (editor.kind === "subgroup" && memberIds.length === 0) return notify("Select at least one Pirdy for this Subgroup.", "error");
  editor.name = name;editor.saving = true;render();
  try {
    if (editor.kind === "parent") {
      if (editor.id) await updateParentGroup(editor.id, editor.version, name, memberIds);
      else await createParentGroup(name, memberIds);
    } else if (editor.id) await updateSubgroup(editor.id, editor.version, name, memberIds);
    else await createSubgroup(name, memberIds);
    if (state.hierarchyEditor !== editor || editor.account !== state.account) return;
    state.hierarchyEditor = null;await refreshWorkspace({ announce: false });notify(`${editor.kind === "parent" ? "Group" : "Subgroup"} saved.`, "success");
  } catch (error) {
    if (state.hierarchyEditor !== editor || editor.account !== state.account) return;
    editor.saving = false;render();notify(`${customerVisibleErrorMessage(error,
      "The hierarchy change could not be saved.")} Your selections are retained; refresh before retrying if another client changed the structure.`, "error");
  }
}

async function removeHierarchy() {
  const editor = state.hierarchyEditor;
  if (!canAdminister() || !editor?.id || editor.saving || editor.workspace !== state.workspace || editor.account !== state.account) return;
  await removeHierarchyRecord(editor.kind,editor.id,editor.name);
}

async function removeHierarchyRecord(kind,id,name) {
  if(!canAdminister()||state.busy)return;
  const label=kind==="parent"?"Group":"Subgroup";
  const consequence=kind==="parent"
    ?"This also deletes every Subgroup inside it. Pirdys and active content will be kept."
    :"Its Pirdys and active content will be kept.";
  if(!window.confirm(`Delete ${label} '${name}'? ${consequence}`))return;
  const workspace=state.workspace,account=state.account;
  state.busy=true;render();
  try {
    const result=kind==="parent"?await deleteParentGroup(id):await deleteSubgroup(id);
    if(workspace!==state.workspace||account!==state.account)return;
    if (result?.deleted !== true) throw new Error(`Pirdy did not confirm that the ${label} was deleted.`);
    if(kind==="parent"&&result.pirdysPreserved!==true)throw new Error("Pirdy did not confirm that the displays were preserved.");
    state.hierarchyEditor=null;await refreshWorkspace({announce:false});
    if(account===state.account)notify(kind==="parent"?`${label} and its Subgroups deleted. Pirdys and active content were kept.`:`${label} deleted. Pirdys and active content were kept.`,"success");
  } catch (error) {
    if(workspace===state.workspace&&account===state.account)notify(customerVisibleErrorMessage(error,
      "The group could not be deleted. Refresh its current state and try again."),"error");
  } finally {if(account===state.account){state.busy=false;render();}}
}

function membersForGroup(group) {
  const id = String(group.id ?? group.groupId).toLowerCase();
  return buildFleet(state.workspace).allGroups.find(item => String(item.id ?? item.groupId).toLowerCase() === id)?.members ?? [];
}
function membersForParentGroup(parentGroupId) {
  const id = String(parentGroupId).toLowerCase();
  const site = buildFleet(state.workspace).sites.find(item => String(item.id ?? item.siteId).toLowerCase() === id);
  return [...new Map((site?.groups ?? []).flatMap(group => group.members).map(device => [String(device.deviceId).toLowerCase(), device])).values()];
}
function deviceRow(device, compact) {
  const status = statusFor(device);
  const powerLabel = !status.powerAvailable ? "Unavailable"
    : `${status.powerConfirmed ? "" : "Requested "}${status.desiredDisplayOn ? "On" : "Off"}`;
  return `<article class="device-row"><span class="device-icon">${icon("display")}</span><span class="device-main"><strong>${escapeHtml(customerDeviceName(device, state.workspace))}</strong><small>${escapeHtml(customerModelName(device))}</small><small>${escapeHtml(status.publication)}</small>${compact ? "" : `<small>${escapeHtml(status.state)} · ${escapeHtml(status.lastSeen)}</small>`}</span><span class="device-controls"><label class="switch"><input type="checkbox" data-device-power="${escapeHtml(device.deviceId)}" ${status.desiredDisplayOn === true ? "checked" : ""} ${canAdminister() && status.powerAvailable && !state.busy ? "" : "disabled"}/><span></span><em>${powerLabel}</em></label>${muteControls("device", device.deviceId, [device])}<span class="presence ${status.online ? "online" : "offline"}"><i></i>${status.online ? "Online" : "Offline"}</span>${hasAdministratorRole() ? `<button class="button" data-device-settings="${escapeHtml(device.deviceId)}">Settings</button>` : ""}${compact ? "" : '<button class="button" data-route="content">View Content</button>'}${canAdminister() && device.customerName?.version > 0 ? `<button class="button" data-rename-device="${escapeHtml(device.deviceId)}">Rename</button>` : ""}${canAdminister() && !compact ? `<details class="device-manage"><summary>Manage</summary><button class="button danger" data-report-stolen="${escapeHtml(device.deviceId)}">Report stolen</button><button class="button" data-reenable-pirdy="${escapeHtml(device.deviceId)}">Re-enable</button></details>` : ""}</span>${renderDeviceRename(device)}</article>`;
}

function muteCache() {
  if (muteAccount !== state.account || muteOrganization !== state.workspace?.me?.organizationId) {
    deviceMuteSnapshots.clear();muteAccount = state.account;muteOrganization = state.workspace?.me?.organizationId;
  }
  return deviceMuteSnapshots;
}
function muteControls(type, id, devices, membershipKnown = true) {
  if (!devices.some(supportsMuteProfile)) return "";
  const snapshot = type === "device" ? muteCache().get(id) : null;
  const sound = muteStatus(snapshot), disabled = !canAdminister() || !membershipKnown || state.busy || sound.pending;
  return `<span class="device-mute-controls" role="group" aria-label="Sound controls"><span class="actions"><button class="button" data-mute-type="${type}" data-mute-id="${escapeHtml(id)}" data-muted="true" ${disabled ? "disabled" : ""} ${sound.known ? `aria-pressed="${sound.muted}"` : ""}>Mute</button><button class="button" data-mute-type="${type}" data-mute-id="${escapeHtml(id)}" data-muted="false" ${disabled ? "disabled" : ""} ${sound.known ? `aria-pressed="${!sound.muted}"` : ""}>Unmute</button>${type === "device" ? `<button class="button quiet" data-mute-refresh="${escapeHtml(id)}" ${!canAdminister() || state.busy ? "disabled" : ""}>Last sound report</button>` : ""}</span>${type === "device" ? `<small>${escapeHtml(sound.known ? "Last reported: " + sound.message : sound.message)}</small>` : ""}</span>`;
}

function statusFor(device) {
  const id = String(device?.deviceId ?? "").toLowerCase();
  const match = array(state.workspace?.statuses).find(item => String(item?.deviceId ?? "").toLowerCase() === id);
  if (!match) return {
    online: false,
    state: "Status unavailable",
    publication: publicationDeliveryText(null),
    lastSeen: "Not reported",
    desiredDisplayOn: null,
    powerConfirmed: false,
    powerAvailable: false,
  };
  return {
    online: match.controlConnected === true,
    state: match.playbackState ?? match.state ?? match.updateState ?? "Ready",
    lastSeen: match.lastSeenUtc ?? match.lastSeen ?? "Not reported",
    publication: publicationDeliveryText(match),
    desiredDisplayOn: typeof match.desiredDisplayOn === "boolean" ? match.desiredDisplayOn : null,
    powerConfirmed: typeof match.reportedDisplayOn === "boolean" && match.reportedDisplayOn === match.desiredDisplayOn && match.acknowledgedDisplayControlVersion != null && match.acknowledgedDisplayControlVersion === match.displayControlVersion,
    powerAvailable: typeof match.desiredDisplayOn === "boolean",
  };
}

function renderDeviceRename(device) {
  const draft = state.deviceRename;
  if (!draft || draft.workspace !== state.workspace || draft.id !== device.deviceId) return "";
  return `<form class="device-rename-form" data-device-rename-form><label>Pirdy name<input name="nickname" maxlength="80" value="${escapeHtml(draft.nickname)}" placeholder="Leave blank for the automatic model name" ${draft.saving ? "disabled" : ""}></label><small>Saved for this Cloud account. Playback and connections stay unchanged.</small><div class="actions"><button class="button primary" type="submit" ${draft.saving ? "disabled" : ""}>${draft.saving ? "Saving…" : "Save name"}</button><button class="button" type="button" data-cancel-device-rename ${draft.saving ? "disabled" : ""}>Cancel</button></div></form>`;
}

function startDeviceRename(id) {
  if (!canAdminister()) return;
  const device = array(state.workspace?.devices).find(value => value.deviceId === id);
  if (!device?.customerName?.version) return;
  state.deviceRename = { workspace: state.workspace, account: state.account, id, original: device.customerName, nickname: device.customerName.nickname ?? customerDeviceName(device, state.workspace), saving: false };
  render();app.querySelector('[name="nickname"]')?.focus();
}

async function saveDeviceRename(value) {
  const draft = state.deviceRename;
  if (!canAdminister() || !draft || draft.saving || draft.workspace !== state.workspace || draft.account !== state.account) return;
  const nickname = String(value ?? draft.nickname).trim() || null;
  if (nickname && (nickname.length > 80 || /[\u0000-\u001f\u007f]/.test(nickname))) { notify("Use up to 80 printable characters for the Pirdy name.", "error");return; }
  draft.nickname = nickname ?? "";draft.saving = true;render();
  try {
    const result = await renameDevice(draft.id, nickname, draft.original.version);
    if (draft.workspace !== state.workspace || draft.account !== state.account || state.deviceRename !== draft) return;
    if (result?.deviceId !== draft.id || result?.modelName !== draft.original.modelName || result?.sequence !== draft.original.sequence || result?.version !== draft.original.version + 1 || (result?.nickname ?? null) !== nickname)
      throw new Error("The service did not confirm this Pirdy's name. Refresh before trying again.");
    const device = array(state.workspace.devices).find(item => item.deviceId === draft.id);
    if (device) device.customerName = result;
    state.deviceRename = null;render();notify("Pirdy name saved. Other clients will see it when refreshed.", "success");
  } catch (error) {
    if (draft.workspace !== state.workspace || draft.account !== state.account || state.deviceRename !== draft) return;
    draft.saving = false;render();notify(`${customerVisibleErrorMessage(error,
      "The Pirdy name could not be saved.")} Your typed name is retained. Refresh before retrying; no automatic overwrite was attempted.`, "error");
  }
}

function bindShell() {
  app.querySelectorAll('[data-action="usb-local-control"]').forEach(button => button.addEventListener("click", openBrowserUsbControl));
  app.querySelectorAll("[data-route]").forEach(button => button.addEventListener("click", () => navigate(button.dataset.route)));
  app.querySelectorAll('[data-action="refresh"]').forEach(button => button.addEventListener("click",
    refreshSignedInAccount));
  app.querySelector(".mobile-menu")?.addEventListener("click", () => app.querySelector(".sidebar")?.classList.toggle("open"));
  app.querySelectorAll(".group-power-switch").forEach(control => control.addEventListener("click", event => event.stopPropagation()));
  app.querySelectorAll('[data-mixed="true"]').forEach(control => { control.indeterminate = true; });
  app.querySelectorAll('[data-action="open-local-control"]').forEach(button =>
    button.addEventListener("click", openLocalControl));
}
function bindRoute() {
  const audioItem=state.playlistDraft?.items?.[state.selectedPlaylistItem];
  if(audioItem)bindPlaylistAudio(app,{item:audioItem,isCurrent:()=>!state.busy&&state.playlistDraft?.items?.[state.selectedPlaylistItem]===audioItem,importAudio:importPlaylistAudio});
  app.querySelector("[data-import-library-audio]")?.addEventListener("change",event=>{const file=event.target.files?.[0];if(file)importPlaylistAudio(file);});
  app.querySelectorAll('[data-new-parent-group]').forEach(button => button.addEventListener('click', () => startHierarchyEditor("parent")));
  app.querySelectorAll('[data-new-subgroup]').forEach(button => button.addEventListener('click', () => startHierarchyEditor("subgroup")));
  app.querySelectorAll('[data-edit-parent-group]').forEach(button => button.addEventListener('click', event => { event.preventDefault();event.stopPropagation();startHierarchyEditor("parent", button.dataset.editParentGroup); }));
  app.querySelectorAll('[data-edit-subgroup]').forEach(button => button.addEventListener('click', event => { event.preventDefault();event.stopPropagation();startHierarchyEditor("subgroup", button.dataset.editSubgroup); }));
  app.querySelectorAll('[data-delete-parent-group]').forEach(button => button.addEventListener('click', event => { event.preventDefault();event.stopPropagation();removeHierarchyRecord("parent",button.dataset.deleteParentGroup,button.dataset.hierarchyName); }));
  app.querySelectorAll('[data-delete-subgroup]').forEach(button => button.addEventListener('click', event => { event.preventDefault();event.stopPropagation();removeHierarchyRecord("subgroup",button.dataset.deleteSubgroup,button.dataset.hierarchyName); }));
  app.querySelector('[data-hierarchy-form]')?.addEventListener('submit', saveHierarchy);
  app.querySelector('[data-cancel-hierarchy]')?.addEventListener('click', () => { state.hierarchyEditor = null;render(); });
  app.querySelector('[data-delete-hierarchy]')?.addEventListener('click', removeHierarchy);
  app.querySelectorAll('[data-resume-playlist-create]').forEach(button => button.addEventListener('click', () => resumePlaylistCreate(button.dataset.resumePlaylistCreate)));
  app.querySelectorAll('[data-device-settings]').forEach(button => button.addEventListener('click', () => {
    const device = (isBrowserLocalWorkspace() ? currentLinkedPirdys() : array(state.workspace?.devices)).find(value => value.deviceId === button.dataset.deviceSettings);
    const accountId = localControlAccountId();if (!device || !accountId || (!hasAdministratorRole() && !isBrowserLocalWorkspace())) return;
    openDeviceSettings({ device, name: customerDeviceName(device, state.workspace), accountId, currentAccountId: localControlAccountId, cloudAvailable: canAdministerCloudWorkspace() });
  }));
  app.querySelector('[data-refresh-linked-pirdys]')?.addEventListener('click', () => { state.linkedPirdysError = null;void refreshLocalLinkedPirdys(); });
  app.querySelectorAll('[data-rename-device]').forEach(button => button.addEventListener('click', () => startDeviceRename(button.dataset.renameDevice)));
  app.querySelector('[data-device-rename-form]')?.addEventListener('submit', event => { event.preventDefault();saveDeviceRename(event.currentTarget.elements.nickname.value); });
  app.querySelector('[data-cancel-device-rename]')?.addEventListener('click', () => { state.deviceRename = null;render(); });
  app.querySelector('[data-action="retry-previews"]')?.addEventListener("click", () => { mediaPreviews.retryFailed(); hydrateThumbnails(); });
  app.querySelectorAll("[data-playlist]").forEach(button => button.addEventListener("click", () => selectPlaylist(button.dataset.playlist)));
  app.querySelector('[data-action="prepare-artwork"]')?.addEventListener("click", prepareSelectedArtwork);
  app.querySelector('[data-action="upload-artwork"]')?.addEventListener("click", uploadPreparedArtwork);
  app.querySelectorAll("[data-delete-media]").forEach(button => button.addEventListener("click", () => removeMedia(button.dataset.deleteMedia)));
  app.querySelector('[data-action="new-playlist"]')?.addEventListener("click", newPlaylistDraft);
  app.querySelector('[data-action="open-assistant"]')?.addEventListener("click", openCustomerAssistant);
  app.querySelector('[data-action="assistant-review-publish"]')?.addEventListener("click", reviewAssistantPublish);
  app.querySelector('[data-action="save-playlist"]')?.addEventListener("click", savePlaylistDraft);
  app.querySelector('[data-action="export-local-playlist"]')?.addEventListener("click", exportBrowserLocalPlaylist);
  app.querySelector('[data-action="delete-playlist"]')?.addEventListener("click", removePlaylistDraft);
  app.querySelectorAll("[data-select-playlist-source]").forEach(button=>button.addEventListener("click",()=>{
    if(!state.playlistDraft||state.busy||!canManageContent())return;
    syncItemEditorFields();const selected=playlistSourceSelection(),id=button.dataset.selectPlaylistSource;
    if(selected.has(id))selected.delete(id);else selected.add(id);render();
  }));
  app.querySelector("[data-add-playlist-selection]")?.addEventListener("click",()=>addAssetsToPlaylist([...playlistSourceSelection()]));
  bindPlaylistCardInput();
  app.querySelectorAll("[data-add-asset]").forEach(button => button.addEventListener("click", () => addAssetToPlaylist(button.dataset.addAsset)));
  app.querySelectorAll("[data-prepare-local-publish]").forEach(button=>button.addEventListener("click",async()=>{
    if(!isBrowserLocalWorkspace()||state.busy)return;
    syncItemEditorFields();
    if(assistantWouldReplaceUnsavedDraft())return notify("Save your current playlist edits before preparing another transfer.","error");
    const account=state.account,id=button.dataset.prepareLocalPublish;
    await selectPlaylist(id);
    if(state.account!==account||String(state.playlistDraft?.id)!==id)return;
    await exportBrowserLocalPlaylist();
  }));
  app.querySelectorAll("[data-send-local-playlist]").forEach(button => button.addEventListener("click", () => sendBrowserLocalPlaylist(button.dataset.sendLocalPlaylist)));
  for (const [action, remove] of [["usb-branding", false], ["usb-default-branding", true]]) app.querySelector(`[data-action="${action}"]`)?.addEventListener("click", () => {
    const account = state.account, accountId = browserLocalAccountId();
    if (!accountId || !isBrowserLocalWorkspace()) return;
    const source = remove ? null : state.preparedBranding?.sourceFile;
    if (!remove && !source) return notify("Choose and preview a PNG or JPEG first.", "error");
    openUsbControls({ accountId, currentAccountId: () => state.account === account ? browserLocalAccountId() : null, branding: { source, remove } });
  });
  app.querySelectorAll("[data-duplicate-item]").forEach(button => button.addEventListener("click", () => duplicatePlaylistItem(Number(button.dataset.duplicateItem))));
  app.querySelectorAll("[data-playlist-item]").forEach(button => button.addEventListener("click", () => selectPlaylistItem(Number(button.dataset.playlistItem))));
  app.querySelectorAll("[data-move-item]").forEach(button => button.addEventListener("click", () => movePlaylistItem(Number(button.dataset.moveItem), Number(button.dataset.delta))));
  app.querySelectorAll("[data-remove-item]").forEach(button => button.addEventListener("click", () => removePlaylistItem(Number(button.dataset.removeItem))));
  app.querySelector('[data-action="apply-item-settings"]')?.addEventListener("click", applyItemSettings);
  app.querySelector('[data-action="test-item-interactions"]')?.addEventListener("click", testItemInteractions);
  app.querySelector('[data-action="retry-item-preview"]')?.addEventListener("click", () => {
    selectedItemPreview.retry(); selectedPreviewSource = null; void hydrateItemPresentationPreview();
  });
  app.querySelectorAll('input[name="item-presentation"]').forEach(control => control.addEventListener("change", () => {
    const item = state.playlistDraft?.items?.[state.selectedPlaylistItem];
    if (!item) return;
    syncItemEditorFields();
    item.requestedPresentation = Number(control.value);
    render();
  }));
  {const disclosure=app.querySelector('[data-static-overlay-options]'),item=state.playlistDraft?.items?.[state.selectedPlaylistItem];
    if(disclosure&&item)disclosure.addEventListener("toggle",()=>{
      if(!disclosure.isConnected||state.playlistDraft?.items?.[state.selectedPlaylistItem]!==item)return;
      if(disclosure.open)overlayEditorsExpanded.add(item);else overlayEditorsExpanded.delete(item);
    });}
  app.querySelector('[data-static-overlay-file]')?.addEventListener("change",async event=>{
    syncItemEditorFields();
    const draft=state.playlistDraft,item=draft?.items?.[state.selectedPlaylistItem],files=Array.from(event.target.files??[]);
    if(!item||!files.length)return;
    try{
      const original=effectiveStaticOverlays(item);
      if(original.length+files.length>8)throw overlayError("Each artwork supports up to 8 overlay images. Select fewer files or remove an existing image.");
      let remaining=4096-validateOverlayPlaylist(draft.items);
      if(remaining<files.length)throw overlayError("No overlay space remains in this playlist. Remove an overlay before adding more.");
      const bounds=hotspotBounds({coordinateMode:2},assetById(item.assetId)),additions=[];
      for(let i=0;i<files.length;i++){
        await inspectContentSource(files[i]);
        const image=await prepareOverlay(files[i],Math.min(1024,Math.floor(remaining/(files.length-i))));
        if(state.playlistDraft!==draft||draft.items?.[state.selectedPlaylistItem]!==item)return;
        remaining-=image.width*image.height;
        let region=resizeStaticOverlay({x:0,y:0,width:1,height:1},image,Math.min(96,image.width),bounds);
        const offset=(original.length+i)*8;
        region={...region,x:Math.min(bounds.width-region.width,Math.floor((bounds.width-region.width)/2)+offset),
          y:Math.min(bounds.height-region.height,Math.floor((bounds.height-region.height)/2)+offset)};
        additions.push({image,region});
      }
      // Recheck the complete current playlist before one atomic append. No
      // existing image is resized, replaced or silently removed to make room.
      overlaySelections.set(item,appendStaticOverlays(item,additions,draft.items));render();
    }catch(error){notify(customerVisibleErrorMessage(error,"The overlay images could not be prepared."),"error");}
  });
  app.querySelectorAll('[data-remove-static-overlay]').forEach(button=>button.addEventListener("click",()=>{
    syncItemEditorFields();const item=state.playlistDraft?.items?.[state.selectedPlaylistItem];
    if(item)removeStaticOverlay(item,Number(button.dataset.removeStaticOverlay));render();
  }));
  app.querySelectorAll('[data-select-static-overlay]').forEach(button=>button.addEventListener("click",()=>{
    syncItemEditorFields();const item=state.playlistDraft?.items?.[state.selectedPlaylistItem];if(!item)return;
    const index=Number(button.dataset.selectStaticOverlay);overlaySelections.set(item,index);render();
    app.querySelector('[data-static-visual][data-overlay-index="'+index+'"]')?.focus();
  }));
  {const selected=state.playlistDraft?.items?.[state.selectedPlaylistItem];if(selected)bindStaticOverlay(app,()=>state.playlistDraft?.items?.[state.selectedPlaylistItem],
    hotspotBounds({coordinateMode:2},assetById(selected.assetId)),render,syncItemEditorFields,index=>{
      overlaySelections.set(selected,index);
      app.querySelectorAll('[data-select-static-overlay]').forEach(button=>{
        const active=Number(button.dataset.selectStaticOverlay)===index;button.classList.toggle("primary",active);button.setAttribute("aria-pressed",String(active));
      });
    });}
  app.querySelector('[data-action="draw-hotspot"]')?.addEventListener("click", () => {
    syncItemEditorFields();
    state.drawingHotspot = !state.drawingHotspot;
    render();
  });
  app.querySelectorAll("[data-hotspot-move]").forEach(control=>control.addEventListener("change",()=>{
    syncItemEditorFields();const item=state.playlistDraft?.items?.[state.selectedPlaylistItem],area=item?.interactions?.touchAreas?.[Number(control.dataset.hotspotMove)];if(!area)return;
    area.coordinateMode=control.checked?1:2;if(control.checked)delete area.overlayImage;
    const asset=assetById(item.assetId);area.region=clampHotspot(area.region,hotspotBounds(area,asset));render();
  }));
  app.querySelectorAll("[data-delete-hotspot]").forEach(button => button.addEventListener("click", () => deleteHotspot(Number(button.dataset.deleteHotspot))));
  app.querySelectorAll("[data-hotspot-action]").forEach(control => control.addEventListener("change", () => changeHotspotAction(Number(control.dataset.hotspotAction), Number(control.value))));
  app.querySelectorAll("[data-hotspot-target]").forEach(control => control.addEventListener("change", () => changeHotspotTarget(Number(control.dataset.hotspotTarget), control.value)));
  bindHotspotStage();
  void hydrateEditorArtwork();
  void hydrateItemPresentationPreview();
  app.querySelector('[data-action="prepare-branding"]')?.addEventListener("click", prepareSelectedBranding);
  app.querySelector('[data-action="upload-branding"]')?.addEventListener("click", uploadPreparedBranding);
  app.querySelector('[data-action="remove-branding"]')?.addEventListener("click", restoreDefaultBranding);
  app.querySelectorAll("[data-device-power]").forEach(control => control.addEventListener("change", () => updatePower("device", control.dataset.devicePower, control.checked, control)));
  app.querySelectorAll("[data-group-power]").forEach(control => control.addEventListener("change", () => updatePower("group", control.dataset.groupPower, control.checked, control)));
  app.querySelectorAll("[data-parent-power]").forEach(control => control.addEventListener("change", () => updatePower("parent", control.dataset.parentPower, control.checked, control)));
  app.querySelectorAll("[data-mute-type]").forEach(control => control.addEventListener("click", event => { event.preventDefault();event.stopPropagation();void updateMute(control.dataset.muteType, control.dataset.muteId, control.dataset.muted === "true"); }));
  app.querySelectorAll("[data-mute-refresh]").forEach(control => control.addEventListener("click", event => { event.preventDefault();event.stopPropagation();void updateMute("device", control.dataset.muteRefresh, null); }));
  app.querySelectorAll('input[name="publish-playlist"]').forEach(control => control.addEventListener("change", () => {
    state.selectedPlaylistId = control.value;
    state.selectedPlaylist = null;
    state.publishTarget = null;
    state.publicationValidation = null;
    render();
  }));
  app.querySelectorAll('input[name="publish-target"]').forEach(control => control.addEventListener("change", () => {
    const separator = control.value.indexOf(":");
    state.publishTarget = { kind: control.value.slice(0, separator), id: control.value.slice(separator + 1) };
    state.publicationValidation = null;
    render();
  }));
  app.querySelector('[data-action="publish-next"]')?.addEventListener("click", continueToTargets);
  app.querySelector('[data-action="publish-back"]')?.addEventListener("click", () => { state.publishStep = 1; state.publishTarget = null; state.publicationValidation = null; render(); });
  app.querySelector('[data-action="publish-review"]')?.addEventListener("click", reviewPublication);
  app.querySelector('[data-action="publish-back-target"]')?.addEventListener("click", () => { state.publishStep = 2; state.publicationValidation = null; render(); });
  app.querySelector('[data-action="publish-confirm"]')?.addEventListener("click", commitPublication);
  app.querySelector('[data-action="load-billing"]')?.addEventListener("click", refreshBilling);
  app.querySelector('[data-action="start-trial"]')?.addEventListener("click", startFreeCloudTrial);
  app.querySelectorAll("[data-hardware-offer]").forEach(button => button.addEventListener("click", () => showHardwareOffer(button.dataset.hardwareOffer)));
  app.querySelectorAll('[data-plan]').forEach(button => button.addEventListener("click", () => startPlanCheckout(button.dataset.plan)));
  app.querySelector('[data-action="buy-change"]')?.addEventListener("click", buySingleChange);
  app.querySelectorAll('[data-action="pay"]').forEach(button => button.addEventListener("click", () => payInvoice(button.dataset.invoice)));
  app.querySelectorAll('[data-action="invoice"]').forEach(button => button.addEventListener("click", () => invoiceDocument(button.dataset.invoice)));
  bindClaimSessionForm(app.querySelector("[data-claim-pirdy-form]"), {start: startClaimSession, account: () => state.account, enabled: !reviewMode});
  app.querySelector("[data-claim-pirdy-form]")?.addEventListener("submit", claimPurchasedPirdy);
  app.querySelectorAll("[data-report-stolen]").forEach(button => button.addEventListener("click", () => reportStolenDevice(button.dataset.reportStolen)));
  app.querySelectorAll("[data-reenable-pirdy]").forEach(button => button.addEventListener("click", () => reEnableDevice(button.dataset.reenablePirdy)));
  const supportCategory = app.querySelector('#support-ticket-form select[name="category"]');
  supportCategory?.addEventListener("change", () => toggleSupportOther(supportCategory));
  app.querySelector("#support-ticket-form")?.addEventListener("submit", submitSupportTicket);
  app.querySelectorAll('[data-action="refresh-support"]').forEach(button => button.addEventListener("click", () => refreshSupportTickets({ announce: true })));
  app.querySelectorAll('[data-action="refresh-cloud-settings"]').forEach(button => button.addEventListener("click", () => refreshWorkspace({ announce: true })));
  const backupExportConfirmation = app.querySelector("[data-backup-export-confirm]");
  const backupExportButton = app.querySelector('[data-action="download-encrypted-backup"]');
  backupExportConfirmation?.addEventListener("change", () => {
    if (backupExportButton) backupExportButton.disabled =
      backupExportConfirmation.checked !== true || state.backupBusyKind !== null;
  });
  backupExportButton?.addEventListener("click", () => exportEncryptedWorkspaceBackup());
  app.querySelector("[data-backup-restore-form]")?.addEventListener("submit", restoreEncryptedWorkspaceLocally);
  app.querySelectorAll('[data-action="refresh-workspace-settings"]').forEach(button => button.addEventListener("click", () => refreshWorkspaceSettings({ announce: true })));
  const workspaceSettingsForm = app.querySelector("[data-workspace-settings-form]");
  workspaceSettingsForm?.addEventListener("submit", saveWorkspaceSettings);
  workspaceSettingsForm?.querySelectorAll("input, select").forEach(control => {
    control.addEventListener("input", () => syncWorkspaceSettingsDraft(workspaceSettingsForm));
    control.addEventListener("change", () => syncWorkspaceSettingsDraft(workspaceSettingsForm));
  });
  app.querySelectorAll('[data-action="refresh-billing-profile"]').forEach(button => button.addEventListener("click", () => refreshBillingProfile({ announce: true })));
  const billingProfileForm = app.querySelector("[data-billing-profile-form]");
  billingProfileForm?.addEventListener("submit", saveBillingProfile);
  billingProfileForm?.querySelectorAll("input, select").forEach(control => {
    control.addEventListener("input", () => syncBillingProfileDraft(billingProfileForm));
    control.addEventListener("change", () => syncBillingProfileDraft(billingProfileForm));
  });
  billingProfileForm?.elements?.countryCode?.addEventListener("input", () => applyBillingCountryRules(billingProfileForm));
  app.querySelectorAll('[data-action="refresh-organization"]').forEach(button => button.addEventListener("click", () => refreshOrganizationManagement({ announce: true })));
  app.querySelectorAll("[data-organization-member-index]").forEach(button => button.addEventListener("click", () => selectOrganizationMember(button.dataset.organizationMemberIndex)));
  app.querySelector("[data-organization-member-form]")?.addEventListener("submit", saveOrganizationMember);
  app.querySelector('[data-action="change-member-state"]')?.addEventListener("click", requestOrganizationMemberStateChange);
  app.querySelector("[data-organization-invite-form]")?.addEventListener("submit", submitOrganizationInvitation);
  app.querySelectorAll("[data-revoke-invitation-index]").forEach(button => button.addEventListener("click", () => requestOrganizationInvitationRevoke(button.dataset.revokeInvitationIndex)));
  app.querySelector('[data-action="confirm-organization-change"]')?.addEventListener("click", confirmOrganizationChange);
  app.querySelector('[data-action="cancel-organization-change"]')?.addEventListener("click", () => { state.organizationConfirmation = null; render(); });
  app.querySelector('[data-action="signout"]')?.addEventListener("click", async () => { mediaPreviews.clear();selectedItemPreview.clear();selectedPreviewSource = null;state.editorArtwork = null;state.hotspotViewportPosition = {}; workspaceOwner = null; state.notice = null; state.preparedArtwork = null; state.preparedBranding = null; state.playlistDraft = null; state.assistantDraftJobId = null; state.selectedPlaylist = null; state.selectedPlaylistId = null; state.hierarchyEditor = null; state.supportTickets = null; state.supportLoading = false; state.supportError = null; state.supportSubmitting = false; resetOrganizationManagement(); resetCustomerSettings(); clearBrowserLocalWorkspaceView(); state.account = null; state.pirdyAccount = null; state.accountRegistrationRequired = false; state.cloudActivationOpen = false; state.workspace = null; state.billing = null; state.entitlement = null; state.entitlementError = null; state.cloudAccess = null; state.cloudAccessError = null; state.claimedDevices = null; state.pendingProductCode = null; render(); await signOut(); });
  hydrateThumbnails();
}

async function prepareSelectedArtwork() {
  const file = app.querySelector("#artwork-file")?.files?.[0];
  if (!file) return notify("Choose a PNG or JPEG source image.", "error");
  const isCurrent = customerOperationScope();
  state.busy = true;
  render();
  try {
    const [source, representative] = await Promise.all([
      inspectContentSource(file),
      prepareArtwork(file, "fit", Orientation.landscape, "#000", DeviceProfile.uno),
    ]);
    if (!isCurrent()) return;
    state.preparedArtwork = { ...representative, source };
    notify("The reusable source was verified. Review it before adding it to Content.", "success");
  } catch (error) {
    if (!isCurrent()) return;
    state.preparedArtwork = null;
    notify(customerVisibleErrorMessage(error,
      "That image could not be prepared. Choose a valid PNG or JPEG and try again."), "error");
  } finally {
    if (isCurrent()) { state.busy = false; render(); }
  }
}


async function importPlaylistAudio(file,item=null,recipient=null,background=false) {
  if(reviewMode||!canManageContent()||state.busy)return;
  syncItemEditorFields();
  const account=state.account,draft=state.playlistDraft,accountId=browserLocalAccountId(),local=isBrowserLocalWorkspace();
  const current=()=>state.account===account&&local===isBrowserLocalWorkspace()&&(!local||browserLocalAccountId()===accountId);
  let audio;
  state.busy=true;render();
  try{
    audio=await prepareCydAudio(file);
    if(!current())return;
    const metadata=preparedAudioMetadata(audio,file.name,crc32);
    let assetId;
    if(local){
      if(audio.bytes.length>20*1024*1024)throw audioError("This clip exceeds the 20 MB browser-local file limit. Choose a shorter clip or use the Windows Customer App.");
      const saved=await browserAuthoringWorkspaceStore.saveAsset(accountId,{
        ...metadata,assetId:crypto.randomUUID(),mediaType:"audio/wav",bytes:audio.bytes,
        thumbnail:null,sourceWidth:0,sourceHeight:0
      });
      if(!current())return;
      assetId=saved.result?.assetId;
      if(!assetId)throw audioError("Pirdy did not confirm the saved audio.");
      applyBrowserLocalWorkspace(saved.workspace);
    }else{
      const registration=await registerMedia({...metadata,libraryVisible:true});
      if(!current())return;
      assetId=registration.assetId;
      if(!assetId)throw audioError("Pirdy did not confirm the audio registration.");
      if(registration.alreadyExists!==true){
        await uploadBlob(registration.uploadUrl,new Blob([audio.bytes],{type:"audio/wav"}));
        if(!current())return;
        await completeMedia(assetId);
        if(!current())return;
      }
      const content=array(state.workspace?.content);
      if(!content.some(asset=>String(asset.assetId??asset.id)===String(assetId)))
        state.workspace={...state.workspace,content:[...content,{...metadata,assetId,duration:audioDuration(metadata.durationSeconds),libraryVisible:true}]};
    }
    if(!current())return;
    const stillSelected=draft===state.playlistDraft&&item&&state.playlistDraft?.items?.[state.selectedPlaylistItem]===item;
    const stillRecipient=recipient===item||item?.interactions?.touchAreas?.includes(recipient);
    if(stillSelected&&stillRecipient){if(background&&recipient===item)recipient.backgroundAudio={assetId,volume:1,loop:true};else recipient.audio={assetId,volume:2};}
    notify(stillSelected&&stillRecipient?"Audio was verified and attached to this artwork. Save the playlist, then publish it.":"Audio was verified and added to your library. Choose it from an artwork sound setting.","success");
  }catch(error){if(current()){rememberBrowserLocalFailure(error);notify(customerVisibleErrorMessage(error,"Audio could not be prepared or saved. Existing playlist sounds were not changed."),"error");}}
  finally{audio?.bytes?.fill?.(0);if(current()){state.busy=false;render();}}
}

async function uploadPreparedArtwork() {
  const prepared = state.preparedArtwork;
  if (!prepared || reviewMode || !canManageContent()) return;
  const isCurrent = customerOperationScope();
  state.busy = true;
  render();
  try {
    if (isBrowserLocalWorkspace()) {
      const account = state.account;
      const accountId = browserLocalAccountId();
      const bytes = new Uint8Array(await prepared.source.blob.arrayBuffer());
      if (!accountId || state.account !== account || !isBrowserLocalWorkspace()) return;
      const saved = await browserAuthoringWorkspaceStore.saveAsset(accountId, {
        assetId: crypto.randomUUID(),
        name: prepared.source.metadata.name,
        mediaType: prepared.source.metadata.sourceContentType,
        sha256: prepared.source.metadata.sha256,
        bytes,
        thumbnail: prepared.previewUrl,
        width: prepared.metadata.width,
        height: prepared.metadata.height,
        sourceWidth: prepared.source.metadata.width,
        sourceHeight: prepared.source.metadata.height,
        orientation: prepared.metadata.orientation,
        playbackMode: prepared.metadata.playbackMode,
        pixelFormat: prepared.metadata.pixelFormat,
        crc32: prepared.metadata.crc32,
        extension: prepared.metadata.extension,
      });
      if (state.account !== account || browserLocalAccountId() !== accountId) return;
      applyBrowserLocalWorkspace(saved.workspace);
      state.preparedArtwork = null;
      notify("Content was verified and saved only in this browser.", "success");
      return;
    }
    const sourceRegistration = await registerContentSource(prepared.source.metadata);
    if (!isCurrent()) return;
    if (sourceRegistration.alreadyExists !== true) {
      await uploadBlob(sourceRegistration.uploadUrl, prepared.source.blob);
      if (!isCurrent()) return;
      await completeContentSource(sourceRegistration.sourceId);
      if (!isCurrent()) return;
    }
    const registration = await registerMedia({ ...prepared.metadata, logicalSourceAssetId: sourceRegistration.sourceId, preparation: 1, targetProfileId: DeviceProfile.uno, libraryVisible: true });
    if (!isCurrent()) return;
    const assetId = registration.assetId;
    if (registration.alreadyExists !== true) {
      await uploadBlob(registration.uploadUrl, prepared.blob);
      if (!isCurrent()) return;
      await completeMedia(assetId);
      if (!isCurrent()) return;
    }
    state.thumbnailUrls.set(String(assetId), prepared.previewUrl);
    state.preparedArtwork = null;
    await refreshWorkspace({ announce: false });
    if (!isCurrent()) return;
    notify(registration.alreadyExists ? "This verified content already exists in your library." : "Content was uploaded, verified, and added to your library.", "success");
  } catch (error) {
    if (!isCurrent()) return;
    rememberBrowserLocalFailure(error);
    notify(`${customerVisibleErrorMessage(error,
      "Content could not be uploaded and verified.")} Existing content was not changed.`, "error");
  } finally {
    if (isCurrent()) { state.busy = false; render(); }
  }
}

async function removeMedia(assetId) {
  if (reviewMode || !canManageContent() || state.busy) return;
  if (!assetId || assetId === "undefined") return notify("Select a saved content item to delete.", "error");
  const account = state.account;
  const organization = state.workspace?.me?.organizationId;
  const isCurrent = () => state.account === account && state.workspace?.me?.organizationId === organization;
  state.busy = true;
  render();
  try {
    if (isBrowserLocalWorkspace()) {
      const accountId = browserLocalAccountId();
      if (!accountId) return;
      const removed = await browserAuthoringWorkspaceStore.deleteAsset(accountId, assetId);
      if (!isCurrent() || browserLocalAccountId() !== accountId) return;
      applyBrowserLocalWorkspace(removed.workspace);
      mediaPreviews.forget(assetId);
      state.selectedContent.delete(String(assetId));
      notify("Content was removed from this browser-local workspace.", "success");
      return;
    }
    const result = await deleteMedia(assetId);
    if (!isCurrent()) return;
    if (result?.found !== true) throw new Error("Pirdy did not confirm this content deletion. Refresh and try again.");
    if (!result.retainedByReference && result.cleanupScheduled !== true) throw new Error("Pirdy did not confirm removal from the content library. Nothing was removed here.");
    await refreshWorkspace({ announce: false });
    if (!isCurrent()) return;
    if (state.workspaceError) {
      notify("Deletion was accepted, but the current library could not be refreshed. Refresh before making more changes.", "error");
      return;
    }
    if (libraryContent().some(item => String(item.assetId ?? item.id) === String(assetId)))
      throw new Error("The refreshed library still contains this content. Refresh before trying again.");
    mediaPreviews.forget(assetId);
    state.selectedContent.delete(String(assetId));
    notify("Removed from Content. Existing playback is unchanged.", "success");
  } catch (error) {
    if (!isCurrent()) return;
    if (error?.code === "browser_local_in_playlist")
      notify(mediaPlaylistBlockMessage(error.blockingPlaylists), "error");
    else if (error?.status === 409 && error?.code === "pirdy_media_in_playlist")
      notify(mediaPlaylistBlockMessage(error.blockingPlaylists), "error");
    else notify(customerVisibleErrorMessage(error,
      "Content could not be deleted. Refresh the library and try again."), "error");
    rememberBrowserLocalFailure(error);
  } finally {
    if (isCurrent()) { state.busy = false; render(); }
  }
}

function mediaPlaylistBlockMessage(playlists) {
  const labels = array(playlists).map(item => String(typeof item === "string" ? item : item?.name ?? item?.playlistName ?? "").trim()).filter(Boolean);
  const unique = [...new Set(labels)];
  if (unique.length === 1) return `Remove this content from the saved playlist "${unique[0]}" before deleting it.`;
  if (unique.length > 1) {
    const shown = unique.slice(0, 2).map(name => `"${name}"`).join(" and ");
    const remainder = unique.length > 2 ? ` and ${unique.length - 2} more` : "";
    return `Remove this content from saved playlists ${shown}${remainder} before deleting it.`;
  }
  return "Remove this content from every saved playlist before deleting it.";
}

function assistantWouldReplaceUnsavedDraft() {
  const draft = state.playlistDraft;
  if (!draft) return false;
  if ((app.querySelector("#playlist-name")?.value?.trim() ?? draft.name) !== draft.name) return true;
  const saved = state.selectedPlaylist;
  if (!saved) return draft.items.length > 0 || draft.name !== "Untitled playlist";
  if (JSON.stringify({ name: draft.name, items: draft.items }) !== JSON.stringify({ name: saved.name, items: saved.items })) return true;
  const item = draft.items[state.selectedPlaylistItem], asset = item && assetById(item.assetId);
  if (!item || !asset) return false;
  try {
    const pending = structuredClone(item); syncItemEditorFields(pending);
    return JSON.stringify(createPlaylistItem(asset, item)) !== JSON.stringify(createPlaylistItem(asset, pending));
  } catch { return true; }
}

export async function openCustomerAssistant() {
  if (!state.account || reviewMode) return;
  if (assistantComposer?.isCurrent()) { assistantComposer.expand(); assistantComposer.focus(); updateAssistantToggle(); return; }
  ensureGlobalAssistantShell();
  const host = app.querySelector("[data-assistant-host]"); if (!host) return;
  const account = state.account;
  let composerAlive = true;
  const local = isBrowserLocalWorkspace(), localAccountId = local ? browserLocalAccountId() : null;
  const organizationId = state.workspace?.me?.organizationId ?? null;
  const current = () => composerAlive && state.account === account && isBrowserLocalWorkspace() === local && (state.workspace?.me?.organizationId ?? null) === organizationId && (!local || browserLocalAccountId() === localAccountId);
  const profiles = [
    { id: DeviceProfile.cyd28St7789Touch, name: "UNO28 CYD Touch · 320 × 240" },
    { id: DeviceProfile.unoTouch, name: "Pirdy Spark · 320 × 240" },
    { id: DeviceProfile.uno, name: "Pirdy Spark · 320 × 240" },
    { id: DeviceProfile.duosTouch, name: "Pirdy Engage · 480 × 320" },
    { id: DeviceProfile.duos, name: "Pirdy Engage · 480 × 320" },
  ];
  const devices = array(state.workspace?.devices).filter(device => profiles.some(profile => profile.id === device.profileId)).map(device => ({ deviceId: device.deviceId, profileId: device.profileId, orientation: Number(device.orientation ?? 2), name: customerDeviceName(device, state.workspace) }));
  const assistantApi = createAssistantApiSession(current);
  assistantComposer = openAssistantComposer({ host, api: assistantApi,
    profiles, devices, content: local ? [] : libraryContent().filter(asset => !isAudioAsset(asset)).map(asset => ({ assetId: String(asset.assetId ?? asset.id), name: asset.name })),
    selectedAssetIds: local ? [] : [...state.selectedContent], isCurrent: current, onClose: () => { composerAlive = false; assistantComposer = null; updateAssistantToggle(); }, onVisibilityChange: updateAssistantToggle,
    isAppliedDraftCurrent: jobId => current() && state.assistantDraftJobId === jobId && !!state.playlistDraft,
    reviewLabel: local ? "Save and prepare transfer" : "Save and review publishing",
    previewDraft: () => { navigate("playlists"); testItemInteractions(); }, reviewPublish: () => { navigate("playlists"); return reviewAssistantPublish(); },
    applyDraft: async (result, files, progress) => {
      validateAssistantResult(result);
      const originalDraft = state.playlistDraft, workspace = state.workspace;
      const check = () => { if (!current() || !canManageContent() || state.workspace !== workspace || state.playlistDraft !== originalDraft || assistantWouldReplaceUnsavedDraft()) throw assistantError("Open an editable workspace and save your current playlist edits before creating the new assistant playlist. Your existing work was not replaced."); };
      check();
      const normalized = new Map(), preparedRecords = new Map();
      for (const media of result.media) {
        check(); const file = files.get(media.sourceRef);
        if (!(file instanceof Blob)) throw assistantError("A verified assistant image is missing. Generate the draft again.");
        const image = await createImageBitmap(file);
        try {
          if (image.width !== media.width || image.height !== media.height) throw assistantError("An assistant image has unexpected dimensions.");
          if (file.type === "image/webp") {
            const canvas = document.createElement("canvas"); canvas.width = image.width; canvas.height = image.height;
            const context = canvas.getContext("2d"); if (!context) throw assistantError("This browser cannot prepare artwork.");
            context.drawImage(image, 0, 0);
            const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/png"));
            if (!blob) throw assistantError("The assistant artwork could not be converted.");
            normalized.set(media.sourceRef, new File([blob], file.name.replace(/\.[^.]+$/, "") + ".png", { type: "image/png" }));
          } else normalized.set(media.sourceRef, file);
        } finally { image.close(); }
      }
      const prepared = await buildAssistantPlaylist(result, {
        isCurrent: current, onProgress: progress,
        prepareOverlay: (sourceRef, budget) => prepareOverlay(normalized.get(sourceRef), budget),
        importArtwork: async (sourceRef, proposed) => {
          const key = sourceRef + ":" + proposed.appearance;
          if (preparedRecords.has(key)) return preparedRecords.get(key).asset;
          const file = normalized.get(sourceRef), source = await inspectContentSource(file);
          let presentation = proposed.appearance, artwork;
          try { artwork = await prepareArtwork(file, presentation, result.orientation, "#000", result.profileId); }
          catch (error) {
            if (presentation !== "scroll" || !/same aspect ratio|already matches/i.test(error.message)) throw error;
            presentation = "fit"; artwork = await prepareArtwork(file, "fit", result.orientation, "#000", result.profileId);
          }
          const asset = { ...artwork.metadata, assetId: crypto.randomUUID(), sourceWidth: source.metadata.width, sourceHeight: source.metadata.height,
            sourceSha256: source.metadata.sha256, preparation: presentation === "fit" ? 1 : 3, targetProfileId: result.profileId, libraryVisible: true };
          preparedRecords.set(key, { source, artwork, asset }); return asset;
        },
      });
      // All model-proposed geometry/actions and image hashes are validated before
      // adding any media. No device operation is reachable from this path.
      check(); const idMap = new Map(), finalAssets = [], sourceIds = new Map(); let localSnapshot = null;
      for (const record of preparedRecords.values()) {
        check(); progress(`Adding verified artwork ${finalAssets.length + 1} of ${preparedRecords.size}...`);
        const { source, artwork, asset } = record; let finalAsset = asset;
        if (local) {
          const sourceBytes = new Uint8Array(await source.blob.arrayBuffer()); check();
          const saved = await browserAuthoringWorkspaceStore.saveAsset(localAccountId, { assetId: asset.assetId, name: source.metadata.name,
            mediaType: source.metadata.sourceContentType, sha256: source.metadata.sha256, bytes: sourceBytes,
            thumbnail: artwork.previewUrl, width: asset.width, height: asset.height, sourceWidth: asset.sourceWidth, sourceHeight: asset.sourceHeight,
            orientation: asset.orientation, playbackMode: asset.playbackMode, pixelFormat: asset.pixelFormat, crc32: asset.crc32, extension: asset.extension });
          check(); localSnapshot = saved.workspace;
        } else {
          let sourceId = sourceIds.get(source.metadata.sha256);
          if (!sourceId) {
            const registration = await assistantApi.registerSource(source.metadata); check(); sourceId = registration.sourceId;
            if (registration.alreadyExists !== true) { await uploadBlob(registration.uploadUrl, source.blob); check(); await assistantApi.completeSource(sourceId); check(); }
            sourceIds.set(source.metadata.sha256, sourceId);
          }
          const registration = await assistantApi.registerArtwork({ ...artwork.metadata, logicalSourceAssetId: sourceId, preparation: asset.preparation, targetProfileId: result.profileId, libraryVisible: true }); check();
          if (registration.alreadyExists !== true) { await uploadBlob(registration.uploadUrl, artwork.blob); check(); await assistantApi.completeArtwork(registration.assetId); check(); }
          finalAsset = { ...asset, assetId: registration.assetId, logicalSourceAssetId: sourceId };
        }
        idMap.set(asset.assetId, finalAsset.assetId); finalAssets.push(finalAsset); state.thumbnailUrls.set(String(finalAsset.assetId), artwork.previewUrl);
      }
      check();
      for (const item of prepared.draft.items) {
        item.assetId = idMap.get(item.assetId);
        for (const area of item.interactions?.touchAreas ?? []) if (area.action.targetContentId) area.action.targetContentId = idMap.get(area.action.targetContentId);
      }
      if (localSnapshot) applyBrowserLocalWorkspace(localSnapshot);
      else { const content = new Map(array(state.workspace.content).map(asset => [String(asset.assetId ?? asset.id), asset])); finalAssets.forEach(asset => content.set(String(asset.assetId), asset)); state.workspace = { ...state.workspace, content: [...content.values()] }; }
      state.selectedPlaylist = null; state.selectedPlaylistId = null; state.playlistDraft = prepared.draft; state.assistantDraftJobId = result.jobId; state.selectedPlaylistItem = 0; state.drawingHotspot = false; state.route = "playlists";
      state.publicationValidation = null; state.publicationRequest = null; state.publishStep = 1;
      notify("Your new assistant playlist is ready to edit. Test interactions, save it, then review and confirm Publish to send it to a Pirdy.", "success"); render();
    },
  });
  updateAssistantToggle();
}

async function reviewAssistantPublish() {
  if (!state.assistantDraftJobId || !state.playlistDraft || state.busy) return;
  const account = state.account, assistantJob = state.assistantDraftJobId;
  await savePlaylistDraft();
  if (account !== state.account || state.assistantDraftJobId !== assistantJob || !state.selectedPlaylistId || assistantWouldReplaceUnsavedDraft()) return;
  if (isBrowserLocalWorkspace()) { await exportBrowserLocalPlaylist(); return; }
  state.publishStep = 2; state.publishTarget = null; state.publicationValidation = null; state.publicationRequest = null;
  navigate("publish");
}

function newPlaylistDraft() {
  if (!canManageContent()) return;
  state.assistantDraftJobId = null;
  state.selectedPlaylistId = null;
  state.selectedPlaylist = null;
  state.playlistDraft = { id: null, name: "Untitled playlist", version: null, items: [] };
  state.selectedPlaylistItem = 0;
  state.drawingHotspot = false;
  render();
}

const playlistItemIdentityPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;

function synchronizeBrowserLocalPlaylistTargets(items) {
  if (!isBrowserLocalWorkspace() || !Array.isArray(items)) return;
  for (const item of items) {
    if (!playlistItemIdentityPattern.test(String(item.instanceId ?? "")))
      item.instanceId = crypto.randomUUID();
  }
  for (const item of items) {
    for (const area of array(item?.interactions?.touchAreas)) {
      const action = area?.action;
      const kind = Number(action?.kind);
      if (kind === 6) {
        let targetIndex = playlistItemIdentityPattern.test(String(action.targetPlaylistItemId ?? ""))
          ? items.findIndex(candidate => candidate.instanceId === action.targetPlaylistItemId)
          : Number(action.targetPlaylistIndex);
        if (!Number.isInteger(targetIndex) || targetIndex < 0 || targetIndex >= items.length) {
          area.action = { kind: 0 };
          continue;
        }
        action.targetPlaylistIndex = targetIndex;
        action.targetPlaylistItemId = items[targetIndex].instanceId;
      } else if (kind === 1 || kind === 5) {
        const targetAssetId = String(action.targetContentId ?? "");
        let targetIndex = playlistItemIdentityPattern.test(String(action.targetPlaylistItemId ?? ""))
          ? items.findIndex(candidate => candidate.instanceId === action.targetPlaylistItemId &&
            String(candidate.assetId) === targetAssetId)
          : -1;
        if (targetIndex < 0) {
          const matches = items
            .map((candidate, index) => ({ candidate, index }))
            .filter(entry => String(entry.candidate.assetId) === targetAssetId);
          targetIndex = matches.length === 1 ? matches[0].index : -1;
        }
        action.targetPlaylistIndex = targetIndex >= 0 ? targetIndex : null;
        action.targetPlaylistItemId = targetIndex >= 0 ? items[targetIndex].instanceId : null;
      }
    }
  }
}

function selectPlaylistItem(index) {
  if (!Number.isInteger(index) || index < 0 || index >= (state.playlistDraft?.items?.length ?? 0)) return;
  syncItemEditorFields();
  state.selectedPlaylistItem = index;
  state.drawingHotspot = false;
  render();
  app.querySelector(`[data-playlist-item="${index}"]`)?.focus({ preventScroll: true });
}

function addAssetToPlaylist(assetId){addAssetsToPlaylist([assetId]);}
function addAssetsToPlaylist(assetIds){
  if(!state.playlistDraft||state.busy||!canManageContent()||!assetIds.length)return;
  syncItemEditorFields();
  try{
    const additions=preparePlaylistAddition(state.playlistDraft.items,assetIds,assetById,asset=>({...createPlaylistItem(asset),...(isBrowserLocalWorkspace()?{instanceId:crypto.randomUUID()}:{} )}));
    state.playlistDraft.items.push(...additions);playlistSourceSelection().clear();
    synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
    state.selectedPlaylistItem=state.playlistDraft.items.length-1;state.drawingHotspot=false;render();
  }catch(error){notify(customerVisibleErrorMessage(error,"Content could not be added to this playlist."),"error");}
}
function bindPlaylistCardInput(){
  const draft=state.playlistDraft,account=state.account;let dragged=null;
  const current=()=>draft===state.playlistDraft&&account===state.account&&!state.busy&&canManageContent();
  app.querySelectorAll("[data-playlist-drag-index]").forEach(card=>{
    const index=Number(card.dataset.playlistDragIndex);
    card.addEventListener("dragstart",event=>{
      if(!current()){event.preventDefault();return;}
      dragged={draft,account,index};event.dataTransfer.effectAllowed="move";event.dataTransfer.setData("text/plain",String(index));
    });
    card.addEventListener("dragover",event=>{if(current()&&dragged?.draft===draft&&dragged.account===account){event.preventDefault();event.dataTransfer.dropEffect="move";}});
    card.addEventListener("drop",event=>{
      event.preventDefault();if(!current()||dragged?.draft!==draft||dragged.account!==account)return;
      const from=dragged.index;dragged=null;if(from!==index)movePlaylistItem(from,index-from);
    });
    card.addEventListener("dragend",()=>{dragged=null;});
    card.querySelector("[data-playlist-item]")?.addEventListener("keydown",event=>{
      if(!current()||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();const target=event.key==='Home'?0:event.key==='End'?draft.items.length-1:Math.max(0,Math.min(draft.items.length-1,index+(event.key==='ArrowLeft'?-1:1)));
      selectPlaylistItem(target);
      requestAnimationFrame(()=>{if(!current())return;const button=app.querySelector('[data-playlist-item="'+target+'"]'),strip=app.querySelector('[data-scroll-key="playback-order"]');
        button?.focus({preventScroll:true});if(button&&strip){const card=button.closest('[data-playlist-drag-index]'),left=card.offsetLeft-strip.offsetLeft;
          if(left<strip.scrollLeft)strip.scrollLeft=left;else if(left+card.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollLeft=left+card.offsetWidth-strip.clientWidth;}
      });
    });
  });
}

function movePlaylistItem(index, delta) {
  syncItemEditorFields();
  synchronizeBrowserLocalPlaylistTargets(state.playlistDraft?.items);
  const destination = index + delta;
  if (!state.playlistDraft || destination < 0 || destination >= state.playlistDraft.items.length) return;
  movePlaylistItemWithTargets(state.playlistDraft.items, index, destination);
  synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
  state.selectedPlaylistItem = destination;
  render();
}

function duplicatePlaylistItem(index) {
  if (!state.playlistDraft || state.busy) return;
  syncItemEditorFields();
  try {
    synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
    duplicatePlaylistItemWithTargets(state.playlistDraft.items, index);
    synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
    state.selectedPlaylistItem = index + 1;state.drawingHotspot = false;render();
  } catch (error) { notify(customerVisibleErrorMessage(error, "The image could not be duplicated."), "error"); }
}

function removePlaylistItem(index) {
  if (!state.playlistDraft) return;
  syncItemEditorFields();
  synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
  removePlaylistItemWithTargets(state.playlistDraft.items, index);
  synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
  state.selectedPlaylistItem = Math.min(index, Math.max(0, state.playlistDraft.items.length - 1));
  state.drawingHotspot = false;
  render();
}

function syncHotspotFields(item = state.playlistDraft?.items?.[state.selectedPlaylistItem]) {
  if (!item) return;
  const areas = array(item.interactions?.touchAreas);
  app.querySelectorAll("[data-hotspot-name]").forEach(input => {
    const area = areas[Number(input.dataset.hotspotName)];
    if (area) area.name = input.value.trim();
  });
}

function syncItemSettingFields(item = state.playlistDraft?.items?.[state.selectedPlaylistItem]) {
  if (!item) return;
  const hotspotOnly = app.querySelector("#item-hotspot-only");
  if (hotspotOnly) item.autoplay = !hotspotOnly.checked;
  const presentation = app.querySelector('input[name="item-presentation"]:checked');
  if (presentation) item.requestedPresentation = Number(presentation.value);
  const setNumber = (selector, property, transform = value => value) => {
    const control = app.querySelector(selector);
    if (!control || control.value === "") return;
    const value = Number(control.value);
    if (Number.isFinite(value)) item[property] = transform(value);
  };
  setNumber("#item-horizontal-direction", "requestedHorizontalDirection");
  setNumber("#item-vertical-direction", "requestedVerticalDirection");
  setNumber("#item-horizontal-speed", "requestedHorizontalSpeedPxPerSecond");
  setNumber("#item-vertical-speed", "requestedVerticalSpeedPxPerSecond");
  setNumber("#item-hold", "holdDurationMs", value => Math.round(value * 1000));
  setNumber("#item-fade", "effectDurationMs");
  setNumber("#item-transition", "transitionEffect");
  setNumber("#item-transition-duration", "transitionDurationMs");
}

function syncItemEditorFields(item = state.playlistDraft?.items?.[state.selectedPlaylistItem]) {
  // Dirty-state checks pass a copy. Inspecting it must not change the draft.
  if (item === state.playlistDraft?.items?.[state.selectedPlaylistItem]) {
    const name = app.querySelector("#playlist-name");
    if (name && state.playlistDraft) state.playlistDraft.name = name.value;
  }
  syncItemSettingFields(item);
  syncHotspotFields(item);
}

function applyItemSettings(notifyResult = true) {
  const item = state.playlistDraft?.items?.[state.selectedPlaylistItem];
  const asset = item ? assetById(item.assetId) : null;
  if (!item || !asset) return false;
  try {
    synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
    syncItemEditorFields();
    const areas = array(item.interactions?.touchAreas);
    validateHotspots(areas, asset);
    validatePlaylistAudio(state.playlistDraft.items,array(state.workspace?.content));
    validateOverlayPlaylist(state.playlistDraft.items);
    validateStaticOverlays(item,hotspotBounds({coordinateMode:2},asset));
    for (const area of areas) {
      if (!area.name) throw new Error("Every hotspot needs a name.");
      if (!Number(area.action?.kind)) throw new Error("Choose an action for every hotspot.");
      if ([1, 5].includes(Number(area.action.kind)) && !area.action.targetContentId) throw new Error("Choose destination content for every Show action.");
      if (Number(area.action.kind) === 6 && !Number.isInteger(area.action.targetPlaylistIndex)) throw new Error("Choose a playlist image for every Go To action.");
    }
    const values = {
      interactions: areas.length ? { touchAreas: areas } : null,
      ...staticOverlayFields(item), ...audioFields(item),
      transitionEffect: Number(item.transitionEffect ?? 1),
      transitionDurationMs: Number(item.transitionDurationMs ?? 500),
      requestedPresentation: Number(app.querySelector('input[name="item-presentation"]:checked')?.value ?? item.requestedPresentation ?? 1),
    };
    if (values.requestedPresentation === 1) {
      values.effectIn = 1;
      values.effectOut = 1;
      values.effectDurationMs = Number(app.querySelector("#item-fade")?.value ?? item.effectDurationMs ?? 500);
      values.holdDurationMs = Math.round(Number(app.querySelector("#item-hold")?.value ?? 5) * 1000);
    } else {
      values.requestedHorizontalDirection = Number(app.querySelector("#item-horizontal-direction")?.value ?? item.requestedHorizontalDirection ?? Direction.left);
      values.requestedVerticalDirection = Number(app.querySelector("#item-vertical-direction")?.value ?? item.requestedVerticalDirection ?? Direction.up);
      values.requestedHorizontalSpeedPxPerSecond = Number(app.querySelector("#item-horizontal-speed")?.value ?? item.requestedHorizontalSpeedPxPerSecond ?? 10);
      values.requestedVerticalSpeedPxPerSecond = Number(app.querySelector("#item-vertical-speed")?.value ?? item.requestedVerticalSpeedPxPerSecond ?? 5);
      const sourceWide = Number(asset.playbackMode) !== PlaybackMode.vertical &&
        Number(asset.sourceWidth ?? asset.width) * Number(asset.height) >= Number(asset.width) * Number(asset.sourceHeight ?? asset.height);
      values.direction = sourceWide ? values.requestedHorizontalDirection : values.requestedVerticalDirection;
      values.speedPxPerSecond = sourceWide ? values.requestedHorizontalSpeedPxPerSecond : values.requestedVerticalSpeedPxPerSecond;
    }
    const replacement = createPlaylistItem(asset, values);
    replacement.autoplay = item.autoplay == null ? true : item.autoplay === true;
    if (replacement.type === "scroll")
      replacement.loopArtwork = item.loopArtwork == null ? false : item.loopArtwork === true;
    if (isBrowserLocalWorkspace()) replacement.instanceId = item.instanceId;
    editorViewState.transferSections(item, replacement);
    if (overlayEditorsExpanded.has(item)) overlayEditorsExpanded.add(replacement);
    if (overlaySelections.has(item)) overlaySelections.set(replacement, overlaySelections.get(item));
    state.playlistDraft.items[state.selectedPlaylistItem] = replacement;
    synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
    if (notifyResult) notify(`${asset.name} settings were applied to this playlist draft.`, "success");
    render();
    return true;
  } catch (error) {
    notify(customerVisibleErrorMessage(error,
      "Review every hotspot name, action, and destination before applying settings."), "error");
    return false;
  }
}

async function savePlaylistDraft() {
  if (!state.playlistDraft || reviewMode || !canManageContent() || state.busy) return;
  const name = app.querySelector("#playlist-name")?.value?.trim() ?? state.playlistDraft.name.trim();
  synchronizeBrowserLocalPlaylistTargets(state.playlistDraft.items);
  if (state.playlistDraft.items.length && !applyItemSettings(false)) return;
  if (!name) return notify("Enter a playlist name.", "error");
  if (state.playlistDraft.items.length && !state.playlistDraft.items.some(item => item.autoplay !== false))
    return notify("Keep at least one artwork in normal playback. Uncheck Touch hotspot only for that artwork.", "error");
  const draft = state.playlistDraft, workspace = state.workspace, account = state.account;
  let saveSelectionOperation = state.playlistSelectionOperation;
  draft.name = name;
  state.publicationValidation = null;
  state.publicationRequest = null;
  state.publicationPlaylistFingerprint = null;
  state.publicationReviewBinding = null;
  state.busy = true;
  render();
  try {
    const payload = { name, items: draft.items };
    if (isBrowserLocalWorkspace()) {
      const accountId = browserLocalAccountId();
      if (!accountId) return;
      const id = draft.id ?? crypto.randomUUID();
      const stored = await browserAuthoringWorkspaceStore.savePlaylist(accountId, {
        id,
        version: draft.id ? draft.version : null,
        ...payload,
      });
      if (workspace !== state.workspace || account !== state.account ||
          state.playlistDraft !== draft || state.playlistSelectionOperation !== saveSelectionOperation || browserLocalAccountId() !== accountId) return;
      applyBrowserLocalWorkspace(stored.workspace);
      state.selectedPlaylistId = id;
      state.selectedPlaylist = structuredClone(stored.result);
      state.playlistDraft = structuredClone(stored.result);
      state.selectedPlaylistItem = 0;
      notify("Playlist saved only in this browser. No Pirdy was changed. Prepare a local transfer to install it.", "success");
      return;
    }
    const scope = playlistRecoveryScope(workspace);
    let saved;
    if (draft.id) saved = await updatePlaylist(draft.id, draft.version, payload);
    else {
      const pending = playlistCreateRecovery.stage(scope, payload, draft.createRequestId);
      draft.createRequestId = pending.request.requestId;
      saved = await createPlaylist(pending.request);
      if (workspace !== state.workspace || account !== state.account || state.playlistDraft !== draft || state.playlistSelectionOperation !== saveSelectionOperation) return;
      if (!saved?.id || saved.version <= 0) throw new Error("The original save was not confirmed.");
      draft.id = saved.id;draft.version = saved.version;
      if (JSON.stringify({ name: pending.request.name, items: pending.request.items }) !== JSON.stringify(payload)) saved = await updatePlaylist(saved.id, saved.version, payload);
      if (workspace !== state.workspace || account !== state.account || state.playlistDraft !== draft || state.playlistSelectionOperation !== saveSelectionOperation) return;
      playlistCreateRecovery.complete(scope, draft.createRequestId);draft.createRequestId = null;
    }
    if (workspace !== state.workspace || account !== state.account || state.playlistDraft !== draft || state.playlistSelectionOperation !== saveSelectionOperation) return;
    if (draft.createRequestId) { playlistCreateRecovery.complete(scope, draft.createRequestId);draft.createRequestId = null; }
    const id = String(saved.id ?? saved.playlistId);
    await refreshWorkspace({ announce: false });
    if (account !== state.account || state.playlistSelectionOperation !== saveSelectionOperation) return;
    const reloading = selectPlaylist(id, { preserveAssistant: true });
    saveSelectionOperation = state.playlistSelectionOperation;
    const reloaded = await reloading;
    if (account !== state.account || state.playlistSelectionOperation !== saveSelectionOperation) return;
    if (!reloaded) return notify("Playlist saved, but its updated details could not be loaded. Device playback is unchanged. Reload the saved playlist before publishing.", "error");
    notify("Playlist saved, including hotspots. Device playback is unchanged. Open Publish to send the saved playlist, then check device installation status.", "success");
  } catch (error) {
    rememberBrowserLocalFailure(error);
    if (workspace === state.workspace && account === state.account && state.playlistSelectionOperation === saveSelectionOperation) notify(`${customerVisibleErrorMessage(error,
      "The playlist could not be saved.")} Your draft and unfinished save are retained. Refresh before retrying if another session changed this playlist.`, "error");
  } finally {
    if (account === state.account && state.playlistSelectionOperation === saveSelectionOperation) { state.busy = false;render(); }
  }
}

async function exportBrowserLocalPlaylist() {
  if (!isBrowserLocalWorkspace() || state.busy) return;
  syncItemEditorFields();
  const draft = state.playlistDraft;
  const account = state.account;
  const accountId = browserLocalAccountId();
  const playlistId = String(draft?.id ?? "");
  const saved = state.browserLocalPlaylists.get(playlistId);
  if (!accountId || !saved)
    return notify("Save this playlist before preparing a local transfer.", "error");
  if (!array(saved.items).length)
    return notify("Add at least one image and save the playlist before transferring it.", "error");
  if (JSON.stringify({ name: draft.name, items: draft.items }) !==
      JSON.stringify({ name: saved.name, items: saved.items }))
    return notify("Save the latest playlist settings before preparing the transfer.", "error");

  const isCurrent = () => state.account === account &&
    browserLocalAccountId() === accountId && state.playlistDraft === draft;
  let transfer = null;
  state.busy = true;
  render();
  try {
    const snapshot = await browserAuthoringWorkspaceStore.readTransferSnapshot(
      accountId, { playlistId });
    if (!isCurrent()) return;
    transfer = await createPirdyTransfer(snapshot, {
      currentAccountId: accountId,
      getCurrentAccountId: browserLocalAccountId,
    });
    if (!isCurrent()) return;
    const delivery = await deliverPirdyTransfer(transfer, {
      currentAccountId: accountId,
      getCurrentAccountId: browserLocalAccountId,
    });
    if (!isCurrent()) return;
    notify(delivery.method === "share"
      ? "The verified playlist is ready in your device's share sheet. Choose Pirdy Customer App to continue."
      : "The verified Pirdy transfer was downloaded. Open it with Pirdy Customer App, then choose a Pirdy and connection.",
    "success");
  } catch (error) {
    if (!isCurrent()) return;
    if (error?.name === "AbortError")
      notify("Local transfer was cancelled. Nothing was sent or changed.", "error");
    else {
      rememberBrowserLocalFailure(error);
      notify(customerVisibleErrorMessage(error,
        "The local transfer could not be prepared. Existing content was not changed."), "error");
    }
  } finally {
    transfer?.bytes?.fill?.(0);
    if (isCurrent()) {
      state.busy = false;
      render();
    }
  }
}

async function removePlaylistDraft() {
  const id = state.playlistDraft?.id;
  if (!state.playlistDraft || reviewMode || !canManageContent() || state.busy) return;
  if (!id) {
    state.selectedPlaylistId = null;
    state.selectedPlaylist = null;
    state.playlistDraft = null; state.assistantDraftJobId = null;
    render();
    notify("Unsaved playlist discarded. Saved playlists and device playback are unchanged.", "success");
    return;
  }
  const account = state.account;
  const organization = state.workspace?.me?.organizationId;
  const isCurrent = () => state.account === account && state.workspace?.me?.organizationId === organization;
  state.busy = true;
  render();
  try {
    if (isBrowserLocalWorkspace()) {
      const accountId = browserLocalAccountId();
      if (!accountId) return;
      const deleted = await browserAuthoringWorkspaceStore.deletePlaylist(
        accountId, id, state.playlistDraft.version);
      if (!isCurrent() || browserLocalAccountId() !== accountId) return;
      applyBrowserLocalWorkspace(deleted.workspace);
      state.selectedPlaylistId = null;
      state.selectedPlaylist = null;
      state.playlistDraft = null; state.assistantDraftJobId = null;
      notify("Playlist was removed from this browser-local workspace.", "success");
      return;
    }
    const result = await deletePlaylist(id);
    if (!isCurrent()) return;
    if (result?.deleted !== true || String(result.id) !== String(id)) throw new Error("Pirdy did not confirm this playlist deletion. Refresh and try again.");
    state.selectedPlaylistId = null;
    state.selectedPlaylist = null;
    state.playlistDraft = null; state.assistantDraftJobId = null;
    state.workspace = { ...state.workspace, playlists: array(state.workspace?.playlists).filter(playlist => String(playlist.id ?? playlist.playlistId) !== String(id)) };
    await refreshWorkspace({ announce: false });
    if (isCurrent()) notify("Playlist deleted. Existing active publications were not changed.", "success");
  } catch (error) {
    rememberBrowserLocalFailure(error);
    if (isCurrent()) notify(customerVisibleErrorMessage(error,
      "The playlist could not be deleted. Refresh it and try again."), "error");
  } finally {
    if (isCurrent()) { state.busy = false; render(); }
  }
}

function deleteHotspot(index) {
  syncItemEditorFields();
  const item = state.playlistDraft?.items?.[state.selectedPlaylistItem];
  const areas = array(item?.interactions?.touchAreas);
  areas.splice(index, 1);
  item.interactions = areas.length ? { touchAreas: areas } : null;
  render();
}

function changeHotspotAction(index, kind) {
  syncItemEditorFields();
  const area = state.playlistDraft?.items?.[state.selectedPlaylistItem]?.interactions?.touchAreas?.[index];
  if (!area) return;
  area.action = { kind };
  render();
}

function changeHotspotTarget(index, value) {
  syncHotspotFields();
  synchronizeBrowserLocalPlaylistTargets(state.playlistDraft?.items);
  const area = state.playlistDraft?.items?.[state.selectedPlaylistItem]?.interactions?.touchAreas?.[index];
  if (!area) return;
  const kind = Number(area.action?.kind);
  area.action = kind === 6
    ? { kind, targetPlaylistIndex: value === "" ? null : Number(value),
        targetPlaylistItemId: value === "" ? null : state.playlistDraft.items[Number(value)]?.instanceId ?? null }
    : { kind, targetContentId: value || null };
  synchronizeBrowserLocalPlaylistTargets(state.playlistDraft?.items);
}

function bindHotspotStage() {
  const gesture = { pointerId: null };
  bindHotspotSurface("#hotspot-stage", false, gesture);
  bindHotspotSurface("#screen-hotspot-stage", true, gesture);
}

function bindHotspotSurface(selector, screenFixed, gesture) {
  const stage = app.querySelector(selector);
  if (!stage) return;
  const selectedItem = state.playlistDraft?.items?.[state.selectedPlaylistItem];
  const selectedAsset = selectedItem ? assetById(selectedItem.assetId) : null;
  if (!selectedAsset) return;
  applyHotspotGeometry(stage, selectedAsset,
    hotspotBounds({ coordinateMode: screenFixed ? 2 : 1 }, selectedAsset), array(selectedItem.interactions?.touchAreas));
  const viewport = stage.closest?.(".hotspot-viewport");
  if (viewport) {
    const key = `${selectedItem.instanceId ?? state.selectedPlaylistItem}:${selectedAsset.assetId ?? selectedAsset.id}:${screenFixed}`;
    const saved = state.hotspotViewportPosition?.[key];
    if (saved) { viewport.scrollLeft = saved.x; viewport.scrollTop = saved.y; }
    viewport.addEventListener("scroll", () => {
      state.hotspotViewportPosition = { ...state.hotspotViewportPosition, [key]: { x: viewport.scrollLeft, y: viewport.scrollTop } };
    });
  }
  stage.addEventListener("pointerdown", event => {
    if (gesture.pointerId !== null) return;
    const item = state.playlistDraft?.items?.[state.selectedPlaylistItem];
    const asset = item ? assetById(item.assetId) : null;
    if (!item || !asset) return;
    const existing = event.target.closest("[data-hotspot]");
    if (!existing && (screenFixed || !state.drawingHotspot)) return;
    event.preventDefault();
    syncItemEditorFields();
    const pointerId = event.pointerId;
    gesture.pointerId = pointerId;
    try { stage.setPointerCapture(pointerId); }
    catch { gesture.pointerId = null;return; }
    const index = existing ? Number(existing.dataset.hotspot) : -1;
    const areas = array(item.interactions?.touchAreas);
    const bounds = hotspotBounds({ coordinateMode: screenFixed ? 2 : 1 }, asset);
    const start = sourcePoint(event, stage, bounds);
    const original = index >= 0 ? { ...areas[index].region } : null;
    const hotspotRect = existing?.getBoundingClientRect();
    const resizing = Boolean(existing && event.clientX >= hotspotRect.right - 18 && event.clientY >= hotspotRect.bottom - 18);
    const provisional = document.createElement("span");
    provisional.className = "hotspot provisional";
    if (index < 0) stage.append(provisional);
    const update = moveEvent => {
      if (moveEvent.pointerId !== pointerId || gesture.pointerId !== pointerId) return;
      const current = sourcePoint(moveEvent, stage, bounds);
      let region;
      if (index >= 0) region = transformHotspot(original, current.x - start.x, current.y - start.y, bounds, resizing);
      else region = clampHotspot({ x: Math.min(start.x, current.x), y: Math.min(start.y, current.y), width: Math.max(1, Math.abs(current.x - start.x)), height: Math.max(1, Math.abs(current.y - start.y)) }, bounds);
      const node = index >= 0 ? existing : provisional;
      positionHotspot(node, region, bounds);
      node._region = region;
    };
    const cleanup = () => {
      stage.removeEventListener("pointermove", update);
      stage.removeEventListener("pointerup", finish);
      stage.removeEventListener("pointercancel", cancel);
      stage.removeEventListener("lostpointercapture", cancel);
      gesture.pointerId = null;
      if (stage.hasPointerCapture?.(pointerId)) stage.releasePointerCapture(pointerId);
    };
    const cancel = cancelEvent => {
      if (cancelEvent.pointerId !== pointerId || gesture.pointerId !== pointerId) return;
      cleanup();
      state.drawingHotspot = false;
      render();
    };
    const finish = upEvent => {
      if (upEvent.pointerId !== pointerId || gesture.pointerId !== pointerId) return;
      update(upEvent);
      cleanup();
      const region = (index >= 0 ? existing : provisional)._region;
      if (index >= 0) areas[index].region = clampHotspot(region, bounds);
      else {
        const minimum = clampHotspot({ ...region, width: Math.max(32, region.width), height: Math.max(32, region.height) }, asset);
        areas.push({ id: crypto.randomUUID(), name: `Hotspot ${areas.length + 1}`, region: minimum, coordinateMode: 1, action: { kind: 0 } });
        item.interactions = { touchAreas: areas };
      }
      state.drawingHotspot = false;
      render();
    };
    stage.addEventListener("pointermove", update);
    stage.addEventListener("pointerup", finish);
    stage.addEventListener("pointercancel", cancel);
    stage.addEventListener("lostpointercapture", cancel);
  });
}

function sourcePoint(event, stage, asset) {
  const bounds = stage.getBoundingClientRect();
  return {
    x: Math.max(0, Math.min(Number(asset.width), Math.round((event.clientX - bounds.left) * Number(asset.width) / bounds.width))),
    y: Math.max(0, Math.min(Number(asset.height), Math.round((event.clientY - bounds.top) * Number(asset.height) / bounds.height))),
  };
}

function positionHotspot(node, region, asset) {
  node.style.left = `${region.x / asset.width * 100}%`;
  node.style.top = `${region.y / asset.height * 100}%`;
  node.style.width = `${region.width / asset.width * 100}%`;
  node.style.height = `${region.height / asset.height * 100}%`;
}

async function prepareSelectedBranding() {
  const file = app.querySelector("#branding-file")?.files?.[0];
  if (!file) return notify("Choose a PNG or JPEG logo.", "error");
  const isCurrent = customerOperationScope();
  state.busy = true;
  render();
  try {
    const prepared = await prepareBranding(file);
    if (!isCurrent()) return;
    state.preparedBranding = { ...prepared, sourceFile: file, sourceFileName: file.name, sourceContentType: file.type };
    notify("Both orientation previews were prepared and verified locally.", "success");
  } catch (error) {
    if (!isCurrent()) return;
    notify(customerVisibleErrorMessage(error,
      "That startup logo could not be prepared. Choose a valid PNG or JPEG and try again."), "error");
  } finally {
    if (isCurrent()) { state.busy = false; render(); }
  }
}

async function uploadPreparedBranding() {
  const prepared = state.preparedBranding;
  if (!prepared || reviewMode || !canAdminister()) return;
  if (!canCommitMeteredCloudChange()) return rejectUnavailableCloudChange();
  const isCurrent = customerOperationScope();
  state.busy = true;
  render();
  try {
    const registration = await registerBranding({
      sourceFileName: prepared.sourceFileName,
      sourceContentType: prepared.sourceContentType,
      landscape: brandingArtifact(prepared.landscape),
      portrait: brandingArtifact(prepared.portrait),
      duosLandscape: brandingArtifact(prepared.duosLandscape),
      duosPortrait: brandingArtifact(prepared.duosPortrait),
    });
    if (!isCurrent()) return;
    if (registration.alreadyCurrent !== true) {
      await Promise.all([
        uploadBlob(registration.landscapeUploadUrl, prepared.landscape.blob),
        uploadBlob(registration.portraitUploadUrl, prepared.portrait.blob),
        uploadBlob(registration.duosLandscapeUploadUrl, prepared.duosLandscape.blob),
        uploadBlob(registration.duosPortraitUploadUrl, prepared.duosPortrait.blob),
      ]);
      if (!isCurrent()) return;
      await completeBranding(registration.version);
      if (!isCurrent()) return;
    }
    state.preparedBranding = null;
    await refreshWorkspace({ announce: false });
    if (!isCurrent()) return;
    notify(registration.alreadyCurrent ? "This startup logo is already saved in Cloud; device installation is not confirmed." : "Startup logo saved in Cloud. Each Pirdy must connect and download it before its next startup; device installation is not confirmed.", "success");
  } catch (error) {
    if (!isCurrent()) return;
    notify(`${customerVisibleErrorMessage(error,
      "The startup logo could not be saved.")} The previous startup logo remains active.`, "error");
  } finally {
    if (isCurrent()) { state.busy = false; render(); }
  }
}

async function restoreDefaultBranding() {
  if (reviewMode || !canAdminister()) return;
  if (!canCommitMeteredCloudChange()) return rejectUnavailableCloudChange();
  const isCurrent = customerOperationScope();
  state.busy = true;
  render();
  try {
    await removeBranding();
    if (!isCurrent()) return;
    state.preparedBranding = null;
    await refreshWorkspace({ announce: false });
    if (!isCurrent()) return;
    notify("Default logo reset saved in Cloud. Each Pirdy must receive the change; device installation is not confirmed.", "success");
  } catch (error) {
    if (!isCurrent()) return;
    notify(customerVisibleErrorMessage(error,
      "The default startup logo could not be restored. The previous logo remains active."), "error");
  } finally {
    if (isCurrent()) { state.busy = false; render(); }
  }
}

function brandingArtifact(prepared) {
  return { sha256: prepared.metadata.sha256, fileSize: prepared.metadata.fileSize, width: prepared.metadata.width, height: prepared.metadata.height };
}

async function hydrateThumbnails() {
  if (reviewMode || !["content", "playlists"].includes(state.route)) return;
  if (isBrowserLocalWorkspace()) return;
  if (!state.workspace || state.workspaceLoading || state.workspaceError || state.workspace.resourceErrors?.content) return;
  const route = state.route;
  const result = await mediaPreviews.load(array(state.workspace?.content).filter(asset=>!isAudioAsset(asset)), createMediaDownloads, previewPimg);
  if (!result || state.route !== route) return;
  render();
  if (result.failed) notify(`${result.failed} preview(s) could not be loaded. Content remains in your library; use Retry previews.`, "error");
}

async function hydrateEditorArtwork() {
  if (reviewMode || isBrowserLocalWorkspace()) return;
  const item = state.playlistDraft?.items?.[state.selectedPlaylistItem];
  const asset = item ? assetById(item.assetId) : null;
  if (!asset || !app.querySelector(".hotspot-viewport, .static-overlay-preview")) return;
  const assetId = String(asset.assetId ?? asset.id), account = state.account, workspace = state.workspace;
  const current = () => state.account === account && state.workspace === workspace &&
    String(state.playlistDraft?.items?.[state.selectedPlaylistItem]?.assetId) === assetId;
  const apply = url => {
    if (!current()) return;
    app.querySelectorAll(".hotspot-stage > img").forEach(image => { image.src = url; });
  };
  const cached = state.editorArtwork;
  if (cached?.assetId === assetId && cached.account === account && cached.workspace === workspace) {
    if (cached.url) apply(cached.url);
    return;
  }
  // Keep just the selected full-resolution image; library thumbnails stay small.
  const request = { assetId, account, workspace };
  state.editorArtwork = request;
  try {
    const download = array(await createMediaDownloads()).find(value => String(value.assetId) === assetId);
    if (!current() || state.editorArtwork !== request) return;
    if (!download?.downloadUrl) throw new Error("Preview unavailable");
    const url = await previewPimg(download.downloadUrl, 16_384);
    if (!current() || state.editorArtwork !== request) return;
    request.url = url;
    apply(url);
  } catch {
    if (current() && state.editorArtwork === request)
      notify("The full-resolution artwork preview could not load. Reopen this playlist after checking your connection.", "error");
  }
}

async function hydrateItemPresentationPreview() {
  const item = state.playlistDraft?.items?.[state.selectedPlaylistItem];
  const asset = item ? assetById(item.assetId) : null;
  if (!asset || !app.querySelector("[data-item-preview-viewport]")) return;
  let plan;
  try { plan = itemPreviewPlan(item, asset); }
  catch { return; } // The render already shows the planner's validation message.
  applyItemPreviewGeometry(app, plan);
  const account = state.account, workspace = state.workspace, draft = state.playlistDraft;
  const request = { account, workspace, item, plan };
  const scrollAreas = [["[data-item-preview-viewport]", "main"], [".static-overlay-artwork", "overlay"]]
    .map(([selector, kind]) => ({ element: app.querySelector(selector), kind })).filter(area => area.element);
  for (const { element, kind } of scrollAreas)
    element.onscroll = () => selectedItemPreview.rememberPosition(item, plan.signature, kind, element.scrollLeft, element.scrollTop);
  const current = () => {
    if (state.account !== account || state.workspace !== workspace || state.playlistDraft !== draft || state.playlistDraft?.items?.[state.selectedPlaylistItem] !== item) return false;
    try { return itemPreviewPlan(item, asset).signature === plan.signature; } catch { return false; }
  };
  const result = await selectedItemPreview.load(request, async () => {
    if (reviewMode) throw Object.assign(new Error("Original source pixels are unavailable in this visual-review fixture."), { customerSafe: true });
    const assetId = String(asset.assetId ?? asset.id);
    const sourceKey = JSON.stringify([assetId, asset.logicalSourceAssetId, asset.sourceSha256 ?? asset.sha256]);
    if (!selectedPreviewSource || selectedPreviewSource.account !== account || selectedPreviewSource.workspace !== workspace || selectedPreviewSource.key !== sourceKey) {
      const source = { account, workspace, key: sourceKey };
      selectedPreviewSource = source;
      source.pending = (async () => {
        if (isBrowserLocalWorkspace()) {
          const snapshot = await browserAuthoringWorkspaceStore.open(browserLocalAccountId());
          const stored = snapshot.assets.find(value => String(value.assetId) === assetId);
          if (!stored) throw new Error("Original artwork is unavailable in this browser.");
          return new File([stored.bytes], stored.name + (stored.mediaType === "image/jpeg" ? ".jpg" : ".png"), { type: stored.mediaType });
        }
        if (asset.logicalSourceAssetId) {
          const download = array(await createContentSourceDownloads()).find(value => String(value.sourceId) === String(asset.logicalSourceAssetId));
          if (!download?.downloadUrl) throw new Error("Original artwork is unavailable. Re-import it to preview this layout.");
          return downloadVerifiedSource(download.downloadUrl, asset);
        }
        // Historical PIMG-only assets have no original source to re-download.
        // Decode their verified pixels; never stretch a Fit bitmap into a long image.
        if (plan.sourceWidth !== Number(asset.width) || plan.sourceHeight !== Number(asset.height))
          throw new Error("Original artwork is unavailable. Re-import it to preview this layout.");
        const download = array(await createMediaDownloads()).find(value => String(value.assetId) === assetId);
        if (!download?.downloadUrl) throw new Error("The saved artwork preview is unavailable.");
        const dataUrl = await previewPimg(download.downloadUrl, 16_384);
        const response = await fetch(dataUrl);
        return new File([await response.blob()], asset.name + ".png", { type: "image/png" });
      })();
    }
    const file = await selectedPreviewSource.pending;
    if (!current()) throw new Error("The selected artwork changed.");
    const prepared = await prepareArtwork(file, plan.presentation, plan.orientation, "#000", plan.profileId);
    return { url: prepared.previewUrl, width: prepared.metadata.width, height: prepared.metadata.height };
  });
  if (!result || !current()) return;
  if (result.error) {
    selectedPreviewSource = null;
    app.querySelectorAll("[data-item-preview-message]").forEach(node => {
      node.hidden = false;
      node.textContent = customerVisibleErrorMessage(result.error, "This artwork preview could not be prepared. Reopen the playlist to retry.");
    });
    return;
  }
  app.querySelectorAll("[data-item-preview-artwork], [data-overlay-artwork]").forEach(image => {
    image.src = result.url; image.hidden = false;
    image.style.width = result.width + "px"; image.style.height = result.height + "px";
  });
  applyItemPreviewGeometry(app, plan);
  for (const { element, kind } of scrollAreas) {
    const position = selectedItemPreview.position(item, plan.signature, kind);
    element.scrollLeft = position.left; element.scrollTop = position.top;
  }
  app.querySelectorAll("[data-item-preview-message]").forEach(node => { node.hidden = true; });
}

function testItemInteractions() {
  const draft = state.playlistDraft, account = state.account, workspace = state.workspace;
  if (!draft?.items?.length) return;
  const originals = draft.items, items = structuredClone(originals), files = new Map();
  syncItemEditorFields(items[state.selectedPlaylistItem]);
  for (const id of interactionTargetContentIds(items)) {
    if (items.some(item => String(item.assetId) === id)) continue;
    const asset = assetById(id);
    if (asset && !isAudioAsset(asset)) items.push({ ...createPlaylistItem(asset), autoplay: false });
  }
  const isCurrent = () => state.route === "playlists" && state.account === account && state.workspace === workspace && state.playlistDraft === draft;
  openInteractionPreview({ items, selectedIndex: state.selectedPlaylistItem, isCurrent,
    prepareItem: async (item, index) => {
      const asset = assetById(item.assetId);
      if (!asset) throw new Error("This artwork is unavailable in the current workspace.");
      const plan = itemPreviewPlan(item, asset), cached = originals[index] && selectedItemPreview.peek({ account, workspace, item: originals[index], plan });
      let url = cached?.url;
      if (!url) {
        const id = String(asset.assetId ?? asset.id);
        if (!files.has(id)) {
          if (files.size >= 2) files.delete(files.keys().next().value);
          files.set(id, (async () => {
          if (isBrowserLocalWorkspace()) {
            const snapshot = await browserAuthoringWorkspaceStore.open(browserLocalAccountId());
            const stored = snapshot.assets.find(value => String(value.assetId) === id);
            if (!stored) throw new Error("Original artwork is unavailable in this browser.");
            return new File([stored.bytes], stored.name + (stored.mediaType === "image/jpeg" ? ".jpg" : ".png"), { type: stored.mediaType });
          }
          if (asset.logicalSourceAssetId) {
            const download = array(await createContentSourceDownloads()).find(value => String(value.sourceId) === String(asset.logicalSourceAssetId));
            if (!download?.downloadUrl) throw new Error("Original artwork is unavailable. Re-import it to preview this layout.");
            return downloadVerifiedSource(download.downloadUrl, asset);
          }
          if (plan.sourceWidth !== Number(asset.width) || plan.sourceHeight !== Number(asset.height))
            throw new Error("Original artwork is unavailable. Re-import it to preview this layout.");
          const download = array(await createMediaDownloads()).find(value => String(value.assetId) === id);
          if (!download?.downloadUrl) throw new Error("The saved artwork preview is unavailable.");
          const response = await fetch(await previewPimg(download.downloadUrl, 16_384));
          return new File([await response.blob()], asset.name + ".png", { type: "image/png" });
          })().catch(error => { files.delete(id); throw error; }));
        }
        const file = await files.get(id);
        if (!isCurrent()) throw new Error("The selected workspace changed.");
        const prepared = await prepareArtwork(file, plan.presentation, plan.orientation, "#000", plan.profileId);
        url = prepared.previewUrl;
      }
      const sourceAsset = { ...asset, sourceWidth: plan.sourceWidth, sourceHeight: plan.sourceHeight };
      const targetAsset = { ...sourceAsset, width: plan.outputWidth, height: plan.outputHeight, preparation: plan.presentation === "fit" ? 1 : 3, playbackMode: plan.playbackMode };
      return { url, name: asset.name, plan, ...previewPlayback(plan, item), interactions: remapInteractions(item.interactions, sourceAsset, targetAsset) };
    },
  });
}

async function updateMute(type, id, muted) {
  if (!canAdminister() || state.busy) return;
  const fleet = buildFleet(state.workspace);
  if (type === "group" && fleet.allGroups.find(group => String(group.id ?? group.groupId) === String(id))?.unresolved.length ||
      type === "parent" && fleet.sites.find(site => String(site.id ?? site.siteId) === String(id))?.groups.some(group => group.unresolved.length)) {
    notify("Some group members are unavailable. Refresh the group before changing sound.", "error");return;
  }
  const targets = type === "device" ? array(state.workspace?.devices).filter(device => String(device.deviceId) === String(id))
    : type === "parent" ? membersForParentGroup(id)
      : type === "group" ? fleet.allGroups.find(group => String(group.id ?? group.groupId) === String(id))?.members ?? [] : [];
  if (!targets.length) { notify("Refresh the account's Pirdys before changing sound.", "error");return; }
  if (reviewMode) { notify("Visual review only: no sound command was sent.", "success");return; }
  const account = state.account, organization = state.workspace?.me?.organizationId;
  const isCurrent = () => state.account === account && state.workspace?.me?.organizationId === organization;
  state.busy = true;render();
  try {
    if (muted === null) {
      const snapshot = await readCloudMute({ target:targets[0], read:getDeviceSettings, isCurrent });
      if (!isCurrent()) return;
      muteCache().set(targets[0].deviceId, snapshot);
      const reportTime = snapshot.reportedAtUtc && Number.isFinite(Date.parse(snapshot.reportedAtUtc)) ? ` Reported ${new Date(snapshot.reportedAtUtc).toLocaleString()}.` : " No report time is available.";
      notify(`${muteStatus(snapshot).message}. This reads the saved device report.${reportTime}`, snapshot.lastError ? "error" : "success");
    } else {
      const results = await sendCloudMuteBatch({ targets, muted, read:getDeviceSettings, save:saveDeviceSettings, isCurrent,
        onSnapshot:(target, snapshot) => { if (isCurrent()) muteCache().set(target.deviceId, snapshot); } });
      if (!isCurrent()) return;
      const confirmed = results.filter(result => result.snapshot && !result.snapshot.pending).length;
      const queued = results.filter(result => result.snapshot?.pending).length;
      const failed = results.filter(result => result.error).length, unsupported = results.filter(result => result.unsupported).length;
      const parts = [confirmed ? `${confirmed} confirmed` : "", queued ? `${queued} queued, awaiting Pirdy confirmation` : "", failed ? `${failed} unconfirmed` : "", unsupported ? `${unsupported} without supported sound controls` : ""].filter(Boolean);
      notify(`${muted ? "Mute" : "Unmute"}: ${parts.join("; ")}.${queued || failed ? " Read the last sound report before retrying." : ""}${failed === 1 && results.length === 1 ? " " + customerVisibleErrorMessage(results.find(result => result.error).error, "The command could not be confirmed.") : ""}`, failed || unsupported ? "error" : "success");
    }
  } catch (error) { if (isCurrent()) notify(customerVisibleErrorMessage(error, "Sound control could not be confirmed. Read the last sound report before retrying."), "error"); }
  finally { if (isCurrent()) { state.busy = false;render(); } }
}

async function updatePower(type, id, displayOn, input) {
  if (!canAdminister() || state.busy) return;
  const fleet = buildFleet(state.workspace);
  const targetDevices = type === "device"
    ? array(state.workspace?.devices).filter(device => String(device.deviceId) === String(id))
    : type === "parent"
      ? membersForParentGroup(id)
      : type === "group"
        ? (fleet.allGroups.find(group => String(group.id ?? group.groupId) === String(id))?.members ?? [])
        : [];
  const deviceIds = [...new Set(targetDevices.map(device => String(device.deviceId)).filter(Boolean))];
  if (!deviceIds.length) {
    render();
    notify("No current Pirdys are available for this display control.", "error");
    return;
  }
  if (reviewMode) {
    render();
    notify("Visual review only: no display request was sent.", "success");
    return;
  }
  const account = state.account;
  const organization = state.workspace?.me?.organizationId;
  const isCurrent = () => state.account === account && state.workspace?.me?.organizationId === organization;
  const requestId = crypto.randomUUID();
  const label = type === "device" ? "Pirdy" : type === "parent" ? "Group" : "Subgroup";
  state.busy = true;
  render();
  try {
    const command = await (type === "device"
      ? setDeviceDisplay(id, displayOn, requestId)
      : type === "parent"
        ? setParentGroupDisplay(id, displayOn, requestId)
        : setGroupDisplay(id, displayOn, requestId));
    if (!isCurrent()) return;
    const targets = validateDisplayCommand(command, { requestId, displayOn, deviceIds });
    state.workspace = { ...state.workspace,
      statuses: applyDisplayCommandStatuses(state.workspace?.statuses, targets) };
    const acknowledgement = displayAcknowledgement(targets);
    if (acknowledgement.superseded) {
      notify(`${acknowledgement.superseded} ${label.toLowerCase()} display command${acknowledgement.superseded === 1 ? " was" : "s were"} superseded by a newer saved command.`, "error");
    } else if (acknowledgement.confirmed === acknowledgement.total) {
      notify(`Display ${displayOn ? "On" : "Off"} confirmed by ${acknowledgement.total} Pirdy${acknowledgement.total === 1 ? "" : "s"}.`, "success");
    } else {
      const parts = [];
      if (acknowledgement.awaiting) parts.push(`${acknowledgement.awaiting} awaiting device confirmation`);
      if (acknowledgement.queued) parts.push(`${acknowledgement.queued} queued until connected`);
      notify(`Display ${displayOn ? "On" : "Off"} saved: ${parts.join("; ")}. Wi-Fi remains active.`, "success");
    }
  } catch (error) {
    if (isCurrent()) notify(customerVisibleErrorMessage(error,
      "Display control could not be confirmed. Refresh the Pirdy's current state before retrying."), "error");
  } finally {
    if (isCurrent()) {
      state.busy = false;
      render();
    }
  }
}
async function selectPlaylist(playlistId, { preserveAssistant = false } = {}) {
  if (!preserveAssistant) state.assistantDraftJobId = null;
  const account = state.account, workspace = state.workspace;
  const operation = {};
  state.playlistSelectionOperation = operation;
  const current = () => state.playlistSelectionOperation === operation && account === state.account &&
    workspace === state.workspace && state.selectedPlaylistId === playlistId;
  state.selectedPlaylistId = playlistId;
  state.selectedPlaylist = null;
  state.busy = true;
  render();
  let failure = null;
  try {
    if (reviewMode) {
      const summary = array(reviewWorkspace.playlists).find(item => String(item.id ?? item.playlistId) === String(playlistId));
      state.selectedPlaylist = { ...summary, id: playlistId, version: "review", items: array(reviewWorkspace.content).slice(0, summary?.itemCount ?? 0).map(asset => createPlaylistItem(asset)) };
      state.playlistDraft = structuredClone(state.selectedPlaylist);
      state.selectedPlaylistItem = 0;state.drawingHotspot = false;
    } else if (isBrowserLocalWorkspace()) {
      const loaded = state.browserLocalPlaylists.get(String(playlistId));
      if (!loaded) throw new Error("That browser-local playlist is no longer available.");
      if (!current()) return;
      state.selectedPlaylist = structuredClone(loaded);
      state.playlistDraft = structuredClone(loaded);
      state.selectedPlaylistItem = 0;
      state.drawingHotspot = false;
    } else {
      const loaded = await loadPlaylist(playlistId);
      if (!current()) return;
      state.selectedPlaylist = loaded;
      state.playlistDraft = structuredClone(state.selectedPlaylist);
      state.selectedPlaylistItem = 0;
      state.drawingHotspot = false;
    }
  } catch (error) {
    failure = error;
  } finally {
    if (current()) { state.busy = false; render(); }
  }
  if (failure && current()) notify(customerVisibleErrorMessage(failure,
    "The selected playlist could not be loaded. Refresh playlists and try again."), "error");
  return current() && !failure;
}
function invalidatePublicationReview() {
  state.publicationValidation = null;
  state.publicationRequest = null;
  state.publicationPlaylistFingerprint = null;
  state.publicationReviewBinding = null;
}
function publicationBindingMatches(binding) {
  return !!binding && state.account === binding.account && state.workspace === binding.workspace &&
    state.selectedPlaylistId === binding.playlistId && state.publishTarget === binding.target &&
    state.publishTarget?.kind === binding.targetKind && state.publishTarget?.id === binding.targetId &&
    JSON.stringify([state.account?.homeAccountId, state.workspace?.me?.organizationId, state.workspace?.me?.userId]) === binding.ownerKey;
}
function publicationContext(requireTarget = true) {
  const account = state.account, workspace = state.workspace, playlistId = state.selectedPlaylistId;
  const target = state.publishTarget, operation = {};
  const selectionOperation = state.playlistSelectionOperation;
  const binding = { account, workspace, playlistId, target, targetKind: target?.kind, targetId: target?.id,
    ownerKey: JSON.stringify([account?.homeAccountId, workspace?.me?.organizationId, workspace?.me?.userId]) };
  state.publicationOperation = operation;
  return {
    playlistId,
    binding,
    current: () => state.publicationOperation === operation && state.account === account &&
      state.workspace === workspace && state.selectedPlaylistId === playlistId &&
      state.playlistSelectionOperation === selectionOperation &&
      (!requireTarget || publicationBindingMatches(binding)),
    finish: () => {
      if (state.publicationOperation !== operation) return;
      state.publicationOperation = null;
      if (state.account === account && state.workspace === workspace &&
          state.playlistSelectionOperation === selectionOperation) { state.busy = false; render(); }
    },
  };
}
async function continueToTargets() {
  if (!state.selectedPlaylistId || state.busy) return;
  const context = publicationContext(false);
  state.busy = true;
  invalidatePublicationReview();
  render();
  try {
    const latest = reviewMode
      ? { ...(array(reviewWorkspace.playlists).find(item => String(item.id ?? item.playlistId) === String(context.playlistId)) ?? {}), id: context.playlistId, version: "review", items: [] }
      : await loadPlaylist(context.playlistId);
    if (!context.current()) return;
    if (!reviewMode) savedPlaylistFingerprint(latest, context.playlistId);
    state.selectedPlaylist = latest;
    state.publishStep = 2;
    state.publishTarget = null;
  } catch (error) {
    if (context.current()) notify(customerVisibleErrorMessage(error, "The latest saved playlist could not be loaded. Nothing was published."), "error");
  } finally { context.finish(); }
}
async function reviewPublication() {
  if (!state.selectedPlaylistId || !state.publishTarget || state.busy) return;
  if (!canManageContent() || !canCommitMeteredCloudChange()) return rejectUnavailableCloudChange();
  const context = publicationContext();
  state.busy = true;
  invalidatePublicationReview();
  render();
  try {
    const latest = reviewMode ? state.selectedPlaylist : await loadPlaylist(context.playlistId);
    if (!context.current()) return;
    const fingerprint = reviewMode ? "review" : savedPlaylistFingerprint(latest, context.playlistId);
    state.selectedPlaylist = latest;
    const request = await buildPublicationRequest();
    if (!context.current()) return;
    const validation = reviewMode ? { canPublish: true, targets: [] } : await validatePublication(request);
    if (!context.current()) return;
    state.publicationValidation = validation;
    state.publicationRequest = request;
    state.publicationPlaylistFingerprint = fingerprint;
    state.publicationReviewBinding = context.binding;
    if (!validation.canPublish) {
      notify("The selected Pirdy is not compatible with this saved playlist. Review its content and target.", "error");
      return;
    }
    state.publishStep = 3;
  } catch (error) {
    if (context.current()) notify(customerVisibleErrorMessage(error, "The latest saved playlist could not be prepared. Nothing was published."), "error");
  } finally { context.finish(); }
}

async function commitPublication() {
  if (!state.publicationValidation?.canPublish || !state.publicationRequest || state.busy) return;
  if (reviewMode) return notify("Visual review only: no publication was created.", "success");
  if (!publicationBindingMatches(state.publicationReviewBinding)) {
    invalidatePublicationReview();
    state.publishStep = state.selectedPlaylistId ? 2 : 1;
    render();
    return notify("The account, workspace, playlist, or target changed after review. Nothing was published. Review the saved playlist and target again.", "error");
  }
  if (!canManageContent() || !canCommitMeteredCloudChange()) return rejectUnavailableCloudChange();
  const context = publicationContext();
  const request = state.publicationRequest, fingerprint = state.publicationPlaylistFingerprint;
  state.busy = true;
  render();
  try {
    const latest = await loadPlaylist(context.playlistId);
    if (!context.current()) return;
    if (savedPlaylistFingerprint(latest, context.playlistId) !== fingerprint) {
      state.selectedPlaylist = latest;
      invalidatePublicationReview();
      state.publishStep = 2;
      notify("This playlist changed after review. Nothing was published. Check compatibility and review its latest saved hotspots again.", "error");
      return;
    }
    const result = await publishContent(request);
    if (!context.current()) return;
    const version = result?.publication?.version ?? "new";
    const immediate = result?.wake?.immediate ?? 0;
    const deferred = result?.wake?.deferred ?? 0;
    state.publishStep = 1;
    state.publishTarget = null;
    invalidatePublicationReview();
    notify(`Publication ${version} was saved in Cloud. ${immediate} Pirdy wake(s) were immediate; ${deferred} wait for connection. Installation is not confirmed by a wake; check the device-reported publication version.`, "success");
    await refreshWorkspace({ announce: false });
  } catch (error) {
    if (context.current()) notify(customerVisibleErrorMessage(error, "Publication was not confirmed. Refresh device status before retrying; no automatic retry was made."), "error");
  } finally { context.finish(); }
}
async function buildPublicationRequest() {
  const account=state.account,playlist=state.selectedPlaylist,publishTarget={...state.publishTarget};
  const demandCurrent=()=>{if(state.account!==account||state.selectedPlaylist!==playlist||state.publishTarget?.kind!==publishTarget.kind||state.publishTarget?.id!==publishTarget.id)throw new Error("Your account, playlist or selected Pirdy changed. Review it before publishing.");};
  const items = array(state.selectedPlaylist?.items);
  if (!items.length) throw new Error("The selected playlist has no saved content items.");
  const content = array(state.workspace?.content);
  const target = publicationTargetContract();
  const audioAssetIds=validatePlaylistAudio(items,content);
  if(audioAssetIds.length>16)throw audioError("A playlist supports up to 16 different audio clips.");
  const targetContentIds = interactionTargetContentIds(items);
  const requiredAssetIds = [...new Set([...items.map(item => String(item.assetId)), ...targetContentIds])];
  const sourceIds = new Set(requiredAssetIds.map(assetId => {
    const asset = content.find(candidate => String(candidate.assetId ?? candidate.id) === assetId);
    return asset?.logicalSourceAssetId ? String(asset.logicalSourceAssetId) : null;
  }).filter(Boolean));
  const sourceDownloads = reviewMode || sourceIds.size === 0
    ? new Map()
    : new Map(array(await createContentSourceDownloads())
      .filter(value => sourceIds.has(String(value.sourceId)))
      .map(value => [String(value.sourceId), value.downloadUrl]));
  demandCurrent();
  const assets = [], preparedItems = [], remappedIds = new Map(), seen = new Set(), sourceFiles=new Map();
  const planned=items.map(item=>({item,include:true}));
  const itemIds=new Set(items.map(item=>String(item.assetId)));
  for(const assetId of targetContentIds){
    if(itemIds.has(String(assetId)))continue;
    const asset=content.find(candidate=>String(candidate.assetId??candidate.id)===String(assetId));
    if(!asset)throw new Error(`Hotspot destination ${assetId} is not available in this account.`);
    const item=createPlaylistItem(asset);item.autoplay=false;planned.push({item,include:false});itemIds.add(String(assetId));
  }
  const prepared=await mapTransfers(planned,2,async (entry,_index,check)=>{
    const demand=()=>{check();demandCurrent();};demand();
    const assetId=String(entry.item.assetId),asset=content.find(candidate=>String(candidate.assetId??candidate.id)===assetId);
    if(!asset)throw new Error(`Playlist asset ${assetId} is not available in this account.`);
    const result=await preparePublicationVariant(entry.item,asset,target,sourceDownloads,sourceFiles,demand);demand();return {...result,originalId:assetId,include:entry.include};
  });
  demandCurrent();
  for(const result of prepared){
    if(result.include)preparedItems.push(result.item);
    remappedIds.set(result.originalId,String(result.asset.assetId));
    if(!seen.has(String(result.asset.assetId))){seen.add(String(result.asset.assetId));assets.push(result.asset);}
  }
  for(const audioId of audioAssetIds){
    const audio=content.find(asset=>String(asset.assetId??asset.id).toLowerCase()===audioId);
    if(!seen.has(audioId)){assets.push(audio);seen.add(audioId);}
  }
  for (const item of preparedItems) {
    for (const area of array(item.interactions?.touchAreas)) {
      if (area.action?.targetContentId && remappedIds.has(String(area.action.targetContentId)))
        area.action.targetContentId = remappedIds.get(String(area.action.targetContentId));
    }
  }
  return {
    deviceIds: state.publishTarget.kind === "device" ? [state.publishTarget.id] : [],
    groupIds: state.publishTarget.kind === "group" ? [state.publishTarget.id] : [],
    siteIds: [],
    profileIds: [],
    assets,
    items: preparedItems,
    requestId: crypto.randomUUID(),
  };
}

function publicationTargetContract() {
  if (state.publishTarget?.kind === "device") {
    const device = array(state.workspace?.devices).find(value => value.deviceId === state.publishTarget.id);
    if (!device) throw new Error("The selected Pirdy is no longer available.");
    return { profileId: requireDeviceProfileId(device.profileId), orientation: Number(device.orientation ?? Orientation.landscape) };
  }
  const group = buildFleet(state.workspace).allGroups.find(value => String(value.id ?? value.groupId) === String(state.publishTarget?.id));
  const members = array(group?.members);
  if (!group || !members.length) throw new Error("The selected group has no compatible Pirdys.");
  const profiles = [...new Set(members.map(value => requireDeviceProfileId(value.profileId)))];
  if (profiles.length !== 1) throw new Error("This group contains different Pirdy models and cannot share one prepared output.");
  const capability = String(group.orientationCapability ?? members[0].orientationCapability ?? "").toLowerCase();
  const orientation = capability === "vertical" ? Orientation.portrait : capability === "horizontal" ? Orientation.landscape : null;
  if (!orientation) throw new Error("Choose a group with one fixed Pirdy orientation.");
  return { profileId: profiles[0], orientation };
}

async function preparePublicationVariant(item, asset, target, sourceDownloads, sourceFiles=new Map(), demandCurrent=()=>{}, storePrepared=null) {
  demandCurrent();
  const sourceId = asset.logicalSourceAssetId;
  if (!sourceId || reviewMode) return { asset, item: devicePlaylistItem(item) };
  const downloadUrl = sourceDownloads.get(String(sourceId));
  if (!downloadUrl) throw new Error(`${asset.name} source artwork is unavailable. Re-import it before publishing.`);
  if(!sourceFiles.has(String(sourceId)))sourceFiles.set(String(sourceId),downloadVerifiedSource(downloadUrl,asset));
  const sourceFile=await sourceFiles.get(String(sourceId));demandCurrent();
  let presentation = Number(item.requestedPresentation ?? (String(item.type).toLowerCase() === "scroll" ? 3 : 1));
  let prepared;
  try {
    prepared = await prepareArtwork(sourceFile, presentation === 3 ? "scroll" : "fit", target.orientation, "#000", target.profileId);
  } catch (error) {
    if (presentation !== 3 || !/same aspect ratio|already matches/i.test(error.message)) throw error;
    presentation = 1;
    prepared = await prepareArtwork(sourceFile, "fit", target.orientation, "#000", target.profileId);
  }
  demandCurrent();
  // Validate target timing before uploading/registering a derived asset.
  const projectedSpeed = prepared.metadata.playbackMode !== PlaybackMode.static && String(item.type).toLowerCase() === "scroll"
    ? projectedScrollSpeed(item, asset, assetViewport(asset),
        {...prepared.metadata,targetProfileId:target.profileId}, viewportFor(target.orientation,target.profileId)) : null;
  const registration = storePrepared
    ? await storePrepared(prepared)
    : await registerMedia({ ...prepared.metadata, logicalSourceAssetId: sourceId, preparation: presentation, targetProfileId: target.profileId, libraryVisible: false });
  demandCurrent();
  if (!storePrepared && registration.alreadyExists !== true) {
    await uploadBlob(registration.uploadUrl, prepared.blob);demandCurrent();
    await completeMedia(registration.assetId);demandCurrent();
  }
  const targetAsset = { ...prepared.metadata, assetId: registration.assetId, logicalSourceAssetId: sourceId, preparation: presentation, targetProfileId: target.profileId, libraryVisible: false };
  const interactions = remapInteractions(item.interactions, asset, targetAsset);
  const common = { ...projectScreenOverlays(devicePlaylistItem(item), assetViewport(asset), assetViewport(targetAsset)), assetId: registration.assetId, interactions };
  if (prepared.metadata.playbackMode === PlaybackMode.static) {
    return { asset: targetAsset, item: { ...common, type: "static", effectIn: 1, effectOut: 1, effectDurationMs: Number(item.effectDurationMs ?? 500), holdDurationMs: Number(item.holdDurationMs ?? 5000), presentationMode: 1 } };
  }
  const vertical = prepared.metadata.playbackMode === PlaybackMode.vertical;
  const existingDirection=Number(item.direction);
  const existingSpeed=Number(item.speedPxPerSecond);
  const direction = vertical
    ? Number(item.requestedVerticalDirection ?? ([Direction.up,Direction.down].includes(existingDirection)?existingDirection:Direction.up))
    : Number(item.requestedHorizontalDirection ?? ([Direction.left,Direction.right].includes(existingDirection)?existingDirection:Direction.left));
  const selectedSpeed = vertical
    ? Number(item.requestedVerticalSpeedPxPerSecond ?? ([Direction.up,Direction.down].includes(existingDirection)&&Number.isFinite(existingSpeed)?existingSpeed:5))
    : Number(item.requestedHorizontalSpeedPxPerSecond ?? ([Direction.left,Direction.right].includes(existingDirection)&&Number.isFinite(existingSpeed)?existingSpeed:10));
  const speedPxPerSecond = projectedSpeed ?? selectedSpeed;
  return { asset: targetAsset, item: { ...common, type: "scroll", direction, speedPxPerSecond, loopArtwork: item.loopArtwork === true } };
}

function devicePlaylistItem(item) {
  const result = structuredClone(item);
  delete result.requestedPresentation;
  delete result.requestedHorizontalDirection;
  delete result.requestedVerticalDirection;
  delete result.requestedHorizontalSpeedPxPerSecond;
  delete result.requestedVerticalSpeedPxPerSecond;
  return result;
}

async function downloadVerifiedSource(downloadUrl, asset) {
  const url = trustedContentDownloadUrl(downloadUrl, "Pirdy refused an untrusted content source.");
  let response;
  try { response = await fetch(url, { cache: "no-store" }); }
  catch { throw new Error("Source artwork could not be downloaded. Check your connection and try publishing again."); }
  if (!response.ok)
    throw new Error("Source artwork could not be downloaded. Refresh your account data and try publishing again.");
  const bytes = await response.arrayBuffer();
  const actual = [...new Uint8Array(await crypto.subtle.digest("SHA-256", bytes))].map(value => value.toString(16).padStart(2, "0")).join("").toUpperCase();
  if (asset.sourceSha256 && actual !== String(asset.sourceSha256).toUpperCase()) throw new Error("Source artwork failed SHA-256 verification.");
  return new File([bytes], asset.sourceFileName ?? `${asset.name}.png`, { type: asset.sourceContentType ?? "image/png" });
}

function assetViewport(asset) {
  return viewportFor(Number(asset.orientation ?? asset.compatibleOrientation ?? Orientation.landscape),geometryProfileIdForAsset(asset));
}

function remapInteractions(settings, sourceAsset, targetAsset) {
  if (!settings) return null;
  const sourceWidth = Number(sourceAsset.sourceWidth);
  const sourceHeight = Number(sourceAsset.sourceHeight);
  if (!sourceWidth || !sourceHeight) throw new Error("Original artwork dimensions are missing. Re-import this content.");
  const oldPlan = coordinatePlan(sourceAsset, sourceWidth, sourceHeight);
  const newPlan = coordinatePlan(targetAsset, sourceWidth, sourceHeight);
  return { ...structuredClone(settings), touchAreas: array(settings.touchAreas).map(area => {
    if (Number(area.coordinateMode) === 2) return {...structuredClone(area),region:projectScreenRegion(area.region,assetViewport(sourceAsset),assetViewport(targetAsset))};
    const sourceRegion = preparedRegionToSource(area.region, oldPlan);
    const region = sourceRegionToPrepared(sourceRegion, newPlan);
    if (region.width <= 0 || region.height <= 0)
      throw new Error("A touch area does not overlap the artwork after resizing. Move it onto the image and try again.");
    return { ...structuredClone(area), region };
  }) };
}

function coordinatePlan(asset, sourceWidth, sourceHeight) {
  const preparation = Number(asset.preparation ?? (Number(asset.playbackMode) === PlaybackMode.static ? 1 : 3));
  // Reconstruct an already-prepared scroll image without applying new-publication
  // restrictions, so historical artwork can still be converted safely to Fit.
  if (preparation === 0 || preparation === 3) return {
    sourceWidth, sourceHeight, outputWidth: Number(asset.width), outputHeight: Number(asset.height),
    scaledWidth: Number(asset.width), scaledHeight: Number(asset.height), destinationX: 0, destinationY: 0,
  };
  const presentation = preparation === 3 ? "scroll" : "fit";
  return {
    ...preparationPlan(sourceWidth, sourceHeight, presentation, Number(asset.orientation ?? asset.compatibleOrientation), geometryProfileIdForAsset(asset)),
    sourceWidth,
    sourceHeight,
  };
}

function preparedRegionToSource(region, plan) {
  const scaleX = plan.sourceWidth / plan.scaledWidth;
  const scaleY = plan.sourceHeight / plan.scaledHeight;
  const left = clamp(Math.round((Number(region.x) - plan.destinationX) * scaleX), 0, plan.sourceWidth);
  const top = clamp(Math.round((Number(region.y) - plan.destinationY) * scaleY), 0, plan.sourceHeight);
  const right = clamp(Math.round((Number(region.x) + Number(region.width) - plan.destinationX) * scaleX), 0, plan.sourceWidth);
  const bottom = clamp(Math.round((Number(region.y) + Number(region.height) - plan.destinationY) * scaleY), 0, plan.sourceHeight);
  return { x: left, y: top, width: Math.max(0, right - left), height: Math.max(0, bottom - top) };
}

function sourceRegionToPrepared(region, plan) {
  const scaleX = plan.scaledWidth / plan.sourceWidth;
  const scaleY = plan.scaledHeight / plan.sourceHeight;
  const left = clamp(Math.round(Number(region.x) * scaleX + plan.destinationX), 0, plan.outputWidth);
  const top = clamp(Math.round(Number(region.y) * scaleY + plan.destinationY), 0, plan.outputHeight);
  const right = clamp(Math.round((Number(region.x) + Number(region.width)) * scaleX + plan.destinationX), 0, plan.outputWidth);
  const bottom = clamp(Math.round((Number(region.y) + Number(region.height)) * scaleY + plan.destinationY), 0, plan.outputHeight);
  return { x: left, y: top, width: Math.max(0, right - left), height: Math.max(0, bottom - top) };
}

function clamp(value, minimum, maximum) {
  return Math.min(maximum, Math.max(minimum, value));
}

function targetChecked(kind, id) {
  return state.publishTarget?.kind === kind && String(state.publishTarget.id) === String(id) ? "checked" : "";
}

function publishTargetLabel() {
  if (!state.publishTarget) return "No target";
  if (state.publishTarget.kind === "group") {
    return buildFleet(state.workspace).allGroups.find(group => String(group.id ?? group.groupId) === String(state.publishTarget.id))?.name ?? state.publishTarget.id;
  }
  const device = array(state.workspace?.devices).find(item => item.deviceId === state.publishTarget.id);
  return device ? customerDeviceName(device, state.workspace) : "Selected Pirdy";
}

function mediaDetail(item) {
  if(isAudioAsset(item))return "Audio clip - "+Math.ceil(Number(item.fileSize??item.byteLength??0)/1024)+" KB";
  if (item.detail) return item.detail;
  const mode = Number(item.playbackMode);
  const label = ({ 1: "Static", 2: "Horizontal scroll", 3: "Vertical scroll", 4: "Video" })[mode] ?? "Ready";
  return `${item.width ?? "?"} × ${item.height ?? "?"} · ${label}`;
}

function assetName(assetId) {
  const asset = array(state.workspace?.content).find(item => String(item.assetId ?? item.id) === String(assetId));
  return asset?.name ?? assetId;
}

function playlistItemDescription(item) {
  if (item.autoplay === false) return "Touch hotspot only";
  const type = String(item.type ?? (item.direction == null ? "static" : "scroll")).toLowerCase();
  if (type === "scroll") {
    const direction = ({ 1: "Left", 2: "Right", 3: "Up", 4: "Down" })[Number(item.direction)] ?? item.direction ?? "Scroll";
    return `${direction} · ${item.speedPxPerSecond ?? "?"} px/s`;
  }
  if (type === "video") return "Video";
  return `Fit · ${Math.round(Number(item.holdDurationMs ?? 0) / 1000)} seconds`;
}

function hasAdministratorRole() {
  if (reviewMode) return true;
  if (state.workspaceError || state.workspaceLoading) return false;
  try { return organizationRoleValue(state.workspace?.me?.role) === 1; }
  catch { return false; }
}

function canAdminister() {
  return hasAdministratorRole() && canMutateCloudWorkspace();
}

function canMutateCloudWorkspace() {
  return reviewMode || (!state.workspaceError && !state.workspaceLoading
    && Object.keys(state.workspace?.resourceErrors ?? {}).length === 0
    && customerCloudAccessPolicy(state.cloudAccess).canMutateCloudWorkspace);
}

function canAdministerCloudWorkspace() {
  return canAdminister();
}

function canManageContent() {
  if (browserLocalAccountId())
    return isBrowserLocalWorkspace() && !state.browserLocalStorageError;
  const role = state.workspace?.me?.role;
  let roleValue = null;
  try { roleValue = organizationRoleValue(role); } catch { /* Unknown roles stay read-only. */ }
  return reviewMode || (canMutateCloudWorkspace() && !state.workspace?.resourceErrors?.content
    && (roleValue === 1 || roleValue === 2));
}

function canCommitMeteredCloudChange() {
  if (reviewMode) return true;
  const decision = customerCloudChangePolicy(state.entitlement);
  return !decision.verified || decision.allowed;
}

function rejectUnavailableCloudChange() {
  const access = customerCloudAccessPolicy(state.cloudAccess);
  const message = !access.canMutateCloudWorkspace
    ? "Cloud Control is unavailable. Review billing to renew before making Cloud changes."
    : "The included monthly Cloud changes are used. Buy a Single Change or renew before publishing or changing the startup logo.";
  notify(message, "error");
}
function customerOperationScope() {
  const account = state.account, organization = state.workspace?.me?.organizationId ?? state.pirdyAccount?.organizationId ?? null;
  const local = isBrowserLocalWorkspace(), localId = local ? browserLocalAccountId() : null;
  return () => state.account === account && (state.workspace?.me?.organizationId ?? state.pirdyAccount?.organizationId ?? null) === organization &&
    isBrowserLocalWorkspace() === local && (!local || browserLocalAccountId() === localId);
}
async function refreshBilling({ announce = true } = {}) {
  const current = customerOperationScope(), version = state.billingRequestVersion = (state.billingRequestVersion ?? 0) + 1;
  const [billing, entitlement, catalog, hardware, access, devices] = await Promise.allSettled([
    loadBilling(), loadCloudEntitlement(), loadPlanCatalog(), loadHardwareOffers(), loadCloudAccess(), loadClaimedDevices(),
  ]);
  if (!current() || state.billingRequestVersion !== version) return;
  if (billing.status === "fulfilled") state.billing = billing.value;
  if (entitlement.status === "fulfilled") state.entitlement = entitlement.value;
  state.planCatalog = catalog.status === "fulfilled" ? catalog.value : null;
  state.hardwareOfferCatalog = hardware.status === "fulfilled" ? hardware.value : null;
  if (access.status === "fulfilled") {
    state.cloudAccess = access.value;
    state.cloudAccessError = null;
  }
  if (devices.status === "fulfilled") state.claimedDevices = array(devices.value);
  render();
  if (!announce) return;
  if (billing.status === "fulfilled" || entitlement.status === "fulfilled") notify("Available billing and plan data is up to date.", "success");
  else notify(customerVisibleErrorMessage(entitlement.reason ?? billing.reason,
    "Billing is unavailable. Refresh Billing & Usage and try again."), "error");
}

function secureCheckoutAddress(value) {
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.href : null;
  } catch { return null; }
}

function purchasedPirdyConfirmed() {
  return app.querySelector("[data-purchased-pirdy-confirm]")?.checked === true;
}

async function claimPurchasedPirdy(event) {
  event.preventDefault();
  if (!hasAdministratorRole() || state.busy) return;
  const account=state.account;
  const data = new FormData(event.currentTarget);
  const deviceId = String(data.get("deviceId") ?? "").trim().toUpperCase();
  const pin = String(data.get("pin") ?? "").trim();
  let sessionId;
  try {sessionId = claimSessionFor(event.currentTarget, state.account);} catch {return notify("Start registration or choose Try again, then tap Add an Account on the Pirdy.", "error");}
  state.busy = true;
  try {
    await claimPirdy(deviceId, pin, sessionId);
    if(state.account!==account)return;
    if(isBrowserLocalWorkspace())await refreshLocalLinkedPirdys();
    else {await refreshWorkspace({ announce: false });await refreshBilling({ announce: false });}
    if(state.account!==account)return;
    notify(`${deviceId} was claimed by this account. You can now start the one-time 7-day Cloud trial from Billing when eligible. ${cloudRecheckGuidance}`, "success");
  } catch (error) {
    notify(customerVisibleErrorMessage(error, "The Pirdy was not claimed. Check its ID and use the current PIN on its display."), "error");
  } finally { if(state.account===account){state.busy = false;render();} }
}

function canStartCloudTrial(entitlement, access) {
  return ["NotSubscribed", "Cancelled", "Expired"].includes(entitlement?.subscriptionState) &&
    ["NotCreated", "Active"].includes(access?.dataAvailability);
}

async function startFreeCloudTrial() {
  const deviceId = app.querySelector("[data-trial-device]")?.value;
  if (!deviceId || !hasAdministratorRole()) return;
  if (!window.confirm("Start this account's one-time 7-day Cloud trial? No payment method is required and there is no automatic charge.")) return;
  const account = state.account;
  try {
    state.entitlement = await loadCloudEntitlement();
    state.cloudAccess = await loadCloudAccess();
    if (!canStartCloudTrial(state.entitlement, state.cloudAccess))
      return notify("A free trial cannot replace an existing subscription or recover retained or purged Cloud data.", "error");
    const trial = await startCloudTrial(deviceId);
    if (state.account !== account) return;
    await refreshSignedInAccount();
    if (state.account !== account) return;
    await refreshBilling({ announce: false });
    notify(`Free Cloud Control is active until ${new Date(trial.endsExclusiveUtc).toLocaleString("en-IN")}. No payment method was added. ${cloudRecheckGuidance}`, "success");
  } catch (error) { notify(customerVisibleErrorMessage(error, "The free trial was not started. No payment was made."), "error"); }
}

async function showHardwareOffer(sku) {
  try {
    const catalog = await loadHardwareOffers();
    state.hardwareOfferCatalog = catalog;
    const offer = array(catalog?.offers).find(value => value.sku === sku);
    if (!offer) throw new Error("That Pirdy offer is unavailable.");
    window.alert(`${offer.displayName} · ₹${Number(offer.price?.amount).toLocaleString("en-IN")}\n\n${offer.purchaseMessage}\n\nNo Cloud subscription or payment was started.`);
  } catch (error) { notify(customerVisibleErrorMessage(error, "Pirdy ordering details could not be loaded. No payment was started."), "error"); }
}

async function reportStolenDevice(deviceId) {
  if (!window.confirm(`Report ${deviceId} stolen? New-account claims will be blocked. Only this same owner account can re-enable it.`)) return;
  try {
    await reportPirdyStolen(deviceId, "Reported from Pirdy Web");
    notify(`${deviceId} is protected against new-account claims.`, "success");
  } catch (error) { notify(customerVisibleErrorMessage(error, "The stolen-device report was not recorded."), "error"); }
}

async function reEnableDevice(deviceId) {
  if (!window.confirm(`Re-enable ${deviceId}? Continue only after the Pirdy has been recovered.`)) return;
  try {
    await reEnableProtectedPirdy(deviceId);
    notify(`${deviceId} was re-enabled by its owner account.`, "success");
  } catch (error) { notify(customerVisibleErrorMessage(error, "The Pirdy was not re-enabled. Sign in again with its owner account and retry."), "error"); }
}

async function refreshCheckoutCatalog() {
  const displayed = state.planCatalog;
  const current = await loadPlanCatalog({ forCheckout: true });
  if (!Number.isSafeInteger(current?.publicationSequence) || current.publicationSequence <= 0)
    throw new Error("The current price revision could not be verified.");
  state.planCatalog = current;
  if (displayed?.publicationSequence !== current.publicationSequence ||
      displayed?.catalogVersion !== current.catalogVersion) {
    render();
    notify("Prices have been refreshed. Review the current prices and choose again; no payment was started.", "error");
    return false;
  }
  return true;
}

async function refreshAfterCheckoutConflict(error) {
  if (error?.code !== "pirdy_catalog_changed") return;
  try { await refreshCheckoutCatalog(); } catch { state.planCatalog = null; render(); }
}

async function startPlanCheckout(planCode) {
  if (reviewMode) return notify("Visual review only: no checkout was started.", "success");
  if (!hasAdministratorRole()) return notify("Only an Organization Administrator can manage the plan.", "error");
  if (!purchasedPirdyConfirmed()) return notify("Confirm that you purchased and claimed a Pirdy on this account before checkout.", "error");
  try {
    if (!await refreshCheckoutCatalog()) return;
    state.entitlement = await loadCloudEntitlement();
    const selected = array(planCatalog()?.monthlyPlans).find(plan => plan.code === planCode);
    if (!selected) throw new Error("The selected fixed plan is unavailable.");
    const hasCurrentPlan = hasCurrentCloudSubscription(state.entitlement);
    if (hasCurrentPlan && state.entitlement.planCode === planCode) return notify("This is already the current plan.", "success");
    let session;
    if (hasCurrentPlan && state.entitlement.planCode) {
      session = await changePlan(planCode, true, true, state.planCatalog.publicationSequence);
    } else session = await createPlanCheckout(planCode, true, state.planCatalog.publicationSequence);
    const target = secureCheckoutAddress(session?.hostedCheckoutUri);
    if (!target) throw new Error("Pirdy did not return a secure checkout address.");
    location.assign(target);
  } catch (error) { await refreshAfterCheckoutConflict(error); notify(`${customerVisibleErrorMessage(error,
    "The plan checkout could not be started.")} No payment or plan change was made.`, "error"); }
}

async function buySingleChange() {
  if (reviewMode) return notify("Visual review only: no checkout was started.", "success");
  if (!hasAdministratorRole()) return notify("Only an Organization Administrator can buy a change.", "error");
  if (!purchasedPirdyConfirmed()) return notify("Confirm that you purchased and claimed a Pirdy on this account before checkout.", "error");
  try {
    if (!await refreshCheckoutCatalog()) return;
    state.entitlement = await loadCloudEntitlement();
    state.cloudAccess = await loadCloudAccess();
    const access = customerCloudAccessPolicy(state.cloudAccess);
    if (!access.canReadCloudWorkspace || !["Active", "Grace"].includes(state.entitlement.subscriptionState))
      throw new Error("An active Cloud Control plan is required before buying a Single Change.");
    if (Number(state.entitlement.includedChangesRemaining) > 0)
      throw new Error("Your monthly plan still has an included Cloud change available.");
    const session = await createSingleChangeCheckout(true, state.planCatalog.publicationSequence);
    const target = secureCheckoutAddress(session?.hostedCheckoutUri);
    if (!target) throw new Error("Pirdy did not return a secure checkout address.");
    location.assign(target);
  } catch (error) { await refreshAfterCheckoutConflict(error); notify(`${customerVisibleErrorMessage(error,
    "The Single Change checkout could not be started.")} No payment was made.`, "error"); }
}

async function resumePendingCheckout() {
  const productCode = state.pendingProductCode;
  if (!productCode || state.cloudActivationOpen || !state.workspace) return;
  state.pendingProductCode = null;
  state.route = "billing";
  await refreshBilling({ announce: false });
  if (productCode === planCatalog()?.singleChangePass?.code) await buySingleChange();
  else await startPlanCheckout(productCode);
}

async function payInvoice(invoiceId) {
  if (reviewMode) return notify("Visual review only: no payment was started.", "success");
  try {
    const session = await createPaymentSession(invoiceId);
    const target = secureCheckoutAddress(session?.checkoutUrl ?? session?.url);
    if (!target) throw new Error("Pirdy did not return a secure checkout address. No payment was started.");
    location.assign(target);
  } catch (error) { notify(customerVisibleErrorMessage(error,
    "The payment session could not be opened. No payment was started."), "error"); }
}

async function invoiceDocument(invoiceId) {
  if (reviewMode) return notify("Visual review only: invoice download was not started.", "success");
  try { await downloadInvoice(invoiceId, `${invoiceId}.pdf`); }
  catch (error) { notify(customerVisibleErrorMessage(error,
    "The invoice could not be downloaded. Refresh Billing & Usage and try again."), "error"); }
}

function navigate(route) {
  if (state.route === "playlists" && state.playlistDraft) {
    syncItemEditorFields();
    const name = app.querySelector("#playlist-name");
    if (name) state.playlistDraft.name = name.value;
  }
  state.route = routes.some(([id]) => id === route) ? route : "home";
  history.replaceState(null, "", `${location.pathname}${location.search}#${state.route}`);
  render();
  app.querySelector("#main-content")?.focus();
  if (state.route === "help" && state.supportTickets === null && !state.supportLoading)
    void refreshSupportTickets({ announce: false });
  if (state.route === "billing" && state.pirdyAccount?.organizationId &&
      state.billing === null)
    void refreshBilling({ announce: false });
  if (state.route === "settings" && state.workspaceSettingsSnapshot === null && !state.workspaceSettingsLoading)
    void refreshWorkspaceSettings({ announce: false });
  if (state.route === "settings" && hasAdministratorRole() &&
      state.organizationMembers === null && state.organizationInvitations === null &&
      !state.organizationMembersLoading && !state.organizationInvitationsLoading)
    void refreshOrganizationManagement({ announce: false });
  if (state.route === "settings" && hasAdministratorRole() && state.billingProfile === null && !state.billingProfileLoading)
    void refreshBillingProfile({ announce: false });
}

let noticeSequence = 0;

function notificationMarkup() {
  const notice = state.notice;
  return notice ? `<div class="toast ${notice.kind}" role="${notice.kind === "error" ? "alert" : "status"}"><span>${escapeHtml(notice.message)}</span><button class="toast-dismiss" data-dismiss-notice aria-label="Dismiss notification">×</button></div>` : "";
}

function paintNotification() {
  const region = app.querySelector("#toast-region");
  if (!region) return;
  region.innerHTML = notificationMarkup();
  region.querySelector("[data-dismiss-notice]")?.addEventListener("click", () => { state.notice = null; paintNotification(); });
}

function notify(message, kind) {
  const id = ++noticeSequence;
  state.notice = { id, message: String(message), kind: kind === "error" ? "error" : "success" };
  paintNotification();
  // Errors stay visible until dismissed. Success timers cannot clear a newer notice.
  if (state.notice.kind === "success") window.setTimeout(() => {
    if (state.notice?.id === id) { state.notice = null; paintNotification(); }
  }, 7000);
}

function displayName() { return [state.accountProfile?.displayName,state.workspace?.me?.displayName,state.pirdyAccount?.displayName,state.account?.name,state.pirdyAccount?.email,state.account?.username].find(value=>typeof value==='string'&&value.trim()&&!/^(unknown|undefined|null)$/i.test(value.trim()))?.trim()??"Pirdy user"; }
function firstName() { return displayName().split(/\s+/)[0]; }
function initials() { return displayName().split(/\s+/).slice(0, 2).map(part => part[0]).join("").toUpperCase(); }

initialize();

